import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WebapiService } from '../webapi.service';
import moment from 'moment';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import * as XLSX from 'xlsx';
import { MultiKeyValueFilterPipe } from '../multi-key-value-filter.pipe';
import { RatebookmompopupComponent } from '../ratebookmompopup/ratebookmompopup.component';
import { ModalController } from '@ionic/angular';
import { PartnerdetailsComponent } from '../partnerdetails/partnerdetails.component';

@Component({
  selector: 'app-partnersourcing',
  templateUrl: './partnersourcing.component.html',
  styleUrls: ['./partnersourcing.component.scss'],
})
export class PartnersourcingComponent implements OnInit {
  selectedweek=''


  weekdata:any=[]
  weeklist:any=[]
  lanelist:any=[]
  selectedItems:any=[]
  //Filers list
  filers:any ={
    fiscal_year:[],
    fiscalmonth:[],
    fiscal_week:[],
    fiscal_quarter:[],
    fiscal_region_origin:[],
    fiscal_theater_origin:[],
    fiscal_airportcode_origin:[],
    fiscal_region_destination:[],
    fiscal_theater_destination:[],
    fiscal_airportcode_destination:[]
  }
  //filter selection object
  filterselection :any={
    fiscal_year:"",
    fiscal_quarter:"",
    fiscal_month:"",
    fiscal_week:"",
    theater_origin:"",
    theater_destination:"",
    region_origin:"",
    region_destination:"",
    airport_origin:"",
    airport_destination:"",
    monthweeklist:[],
    selectedlane:"HKG-AMS",
    date:[]


  }

  fw_q_bsa:any=[]
  fw_q:any;
  fw_o:any;

  //variables
  dropdownSettings:IDropdownSettings;
 
  dfRBook:any=[]
  graph_report_index=0;

  price_model_type='ATA'
  loading=true;

  total_filtered_spend=0
  lanelist_for_Servicelevel_spend:any=[]

  graph_report_list=["Actual Shipment Blended Rates vs Contractual Ratebook Price Model","Total Spend & Avg rate Drill Down View by Service Level, Lane and Partner","Total Spend and Avg Rate Drill Down View by Lane and Partner considering Over-Under Allocation Penalties"]
  


  month=['Aug','Sept','Oct','Nov','Dec','Jan','Feb','Mar',"Apr",'May','June','Jul']

   partner_d:any;
  lane_d:any;
  constructor(public router:Router,public service:WebapiService,public modalController:ModalController) {
    this.loading=false;

    this.check_current_week();
    this.get_filter_list();
    this.get_partner_sourcing_data_top_lane();
    this.getallratebook();
    this.get_partner_sourcing();
    this.get_weekly_prediction();

     
  }

  // check_current_week

  check_current_week(){
    this.today = moment();
    this.today_check = moment();
    this.startofweek=moment().startOf('week')
    this.endofweek=moment().endOf('week')
   }

  //  get fiscal and calender filters
  get_filter_list(){
    var  filter :any


    filter ={'startdate':this.endofweek.format('MM/DD/YYYY'),nweek:4,weeklist:[]}
    this.service.postData(filter, 'get_demand_sensing_filters').then((result) => {
      var res:any=result;
      this.fiscal_list=JSON.parse(res.fiscal_json);
      this.lane_region=JSON.parse(res.lane);
      
      this.get_distincttheator();
     });
}

  // top lane spend and volume
  toplane_spend:any=[];
  toplane_volume:any=[];
  get_partner_sourcing_data_top_lane(){
    this.service.postData({},"get_partner_sourcing_data_top_lane").then((result) => {

      var res:any=result;
      this.toplane_spend=JSON.parse(res.dfTop);
      this.toplane_volume=JSON.parse(res.dfTop50);


      
     });
  }

  Download_top_50_spend()
{
  let sampleJson: any = [];
  
  var datad=this.toplane_spend


  ////////console.log(week_allocation);
  const keysList = Object.keys(this.toplane_spend[0]);
  const data = this.toplane_spend.map((obj:any) => Object.values(obj));

  data.unshift(keysList);
  var workbook: XLSX.WorkBook = XLSX.utils.book_new();
  var worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);

  workbook.SheetNames.push("Top 50 Lane spend");
  workbook.Sheets["Top 50 Lane spend"] = worksheet;

  XLSX.writeFile(workbook,'Top Spend since past 6 months'+".xlsx");

  }
  toplaneoption=-1;

  Download_top_50_volume()
{
  let sampleJson: any = [];
  
  var datad=this.toplane_volume


  ////////console.log(week_allocation);
  const keysList = Object.keys(this.toplane_volume[0]);
  const data = this.toplane_volume.map((obj:any) => Object.values(obj));

  data.unshift(keysList);
  var workbook: XLSX.WorkBook   = XLSX.utils.book_new();
  var worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);

  workbook.SheetNames.push("Top 50 Lane volume");
  workbook.Sheets["Top 50 Lane volume"] = worksheet;

  XLSX.writeFile(workbook,'Top volume since past 6 months'+".xlsx");

  }
  // getpartner sourcing files
  // varibles to store related data
  weekly_avg_cost_model_lane:any=[]
  weekly_avg_cost_model:any=[]

  weekly_avg_cost_model_lane_bk:any=[]
  weekly_avg_cost_model_bk:any=[]
  ocean_data:any;
  projection_data:any;

  get_partner_sourcing(){
    this.service.postData({},"get_partner_sourcing_data_new_file").then((result) => {

      var res:any=result;

      this.weekly_avg_cost_model_lane_bk=JSON.parse(res.weekly_avg_cost_model_lane);
      this.weekly_avg_cost_model_bk=JSON.parse(res.weekly_avg_cost_model);
      this.ocean_data = JSON.parse(res.ocean_data);
      this.projection_data = JSON.parse(res.aggregated_projections);


      this.weekly_avg_cost_model_lane=JSON.parse(JSON.stringify(this.weekly_avg_cost_model_lane_bk));
      this.weekly_avg_cost_model=JSON.parse(JSON.stringify(this.weekly_avg_cost_model_bk));;

      // console.log(this.weekly_avg_cost_model_lane_bk);

      // this.partner_d=JSON.parse(result.merged_df);
      // this.lane_d=JSON.parse(result.lane_df);;
      this.fw_q= JSON.parse(result.weekly_download);
      this.fw_o= JSON.parse(result.weekly_download_over);

      this.fw_q_bsa= JSON.parse(result.weekly_download_bsa);

     
      var ctx=this;
    


  
      // on data function to initiae
      this.get_Distinct_fiscal_year();
      this.get_Distinct_lane();
      this.getdisctinctlane();
     this.get_Distinct_partner();
      this.m=0;
      this.get_months();
     
      this.loading=true;

   
     });

  }
  // subfunctions for filters

  get_Distinct_lane(){

    this.distinct_lane = this.weekly_avg_cost_model_lane
    .map((item:any) => item.Lane)
    .filter(
        (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
    );


  }

  partner_list:any=[]
  get_Distinct_partner(){

    this.partner_list = this.weekly_avg_cost_model
    .map((item:any) => item.PARTNER)
    .filter(
        (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
    );

    //////////console.log(this.distinct_lane)

  }

  getQuarterString(q:any) {
        if (!q || q < 1 || q > 12) return "Invalid month";
        var quarter_no = Math.floor((q - 1) / 3) + 1;
        var month_no = ((q - 1) % 3) + 1; // resets to 1-3 within each quarter
        return 'Q' + quarter_no + ' M' + month_no;
    };

  get_Distinct_fiscal_year(){

    this.filers.fiscal_year = this.weekly_avg_cost_model_lane_bk
    .map((item:any) => item.FY_year)
    .filter(
        (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
    );

    this.filers.fiscal_year = this.filers.fiscal_year.sort((a:any, b:any) => parseInt(a.split('FY')[1]) - parseInt(b.split('FY')[1]));

    console.log(this.filers.fiscal_year)

    this.filterselection.fiscal_year=this.filers.fiscal_year[this.filers.fiscal_year.length-1]
    this.filterselection.fiscal_quarter=""

    //get quarter on fiscal 
    this.get_quarter();

  }

  


  change_quarter(){
    this.get_month();
  }

  change_fiscal(){
    this. get_quarter();
    // this.filter_data();
  }

  get_quarter(){

    var ctx=this;
    
    var quarter=  this.weekly_avg_cost_model_lane_bk.filter((data:any)=>{
       return data.FY_year==ctx.filterselection.fiscal_year});
     //console.log(quarter)


    this.filers.fiscal_quarter=quarter.map((item:any) => item.cisco_FY_quarter)
    .filter(
        (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
    );

    this.filers.fiscal_quarter = this.filers.fiscal_quarter.sort((a:any, b:any) => parseInt(a.split('Q')[1]) - parseInt(b.split('Q')[1]));
    console.log(this.filers.fiscal_quarter)
    ctx.filterselection.fiscal_quarter=this.filers.fiscal_quarter[this.filers.fiscal_quarter.length-1];
    // this.filter_data();

    this.get_month();
  }
  get_month(){

    var ctx=this;
    if(ctx.filterselection.fiscal_quarter!='')
    {
    
    var month=  this.weekly_avg_cost_model_lane_bk.filter((data:any)=>{
       return data.FY_year==ctx.filterselection.fiscal_year && data.cisco_FY_quarter==ctx.filterselection.fiscal_quarter });

  //console.log(month) 

    this.filers.fiscalmonth = month.map((item:any) => item.cisco_FY_month_num)
    .filter(
        (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
    );

    var monthyer= month.map((item:any) => item.monthyear)
    .filter(
        (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
    );
 
    //console.log(this.filers.fiscalmonth)
 
  }
  else {
    var month=  this.weekly_avg_cost_model_lane_bk.filter((data:any)=>{
      return data.FY_year==ctx.filterselection.fiscal_year  });

   ////console.log(month) 

   this.filers.fiscalmonth = month.map((item:any) => item.cisco_FY_month_num)
   .filter(
       (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
   );

  var monthyer= month.map((item:any) => item.monthyear)
   .filter(
       (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
   );


  //  console.log(this.filers.fiscalmonth)

   ////console.log(monthyer)


  }

  this.filers.fiscalmonth = this.filers.fiscalmonth.sort((a:any, b:any) => a - b);

  this.filterselection.fiscal_month=this.filers.fiscalmonth[this.filers.fiscalmonth.length-1]
    ////console.log(this.filers.fiscalmonth)
    this.filter_data();

  }
  
  
  get_Distinct_month(){

    this.distinct_month = this.weekly_avg_cost_model_lane
    .map((item:any) => item.monthyear)
    .filter(
        (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
    );
  }



  //month over month tab



  //average caluclate function

  calculateavgrate(){

    var  filtered_lis=JSON.parse(JSON.stringify(this.ratebook_trend_filtered))
    var list= this.cleanArrayObjects(filtered_lis,['WAVG ATA'])
    
    list= this.removeDuplicatesByKeys(list,['smonthyear','Lane'])
    //console.log(list);

    var listavg=this.groupByMultipleAndAverage(list,['smonthyear'],['WAVG ATA'])
    this.wavg_list=listavg;
    return listavg;

  }

  calculateavgrate_partner(partner:any){
    var  filtered_lis=JSON.parse(JSON.stringify(this.ratebook_trend_filtered)).filter((res:any)=>{return res['Service Provider']== partner});
    var list= this.cleanArrayObjects(filtered_lis,['WAVG ATA'])
    
    list= this.removeDuplicatesByKeys(list,['smonthyear','Lane'])
    //console.log(list);

    var listavg=this.groupByMultipleAndAverage(list,['smonthyear','Service Provider'],['WAVG ATA'])
    this.wavg_list=listavg;

    return listavg;
  }
  
  // month over month trend chart 
  draw_month_over_trend(){

    var  benchmark_combined_chart = {
      chartType: 'LineChart',
      dataTable: [ /* Ensure this contains your combined data */ ],
      options: {
        chartArea: { width: '80%', height: '70%' },
        textPosition: 'none',
        tooltip: { isHtml: true }, // Enable HTML tooltips


        vAxes: {
          0: {
            title: '', // Title for the line chart axis
            gridlines: { color: 'transparent' },
          
            
          }
        },
       

        isStacked: true,
         legend:{ position: 'top', alignment: 'center' },

        hAxis: {
          gridlines: { color: 'transparent' }
        },
        height: 290,
        pointSize: 6,
     
      colors:[
        '#5dade2','#000',  // Original color
       
      ]
      }
    };

    if(this.selectedItems.length==0){
      this.ratebook_trend_filtered=this.ratebook_trend.filter((data:any) =>  this.distinctlane.indexOf(data.Lane)>=0);
   

     }else{
     

       this.ratebook_trend_filtered =  this.ratebook_trend.filter((data:any) =>  this.selectedItems.indexOf(data.Lane)>=0);
       

    }

  
    var datatable:any=[];
    var datatabledta_std:any=[];
    var datatable_iata:any=[];

    var datatabledtd_std:any=[];
    var datatableatd_std:any=[];
    
    var datatable_def:any=[];
    var datatable_def_iata:any=[];

    var datatabledta_def:any=[];
    var datatabledtd_def:any=[];
    var datatableatd_def:any=[];

    var datatable_exp:any=[];
    var datatable_exp_iata:any=[];

    var datatabledta_exp:any=[];
    var datatabledtd_exp:any=[];
    var datatableatd_exp:any=[];


    var rb = this.ratebook_trend_filtered.filter((res:any)=>{return res['STD PeakRate (=ATA+PS)']!=null });

    // avg of rates by month
    var price_model_Avg= this.groupByMultipleAndAverage(rb,["smonthyear"],['STD BaseRate (=ATA)', 'STD PeakRate (=ATA+PS)',
      'STD OverallocationRate (=ATA + OAC)', 'STD BaseRate (=ATD)',
      'STD PeakRate (=ATD+PS)', 'STD OverallocationRate (=ATD + OAC)',
      'STD BaseRate (=DTA)', 'STD PeakRate (=DTA+PS)',
      'STD OverallocationRate (=DTA + OAC)', 'STD BaseRate (=DTD)',
      'STD PeakRate (=DTD+PS)', 'STD OverallocationRate (=DTD + OAC)',
      'DEF BaseRate (=ATA)', 'DEF PeakRate (=ATA+PS)',
      'DEF OverallocationRate (=ATA + OAC)', 'DEF BaseRate (=ATD)',
      'DEF PeakRate (=ATD+PS)', 'DEF OverallocationRate (=ATD + OAC)',
      'DEF BaseRate (=DTA)', 'DEF PeakRate (=DTA+PS)',
      'DEF OverallocationRate (=DTA + OAC)', 'DEF BaseRate (=DTD)',
      'DEF PeakRate (=DTD+PS)', 'DEF OverallocationRate (=DTD + OAC)',
      'EXP BaseRate (=ATA)', 'EXP PeakRate (=ATA+PS)',
      'EXP OverallocationRate (=ATA + OAC)', 'EXP BaseRate (=ATD)',
      'EXP PeakRate (=ATD+PS)', 'EXP OverallocationRate (=ATD + OAC)',
      'EXP BaseRate (=DTA)', 'EXP PeakRate (=DTA+PS)',
      'EXP OverallocationRate (=DTA + OAC)', 'EXP BaseRate (=DTD)',
      'EXP PeakRate (=DTD+PS)', 'EXP OverallocationRate (=DTD + OAC)'
      ,'af_Total_STD','fsc_Total_STD','scr_Sur_Total_STD','sct_Sur_Total_STD','ow_Total_STD','ow_programm_Total_STD','ow_Scr_Total_STD','ow_security_Total_STD','pp_Total_STD','destinationmin_Total_STD','dw_programm_Total_STD','dw_Scr_Total_STD','dw_security_Total_STD','dlpw_Total_STD','pss_Total_STD','af_Total_DEF','fsc_Total_DEF','scr_Sur_Total_DEF','sct_Sur_Total_DEF','ow_Total_DEF','ow_programm_Total_DEF','ow_Scr_Total_DEF','ow_security_Total_DEF','pp_Total_DEF','destinationmin_Total_DEF','dw_programm_Total_DEF','dw_Scr_Total_DEF','dw_security_Total_DEF','dlpw_Total_DEF','pss_Total_DEF','af_Total_EXP','fsc_Total_EXP','scr_Sur_Total_EXP','sct_Sur_Total_EXP','ow_Total_EXP','ow_programm_Total_EXP','ow_Scr_Total_EXP','ow_security_Total_EXP','pp_Total_EXP','destinationmin_Total_EXP','dw_programm_Total_EXP','dw_Scr_Total_EXP','dw_security_Total_EXP','dlpw_Total_EXP','pss_Total_EXP',
      'BaseCapacity (=Available Non Peak Capacity/KG)','WAVG ATA']);

    //  avg of rates by partner and onth
    var price_model_Avg_partner= this.groupByMultipleAndAverage(rb,["smonthyear","Service Provider"],['STD BaseRate (=ATA)', 'STD PeakRate (=ATA+PS)',
        'STD OverallocationRate (=ATA + OAC)', 'STD BaseRate (=ATD)',
        'STD PeakRate (=ATD+PS)', 'STD OverallocationRate (=ATD + OAC)',
        'STD BaseRate (=DTA)', 'STD PeakRate (=DTA+PS)',
        'STD OverallocationRate (=DTA + OAC)', 'STD BaseRate (=DTD)',
        'STD PeakRate (=DTD+PS)', 'STD OverallocationRate (=DTD + OAC)',
        'DEF BaseRate (=ATA)', 'DEF PeakRate (=ATA+PS)',
        'DEF OverallocationRate (=ATA + OAC)', 'DEF BaseRate (=ATD)',
        'DEF PeakRate (=ATD+PS)', 'DEF OverallocationRate (=ATD + OAC)',
        'DEF BaseRate (=DTA)', 'DEF PeakRate (=DTA+PS)',
        'DEF OverallocationRate (=DTA + OAC)', 'DEF BaseRate (=DTD)',
        'DEF PeakRate (=DTD+PS)', 'DEF OverallocationRate (=DTD + OAC)',
        'EXP BaseRate (=ATA)', 'EXP PeakRate (=ATA+PS)',
        'EXP OverallocationRate (=ATA + OAC)', 'EXP BaseRate (=ATD)',
        'EXP PeakRate (=ATD+PS)', 'EXP OverallocationRate (=ATD + OAC)',
        'EXP BaseRate (=DTA)', 'EXP PeakRate (=DTA+PS)',
        'EXP OverallocationRate (=DTA + OAC)', 'EXP BaseRate (=DTD)',
        'EXP PeakRate (=DTD+PS)', 'EXP OverallocationRate (=DTD + OAC)'
        ,'af_Total_STD','fsc_Total_STD','scr_Sur_Total_STD','sct_Sur_Total_STD','ow_Total_STD','ow_programm_Total_STD','ow_Scr_Total_STD','ow_security_Total_STD','pp_Total_STD','destinationmin_Total_STD','dw_programm_Total_STD','dw_Scr_Total_STD','dw_security_Total_STD','dlpw_Total_STD','pss_Total_STD','af_Total_DEF','fsc_Total_DEF','scr_Sur_Total_DEF','sct_Sur_Total_DEF','ow_Total_DEF','ow_programm_Total_DEF','ow_Scr_Total_DEF','ow_security_Total_DEF','pp_Total_DEF','destinationmin_Total_DEF','dw_programm_Total_DEF','dw_Scr_Total_DEF','dw_security_Total_DEF','dlpw_Total_DEF','pss_Total_DEF','af_Total_EXP','fsc_Total_EXP','scr_Sur_Total_EXP','sct_Sur_Total_EXP','ow_Total_EXP','ow_programm_Total_EXP','ow_Scr_Total_EXP','ow_security_Total_EXP','pp_Total_EXP','destinationmin_Total_EXP','dw_programm_Total_EXP','dw_Scr_Total_EXP','dw_security_Total_EXP','dlpw_Total_EXP','pss_Total_EXP',
        'BaseCapacity (=Available Non Peak Capacity/KG)','WAVG ATA']);
    
      this.wavg_list=  this.calculateavgrate();
      datatable.push(["Month","STD ATA",{ role: 'tooltip', p: { html: true } }])
      datatable_iata.push(["Month","STD ATA",{ role: 'tooltip', p: { html: true } },"WAVG ATA"])

      datatableatd_std.push(["Month","STD ATD",{ role: 'tooltip', p: { html: true } }])
      datatabledtd_std.push(["Month","STD DTD",{ role: 'tooltip', p: { html: true } }])
      datatabledta_std.push(["Month","STD DTA",{ role: 'tooltip', p: { html: true } }])

      datatable_exp.push(["Month","EXP ATA",{ role: 'tooltip', p: { html: true } }])
      datatable_exp_iata.push(["Month","EXP ATA",{ role: 'tooltip', p: { html: true } },"WAVG ATA"])
      datatableatd_exp.push(["Month","EXP ATD",{ role: 'tooltip', p: { html: true } }])
      datatabledtd_exp.push(["Month","EXP DTD",{ role: 'tooltip', p: { html: true } }])
      datatabledta_exp.push(["Month","EXP DTA",{ role: 'tooltip', p: { html: true } }])

      datatable_def.push(["Month","DEF ATA",{ role: 'tooltip', p: { html: true } }])
      datatable_def_iata.push(["Month","DEF ATA",{ role: 'tooltip', p: { html: true } },"WAVG ATA"])
      datatableatd_def.push(["Month","DEF ATD",{ role: 'tooltip', p: { html: true } }])
      datatabledtd_def.push(["Month","DEF DTD",{ role: 'tooltip', p: { html: true } }])
      datatabledta_def.push(["Month","DEF DTA",{ role: 'tooltip', p: { html: true } }])

    var distinc_partner_chart= price_model_Avg_partner
    .map((item:any) => item['Service Provider'])
    .filter(
        (value, index, current_value) => current_value.indexOf(value) === index
    );
    this.distinc_partner_chart=distinc_partner_chart;
    
    var list=price_model_Avg;
    if(this.graph_page_partner==-1)
    {
      list=price_model_Avg;
    }
    else
    {
      list=price_model_Avg_partner.filter((res:any)=>{return res['Service Provider']== this.distinc_partner_chart[this.graph_page_partner]});
      this.wavg_list=  this.calculateavgrate_partner(distinc_partner_chart[this.graph_page_partner])

    }
    
    this.momlist=list;
    list=list.sort((a:any, b:any) =>  {
      const [monthA, yearA] = a['smonthyear'].split('-').map(Number);
      const [monthB, yearB] = b['smonthyear'].split('-').map(Number);
    
      // Compare year first, then month
      if (yearA !== yearB) {
        return yearA - yearB;
      } else {
        return monthA - monthB;
      }
    });
    this.wavg_list= this.wavg_list.sort((a:any, b:any) =>  {
      const [monthA, yearA] = a['smonthyear'].split('-').map(Number);
      const [monthB, yearB] = b['smonthyear'].split('-').map(Number);
    
      // Compare year first, then month
      if (yearA !== yearB) {
        return yearA - yearB;
      } else {
        return monthA - monthB;
      }
    });

    var i=0;
   
    if(list.length>12)
      {
        list = list.slice(list.length-12,list.length);
      }
      console.log(list);

    list.forEach((element:any) => {
      var prevel:any;
      if(i>0)
      {
         prevel=list[i-1];
      }else{
         prevel=list[i];
      }
       //console.log(this.wavg_list)
      
      var benchmark=null;
      // if(i< this.wavg_list.length)
       var benchmarklist= this.wavg_list.filter((res:any)=>{return res.smonthyear==element['smonthyear']}) ;
      if(benchmarklist.length>0)
         benchmark=benchmarklist[0]['WAVG ATA']

      datatable_iata.push([element['smonthyear'],element['STD PeakRate (=ATA+PS)'],this.tooltipHtml(element,prevel,'STD','ATA'),benchmark])
      datatable.push([element['smonthyear'],element['STD PeakRate (=ATA+PS)'],this.tooltipHtml(element,prevel,'STD','ATA')])

      datatableatd_std.push([element['smonthyear'],element['STD PeakRate (=ATD+PS)'],this.tooltipHtml(element,prevel,'STD','ATD')])
      datatabledtd_std.push([element['smonthyear'],element['STD PeakRate (=DTD+PS)'],this.tooltipHtml(element,prevel,'STD','DTD')])
      datatabledta_std.push([element['smonthyear'],element['STD PeakRate (=DTA+PS)'],this.tooltipHtml(element,prevel,'STD','DTA')])

      datatable_def_iata.push([element['smonthyear'],element['DEF PeakRate (=ATA+PS)'],this.tooltipHtml(element,prevel,'DEF','ATA'),benchmark])
      datatable_def.push([element['smonthyear'],element['DEF PeakRate (=ATA+PS)'],this.tooltipHtml(element,prevel,'DEF','ATA')])
      datatableatd_def.push([element['smonthyear'],element['DEF PeakRate (=ATD+PS)'],this.tooltipHtml(element,prevel,'DEF','ATD')])
      datatabledtd_def.push([element['smonthyear'],element['DEF PeakRate (=DTD+PS)'],this.tooltipHtml(element,prevel,'DEF','DTD')])
      datatabledta_def.push([element['smonthyear'],element['DEF PeakRate (=DTA+PS)'],this.tooltipHtml(element,prevel,'DEF','DTA')])


      datatable_exp.push([element['smonthyear'],element['EXP PeakRate (=ATA+PS)'],this.tooltipHtml(element,prevel,'EXP','ATA')])
      datatable_exp_iata.push([element['smonthyear'],element['EXP PeakRate (=ATA+PS)'],this.tooltipHtml(element,prevel,'EXP','ATA'),benchmark])

      datatableatd_exp.push([element['smonthyear'],element['EXP PeakRate (=ATD+PS)'],this.tooltipHtml(element,prevel,'EXP','ATD')])
      datatabledtd_exp.push([element['smonthyear'],element['EXP PeakRate (=DTD+PS)'],this.tooltipHtml(element,prevel,'EXP','DTD')])
      datatabledta_exp.push([element['smonthyear'],element['EXP PeakRate (=DTA+PS)'],this.tooltipHtml(element,prevel,'EXP','DTA')])
      
      i=i+1;

    });

    benchmark_combined_chart.dataTable=datatable;
    var c=0;
    datatable_iata.slice(1,datatable_iata.length-1).forEach((element:any) => {
    
      //console.log(element[3]);
       if(element[3]!=null)
         c=c+1;

    });

    //console.log(c);

    if(c==0)
      {
        datatable_iata=[["Month","STD ATA",{ role: 'tooltip', p: { html: true } },"WAVG ATA"]]
        datatable_exp_iata=[["Month","EXP ATA",{ role: 'tooltip', p: { html: true } },"WAVG ATA"]]
        datatable_def_iata=[["Month","DEF ATA",{ role: 'tooltip', p: { html: true } },"WAVG ATA"]]

      }
      //console.log(this.wavg_list);

    var std_ata=JSON.parse(JSON.stringify(benchmark_combined_chart));
    benchmark_combined_chart.dataTable=datatable_iata;
    var std_ata_iata=JSON.parse(JSON.stringify(benchmark_combined_chart));
    
    benchmark_combined_chart.dataTable=datatabledta_std;
    var std_dta=JSON.parse(JSON.stringify(benchmark_combined_chart));
    benchmark_combined_chart.dataTable=datatabledtd_std;
    var std_dtd=JSON.parse(JSON.stringify(benchmark_combined_chart));
    benchmark_combined_chart.dataTable=datatableatd_std;
    var std_atd=JSON.parse(JSON.stringify(benchmark_combined_chart));

    benchmark_combined_chart.dataTable=datatable_exp;
    var exp_ata=JSON.parse(JSON.stringify(benchmark_combined_chart));

    benchmark_combined_chart.dataTable=datatable_exp_iata;
    var exp_ata_iata=JSON.parse(JSON.stringify(benchmark_combined_chart));

    benchmark_combined_chart.dataTable=datatabledta_exp;
    var exp_dta=JSON.parse(JSON.stringify(benchmark_combined_chart));
    benchmark_combined_chart.dataTable=datatabledtd_exp;
    var exp_dtd=JSON.parse(JSON.stringify(benchmark_combined_chart));
    benchmark_combined_chart.dataTable=datatableatd_exp;
    var exp_atd=JSON.parse(JSON.stringify(benchmark_combined_chart));

    benchmark_combined_chart.dataTable=datatable_def;
    var def_ata=JSON.parse(JSON.stringify(benchmark_combined_chart));

    benchmark_combined_chart.dataTable=datatable_def_iata;
    var def_ata_iata=JSON.parse(JSON.stringify(benchmark_combined_chart));

    benchmark_combined_chart.dataTable=datatabledta_def;
    var def_dta=JSON.parse(JSON.stringify(benchmark_combined_chart));
    benchmark_combined_chart.dataTable=datatabledtd_def;
    var def_dtd=JSON.parse(JSON.stringify(benchmark_combined_chart));
    benchmark_combined_chart.dataTable=datatableatd_def;
    var def_atd=JSON.parse(JSON.stringify(benchmark_combined_chart));

    this.ratebook_trend_graph= {std_ata:std_ata,std_ata_iata:std_ata_iata,std_dta:std_dta,std_dtd:std_dtd,std_atd:std_atd,def_ata:def_ata,def_ata_iata:def_ata_iata,def_atd:def_atd,def_dta:def_dta,def_dtd:def_dtd,exp_dta:exp_dta,exp_ata_iata:exp_ata_iata,exp_ata:exp_ata,exp_dtd:exp_dtd,exp_atd:exp_atd}


   
  console.log(this.ratebook_trend_graph);


  }

  filter_ratebook_Data(data:any, laneList:any, partnerList:any) {
  return data.filter((item:any) => {
    const laneMatch = laneList.length === 0 || laneList.includes(item.lane);
    const partnerMatch = partnerList.length === 0 || partnerList.includes(item['Service Provider']);
    return laneMatch && partnerMatch;
  });
}

  draw_month_over_trend_new(){

    var  benchmark_combined_chart = {
      chartType: 'LineChart',
      dataTable: [ /* Ensure this contains your combined data */ ],
      options: {
        chartArea: { width: '80%', height: '70%' },
        textPosition: 'none',
        tooltip: { isHtml: true }, // Enable HTML tooltips


        vAxes: {
          0: {
            title: '', // Title for the line chart axis
            gridlines: { color: 'transparent' },
          
            
          }
        },
       

        isStacked: true,
         legend:{ position: 'top', alignment: 'center' },

        hAxis: {
          gridlines: { color: 'transparent' }
        },
        height: 290,
        pointSize: 6,
     
      colors:[
        '#5dade2','#FAA048','#000',  // Original color
       
      ]
      }
    };

 

    // //console.log(this.ratebook_trend_filtered);
  
    var datatable:any=[];
    var datatabledta_std:any=[];
    var datatable_iata:any=[];

    var datatabledtd_std:any=[];
    var datatableatd_std:any=[];
    
    var datatable_def:any=[];
    var datatable_def_iata:any=[];

    var datatabledta_def:any=[];
    var datatabledtd_def:any=[];
    var datatableatd_def:any=[];

    var datatable_exp:any=[];
    var datatable_exp_iata:any=[];

    var datatabledta_exp:any=[];
    var datatabledtd_exp:any=[];
    var datatableatd_exp:any=[];

    //console.log(this.ratebook_trend)

    //console.log(this.selectedItems,this.selected_partners);

    var list=this.momlist=this.filter_ratebook_Data(this.ratebook_trend,this.selectedItems,this.selected_partners);

    var dlane=  list
    .map((item:any) => item.lane)
    .filter(
        (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
    );
    var listwavg=this.filter_ratebook_Data(this.ratebook_trend,this.selectedItems,[]);

    this.ratebook_trend_filtered=JSON.parse(JSON.stringify(list));
        // //console.log(list)

    

    //  list.forEach(obj => {
    //     obj["WAVG ATA EXP_count"] = obj["WAVG ATA_count"];
    //     obj["WAVG ATA DEF_count"] = obj["WAVG ATA_count"];
    //   });
     listwavg= this.groupByMultipleAndAverage_new(listwavg,["smonthyear",'lane'],['WAVG ATA','WAVG ATA DEF','WAVG ATA EXP']);

     
    listwavg = this.filter_ratebook_Data(listwavg,dlane,[]);


         listwavg= this.groupByMultipleAndAverage_new(listwavg,["smonthyear"],['WAVG ATA','WAVG ATA DEF','WAVG ATA EXP']);

     list= this.groupByMultipleAndWeightedAverage_new(list,["smonthyear"],['STD BaseRate (=ATA)', 'STD PeakRate (=ATA+PS)',
      'STD OverallocationRate (=ATA + OAC)', 'STD BaseRate (=ATD)',
      'STD PeakRate (=ATD+PS)', 'STD OverallocationRate (=ATD + OAC)',
      'STD BaseRate (=DTA)', 'STD PeakRate (=DTA+PS)',
      'STD OverallocationRate (=DTA + OAC)', 'STD BaseRate (=DTD)',
      'STD PeakRate (=DTD+PS)', 'STD OverallocationRate (=DTD + OAC)',
      'DEF BaseRate (=ATA)', 'DEF PeakRate (=ATA+PS)',
      'DEF OverallocationRate (=ATA + OAC)', 'DEF BaseRate (=ATD)',
      'DEF PeakRate (=ATD+PS)', 'DEF OverallocationRate (=ATD + OAC)',
      'DEF BaseRate (=DTA)', 'DEF PeakRate (=DTA+PS)',
      'DEF OverallocationRate (=DTA + OAC)', 'DEF BaseRate (=DTD)',
      'DEF PeakRate (=DTD+PS)', 'DEF OverallocationRate (=DTD + OAC)',
      'EXP BaseRate (=ATA)', 'EXP PeakRate (=ATA+PS)',
      'EXP OverallocationRate (=ATA + OAC)', 'EXP BaseRate (=ATD)',
      'EXP PeakRate (=ATD+PS)', 'EXP OverallocationRate (=ATD + OAC)',
      'EXP BaseRate (=DTA)', 'EXP PeakRate (=DTA+PS)',
      'EXP OverallocationRate (=DTA + OAC)', 'EXP BaseRate (=DTD)',
      'EXP PeakRate (=DTD+PS)', 'EXP OverallocationRate (=DTD + OAC)'
      ,'af_Total_STD','fsc_Total_STD','scr_Sur_Total_STD','sct_Sur_Total_STD','ow_Total_STD','ow_programm_Total_STD','ow_Scr_Total_STD','ow_security_Total_STD','pp_Total_STD','destinationmin_Total_STD','dw_programm_Total_STD','dw_Scr_Total_STD','dw_security_Total_STD','dlpw_Total_STD','pss_Total_STD','af_Total_DEF','fsc_Total_DEF','scr_Sur_Total_DEF','sct_Sur_Total_DEF','ow_Total_DEF','ow_programm_Total_DEF','ow_Scr_Total_DEF','ow_security_Total_DEF','pp_Total_DEF','destinationmin_Total_DEF','dw_programm_Total_DEF','dw_Scr_Total_DEF','dw_security_Total_DEF','dlpw_Total_DEF','pss_Total_DEF','af_Total_EXP','fsc_Total_EXP','scr_Sur_Total_EXP','sct_Sur_Total_EXP','ow_Total_EXP','ow_programm_Total_EXP','ow_Scr_Total_EXP','ow_security_Total_EXP','pp_Total_EXP','destinationmin_Total_EXP','dw_programm_Total_EXP','dw_Scr_Total_EXP','dw_security_Total_EXP','dlpw_Total_EXP','pss_Total_EXP',
      'BaseCapacity (=Available Non Peak Capacity/KG)']);

    // //console.log(rbl.length); 


        
        
        
      // this.wavg_list=  this.calculateavgrate();
      datatable.push(["Month","STD ATA",{ role: 'tooltip', p: { html: true } }])
      datatable_iata.push(["Month","STD ATA",{ role: 'tooltip', p: { html: true } },"Fuel SC","IATA WAVG ATA STD"])

      datatableatd_std.push(["Month","STD ATD",{ role: 'tooltip', p: { html: true } }])
      datatabledtd_std.push(["Month","STD DTD",{ role: 'tooltip', p: { html: true } }])
      datatabledta_std.push(["Month","STD DTA",{ role: 'tooltip', p: { html: true } }])

      datatable_exp.push(["Month","EXP ATA",{ role: 'tooltip', p: { html: true } }])
      datatable_exp_iata.push(["Month","EXP ATA",{ role: 'tooltip', p: { html: true } },"Fuel SC","IATA WAVG ATA EXP"])
      datatableatd_exp.push(["Month","EXP ATD",{ role: 'tooltip', p: { html: true } }])
      datatabledtd_exp.push(["Month","EXP DTD",{ role: 'tooltip', p: { html: true } }])
      datatabledta_exp.push(["Month","EXP DTA",{ role: 'tooltip', p: { html: true } }])

      datatable_def.push(["Month","DEF ATA",{ role: 'tooltip', p: { html: true } }])
      datatable_def_iata.push(["Month","DEF ATA",{ role: 'tooltip', p: { html: true } },"Fuel SC","IATA WAVG ATA DEF"])
      datatableatd_def.push(["Month","DEF ATD",{ role: 'tooltip', p: { html: true } }])
      datatabledtd_def.push(["Month","DEF DTD",{ role: 'tooltip', p: { html: true } }])
      datatabledta_def.push(["Month","DEF DTA",{ role: 'tooltip', p: { html: true } }])

   
    
  //  //console.log( this.wavg_list);


    //list=this.momlist=this.ratebook_trend;
    list=list.sort((a:any, b:any) =>  {
      const [monthA, yearA] = a['smonthyear'].split('-').map(Number);
      const [monthB, yearB] = b['smonthyear'].split('-').map(Number);
    
      // Compare year first, then month
      if (yearA !== yearB) {
        return yearA - yearB;
      } else {
        return monthA - monthB;
      }
    });

   

    var i=0;
    ////console.log( this.wavg_list);

    //console.log(list);

   
    list.forEach((element:any )=> {
      var prevel:any;
      if(i>0)
      {
         prevel=list[i-1];
      }else{
         prevel=list[i];
      }
       //console.log(this.wavg_list)
      
      var benchmark=null;
      var benchmarkexp=null;
      var benchmarkdef=null;

       var obj =listwavg.filter((res:any)=> {return res.smonthyear ==element.smonthyear})[0]
           benchmark=element['WAVG ATA']=obj['WAVG ATA']
           benchmarkexp=element['WAVG ATA EXP']=obj['WAVG ATA EXP']
           benchmarkdef=element['WAVG ATA DEF']=obj['WAVG ATA DEF']
         

      datatable_iata.push([element['smonthyear'],element['STD PeakRate (=ATA+PS)'],this.tooltipHtml(element,prevel,'STD','ATA'),element['fsc_Total_STD'],benchmark])
      datatable.push([element['smonthyear'],element['STD PeakRate (=ATA+PS)'],this.tooltipHtml(element,prevel,'STD','ATA')])

      datatableatd_std.push([element['smonthyear'],element['STD PeakRate (=ATD+PS)'],this.tooltipHtml(element,prevel,'STD','ATD')])
      datatabledtd_std.push([element['smonthyear'],element['STD PeakRate (=DTD+PS)'],this.tooltipHtml(element,prevel,'STD','DTD')])
      datatabledta_std.push([element['smonthyear'],element['STD PeakRate (=DTA+PS)'],this.tooltipHtml(element,prevel,'STD','DTA')])

      datatable_def_iata.push([element['smonthyear'],element['DEF PeakRate (=ATA+PS)'],this.tooltipHtml(element,prevel,'DEF','ATA'),element['fsc_Total_DEF'],benchmarkdef])
      datatable_def.push([element['smonthyear'],element['DEF PeakRate (=ATA+PS)'],this.tooltipHtml(element,prevel,'DEF','ATA')])
      datatableatd_def.push([element['smonthyear'],element['DEF PeakRate (=ATD+PS)'],this.tooltipHtml(element,prevel,'DEF','ATD')])
      datatabledtd_def.push([element['smonthyear'],element['DEF PeakRate (=DTD+PS)'],this.tooltipHtml(element,prevel,'DEF','DTD')])
      datatabledta_def.push([element['smonthyear'],element['DEF PeakRate (=DTA+PS)'],this.tooltipHtml(element,prevel,'DEF','DTA')])


      datatable_exp.push([element['smonthyear'],element['EXP PeakRate (=ATA+PS)'],this.tooltipHtml(element,prevel,'EXP','ATA')])
      datatable_exp_iata.push([element['smonthyear'],element['EXP PeakRate (=ATA+PS)'],this.tooltipHtml(element,prevel,'EXP','ATA'),element['fsc_Total_EXP'],benchmarkexp])

      datatableatd_exp.push([element['smonthyear'],element['EXP PeakRate (=ATD+PS)'],this.tooltipHtml(element,prevel,'EXP','ATD')])
      datatabledtd_exp.push([element['smonthyear'],element['EXP PeakRate (=DTD+PS)'],this.tooltipHtml(element,prevel,'EXP','DTD')])
      datatabledta_exp.push([element['smonthyear'],element['EXP PeakRate (=DTA+PS)'],this.tooltipHtml(element,prevel,'EXP','DTA')])
      
      i=i+1;

    });
    ////console.log(datatable_iata)

    benchmark_combined_chart.dataTable=datatable;
    var c=0;
    datatable_iata.slice(1,datatable_iata.length-1).forEach((element:any) => {
    
      ////console.log(element[3]);
       if(element[3]!=null)
         c=c+1;

    });

    ////console.log(c);

    if(c==0)
      {
        datatable_iata=[["Month","STD ATA",{ role: 'tooltip', p: { html: true } },"Fuel SC","IATA WAVG ATA STD"]]
        datatable_exp_iata=[["Month","EXP ATA",{ role: 'tooltip', p: { html: true } },"Fuel SC","IATA WAVG ATA EXP"]]
        datatable_def_iata=[["Month","DEF ATA",{ role: 'tooltip', p: { html: true } },"Fuel SC","IATA WAVG ATA DEF"]]

      }
      ////console.log(this.wavg_list);

    var std_ata=JSON.parse(JSON.stringify(benchmark_combined_chart));
    benchmark_combined_chart.dataTable=datatable_iata;
    var std_ata_iata=JSON.parse(JSON.stringify(benchmark_combined_chart));
    
    benchmark_combined_chart.dataTable=datatabledta_std;
    var std_dta=JSON.parse(JSON.stringify(benchmark_combined_chart));
    benchmark_combined_chart.dataTable=datatabledtd_std;
    var std_dtd=JSON.parse(JSON.stringify(benchmark_combined_chart));
    benchmark_combined_chart.dataTable=datatableatd_std;
    var std_atd=JSON.parse(JSON.stringify(benchmark_combined_chart));

    benchmark_combined_chart.dataTable=datatable_exp;
    var exp_ata=JSON.parse(JSON.stringify(benchmark_combined_chart));

    benchmark_combined_chart.dataTable=datatable_exp_iata;
    var exp_ata_iata=JSON.parse(JSON.stringify(benchmark_combined_chart));

    benchmark_combined_chart.dataTable=datatabledta_exp;
    var exp_dta=JSON.parse(JSON.stringify(benchmark_combined_chart));
    benchmark_combined_chart.dataTable=datatabledtd_exp;
    var exp_dtd=JSON.parse(JSON.stringify(benchmark_combined_chart));
    benchmark_combined_chart.dataTable=datatableatd_exp;
    var exp_atd=JSON.parse(JSON.stringify(benchmark_combined_chart));

    benchmark_combined_chart.dataTable=datatable_def;
    var def_ata=JSON.parse(JSON.stringify(benchmark_combined_chart));

    benchmark_combined_chart.dataTable=datatable_def_iata;
    var def_ata_iata=JSON.parse(JSON.stringify(benchmark_combined_chart));

    benchmark_combined_chart.dataTable=datatabledta_def;
    var def_dta=JSON.parse(JSON.stringify(benchmark_combined_chart));
    benchmark_combined_chart.dataTable=datatabledtd_def;
    var def_dtd=JSON.parse(JSON.stringify(benchmark_combined_chart));
    benchmark_combined_chart.dataTable=datatableatd_def;
    var def_atd=JSON.parse(JSON.stringify(benchmark_combined_chart));

    this.ratebook_trend_graph= {std_ata:std_ata,std_ata_iata:std_ata_iata,std_dta:std_dta,std_dtd:std_dtd,std_atd:std_atd,def_ata:def_ata,def_ata_iata:def_ata_iata,def_atd:def_atd,def_dta:def_dta,def_dtd:def_dtd,exp_dta:exp_dta,exp_ata_iata:exp_ata_iata,exp_ata:exp_ata,exp_dtd:exp_dtd,exp_atd:exp_atd}


   
    console.log(this.ratebook_trend_graph);


  }
  

  ratebook_trend_graph_wiata:any;
  ratebook_trend_filtered_wata:any=[]
   ratebook_trend_wiata:any=[]
 monthslist_ratebook:any=[]
  monthslist_ratebook_wiata:any=[]

  mom_ldr=false;
  
  months:any=[]
  months_wata:any=[]
  m=0;
  m_wata=0;
  get_months(){

        this.service.postData({},"get_month_over_month_ratebook_month").then((result) => {


           console.log(result);
           result.data.forEach((element:any) => {

            this.months.push(element)
            
           });
           result.iata.forEach((element:any) => {

            this.months_wata.push(element)
            
           });
           console.log(this.months);

                      console.log(this.months_wata);
                      this.monthslist= this.months_wata
            ////console.log(this.monthslist);
            this.selected_month=this.monthslist[0];
            this.getratebook(this.monthslist[0].split('-')[0],this.monthslist[0].split('-')[1]);

           this.get_month_over_month();
           this.get_month_over_month_ratebook_wiata();

        });
  }
  get_month_over_month(){

    this.mom_ldr=true;
    this.service.postData({month:this.months[this.m]},"get_month_over_month_ratebook").then((result) => {

      var res:any=result;
      
      this.ratebook_trend.push(...JSON.parse(res.data));
      // this.ratebook_trendl=JSON.parse(res.datal);

      //console.log(this.ratebook_trendl);

      
     
      //console.log(this.monthslist_ratebook);
      ////console.log(this.monthslist);

      // m=m+1;
      this.m=this.m+1;
      if(this.m==this.months.length)
       {
         this.monthslist_ratebook=this.ratebook_trend.map((item:any) => item['monthyear'])
        .filter(
            (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
        );

        this.draw_month_over_trend_new();
          this.mom_ldr=false;


       }else
       {
        this.get_month_over_month();

       }
     



     });
  }
  mom_ldr_wata=false;
  get_month_over_month_ratebook_wiata(){

    this.mom_ldr_wata=true;
    this.service.postData({month:this.months_wata[this.m_wata]},"get_month_over_month_ratebook_wiata").then((result) => {

      var res:any=result;
      
      this.ratebook_trend_wiata.push(...JSON.parse(res.data));
      
      this.m_wata=this.m_wata+1;
      if(this.m_wata==this.months_wata.length)
       {
         this.monthslist_ratebook_wiata=this.ratebook_trend_wiata.map((item:any) => item['monthyear'])
        .filter(
            (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
        );

          this.draw_month_over_trend_new_without();
          this.mom_ldr_wata=false;


       }else
       {
         this.get_month_over_month_ratebook_wiata();

       }
     



     });
  }
  ratebook_trend_filtered:any=[]
  ratebook_trend_filtered_lane:any=[]

  ratebook_trend_graph:any;

  draw_month_over_trend_new_without(){

    var  benchmark_combined_chart = {
      chartType: 'LineChart',
      dataTable: [ /* Ensure this contains your combined data */ ],
      options: {
        chartArea: { width: '80%', height: '70%' },
        textPosition: 'none',
        tooltip: { isHtml: true }, // Enable HTML tooltips


        vAxes: {
          0: {
            title: '', // Title for the line chart axis
            gridlines: { color: 'transparent' },
          
            
          }
        },
       

        isStacked: true,
         legend:{ position: 'top', alignment: 'center' },

        hAxis: {
          gridlines: { color: 'transparent' }
        },
        height: 290,
        pointSize: 6,
     
      colors:[
        '#5dade2','#000',  // Original color
       
      ]
      }
    };

 

    // //console.log(this.ratebook_trend_filtered);
  
    var datatable:any=[];
    var datatabledta_std:any=[];
    var datatable_iata:any=[];

    var datatabledtd_std:any=[];
    var datatableatd_std:any=[];
    
    var datatable_def:any=[];
    var datatable_def_iata:any=[];

    var datatabledta_def:any=[];
    var datatabledtd_def:any=[];
    var datatableatd_def:any=[];

    var datatable_exp:any=[];
    var datatable_exp_iata:any=[];

    var datatabledta_exp:any=[];
    var datatabledtd_exp:any=[];
    var datatableatd_exp:any=[];

    //console.log(this.ratebook_trend)

    //console.log(this.selectedItems,this.selected_partners);

    var list=this.momlist=this.filter_ratebook_Data(this.ratebook_trend_wiata,this.selectedItems,this.selected_partners);

    var dlane=  list
    .map((item:any) => item.lane)
    .filter(
        (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
    );
    // var listwavg=this.filter_ratebook_Data(this.ratebook_trend_wiata,this.selectedItems,[]);

     this.ratebook_trend_filtered_wata=JSON.parse(JSON.stringify(list));
        // //console.log(list)

    

    //  list.forEach(obj => {
    //     obj["WAVG ATA EXP_count"] = obj["WAVG ATA_count"];
    //     obj["WAVG ATA DEF_count"] = obj["WAVG ATA_count"];
    //   });
    //  listwavg= this.groupByMultipleAndAverage_new(listwavg,["smonthyear",'lane'],['WAVG ATA','WAVG ATA DEF','WAVG ATA EXP']);

     
    // listwavg = this.filter_ratebook_Data(listwavg,dlane,[]);


        //  listwavg= this.groupByMultipleAndAverage_new(listwavg,["smonthyear"],['WAVG ATA','WAVG ATA DEF','WAVG ATA EXP']);

     list= this.groupByMultipleAndWeightedAverage_new(list,["smonthyear"],['STD BaseRate (=ATA)', 'STD PeakRate (=ATA+PS)',
      'STD OverallocationRate (=ATA + OAC)', 'STD BaseRate (=ATD)',
      'STD PeakRate (=ATD+PS)', 'STD OverallocationRate (=ATD + OAC)',
      'STD BaseRate (=DTA)', 'STD PeakRate (=DTA+PS)',
      'STD OverallocationRate (=DTA + OAC)', 'STD BaseRate (=DTD)',
      'STD PeakRate (=DTD+PS)', 'STD OverallocationRate (=DTD + OAC)',
      'DEF BaseRate (=ATA)', 'DEF PeakRate (=ATA+PS)',
      'DEF OverallocationRate (=ATA + OAC)', 'DEF BaseRate (=ATD)',
      'DEF PeakRate (=ATD+PS)', 'DEF OverallocationRate (=ATD + OAC)',
      'DEF BaseRate (=DTA)', 'DEF PeakRate (=DTA+PS)',
      'DEF OverallocationRate (=DTA + OAC)', 'DEF BaseRate (=DTD)',
      'DEF PeakRate (=DTD+PS)', 'DEF OverallocationRate (=DTD + OAC)',
      'EXP BaseRate (=ATA)', 'EXP PeakRate (=ATA+PS)',
      'EXP OverallocationRate (=ATA + OAC)', 'EXP BaseRate (=ATD)',
      'EXP PeakRate (=ATD+PS)', 'EXP OverallocationRate (=ATD + OAC)',
      'EXP BaseRate (=DTA)', 'EXP PeakRate (=DTA+PS)',
      'EXP OverallocationRate (=DTA + OAC)', 'EXP BaseRate (=DTD)',
      'EXP PeakRate (=DTD+PS)', 'EXP OverallocationRate (=DTD + OAC)'
      ,'af_Total_STD','fsc_Total_STD','scr_Sur_Total_STD','sct_Sur_Total_STD','ow_Total_STD','ow_programm_Total_STD','ow_Scr_Total_STD','ow_security_Total_STD','pp_Total_STD','destinationmin_Total_STD','dw_programm_Total_STD','dw_Scr_Total_STD','dw_security_Total_STD','dlpw_Total_STD','pss_Total_STD','af_Total_DEF','fsc_Total_DEF','scr_Sur_Total_DEF','sct_Sur_Total_DEF','ow_Total_DEF','ow_programm_Total_DEF','ow_Scr_Total_DEF','ow_security_Total_DEF','pp_Total_DEF','destinationmin_Total_DEF','dw_programm_Total_DEF','dw_Scr_Total_DEF','dw_security_Total_DEF','dlpw_Total_DEF','pss_Total_DEF','af_Total_EXP','fsc_Total_EXP','scr_Sur_Total_EXP','sct_Sur_Total_EXP','ow_Total_EXP','ow_programm_Total_EXP','ow_Scr_Total_EXP','ow_security_Total_EXP','pp_Total_EXP','destinationmin_Total_EXP','dw_programm_Total_EXP','dw_Scr_Total_EXP','dw_security_Total_EXP','dlpw_Total_EXP','pss_Total_EXP',
      'BaseCapacity (=Available Non Peak Capacity/KG)']);

    // //console.log(rbl.length); 


        
        
        
      // this.wavg_list=  this.calculateavgrate();
      datatable.push(["Month","STD ATA",{ role: 'tooltip', p: { html: true } }])

      datatableatd_std.push(["Month","STD ATD",{ role: 'tooltip', p: { html: true } }])
      datatabledtd_std.push(["Month","STD DTD",{ role: 'tooltip', p: { html: true } }])
      datatabledta_std.push(["Month","STD DTA",{ role: 'tooltip', p: { html: true } }])

      datatable_exp.push(["Month","EXP ATA",{ role: 'tooltip', p: { html: true } }])
      datatableatd_exp.push(["Month","EXP ATD",{ role: 'tooltip', p: { html: true } }])
      datatabledtd_exp.push(["Month","EXP DTD",{ role: 'tooltip', p: { html: true } }])
      datatabledta_exp.push(["Month","EXP DTA",{ role: 'tooltip', p: { html: true } }])

      datatable_def.push(["Month","DEF ATA",{ role: 'tooltip', p: { html: true } }])
      datatableatd_def.push(["Month","DEF ATD",{ role: 'tooltip', p: { html: true } }])
      datatabledtd_def.push(["Month","DEF DTD",{ role: 'tooltip', p: { html: true } }])
      datatabledta_def.push(["Month","DEF DTA",{ role: 'tooltip', p: { html: true } }])

   
    
  //  //console.log( this.wavg_list);


    //list=this.momlist=this.ratebook_trend;
    list=list.sort((a:any, b:any) =>  {
      const [monthA, yearA] = a['smonthyear'].split('-').map(Number);
      const [monthB, yearB] = b['smonthyear'].split('-').map(Number);
    
      // Compare year first, then month
      if (yearA !== yearB) {
        return yearA - yearB;
      } else {
        return monthA - monthB;
      }
    });

   

    var i=0;
    ////console.log( this.wavg_list);

    //console.log(list);

   
    list.forEach((element:any )=> {
      var prevel:any;
      if(i>0)
      {
         prevel=list[i-1];
      }else{
         prevel=list[i];
      }
       //console.log(this.wavg_list)
      
      var benchmark=null;
      var benchmarkexp=null;
      var benchmarkdef=null;

      

      datatable.push([element['smonthyear'],element['STD PeakRate (=ATA+PS)'],this.tooltipHtml(element,prevel,'STD','ATA')])

      datatableatd_std.push([element['smonthyear'],element['STD PeakRate (=ATD+PS)'],this.tooltipHtml(element,prevel,'STD','ATD')])
      datatabledtd_std.push([element['smonthyear'],element['STD PeakRate (=DTD+PS)'],this.tooltipHtml(element,prevel,'STD','DTD')])
      datatabledta_std.push([element['smonthyear'],element['STD PeakRate (=DTA+PS)'],this.tooltipHtml(element,prevel,'STD','DTA')])

      datatable_def.push([element['smonthyear'],element['DEF PeakRate (=ATA+PS)'],this.tooltipHtml(element,prevel,'DEF','ATA')])
      datatableatd_def.push([element['smonthyear'],element['DEF PeakRate (=ATD+PS)'],this.tooltipHtml(element,prevel,'DEF','ATD')])
      datatabledtd_def.push([element['smonthyear'],element['DEF PeakRate (=DTD+PS)'],this.tooltipHtml(element,prevel,'DEF','DTD')])
      datatabledta_def.push([element['smonthyear'],element['DEF PeakRate (=DTA+PS)'],this.tooltipHtml(element,prevel,'DEF','DTA')])


      datatable_exp.push([element['smonthyear'],element['EXP PeakRate (=ATA+PS)'],this.tooltipHtml(element,prevel,'EXP','ATA')])

      datatableatd_exp.push([element['smonthyear'],element['EXP PeakRate (=ATD+PS)'],this.tooltipHtml(element,prevel,'EXP','ATD')])
      datatabledtd_exp.push([element['smonthyear'],element['EXP PeakRate (=DTD+PS)'],this.tooltipHtml(element,prevel,'EXP','DTD')])
      datatabledta_exp.push([element['smonthyear'],element['EXP PeakRate (=DTA+PS)'],this.tooltipHtml(element,prevel,'EXP','DTA')])
      
      i=i+1;

    });
    ////console.log(datatable_iata)

    benchmark_combined_chart.dataTable=datatable;
    var c=0;
    datatable_iata.slice(1,datatable_iata.length-1).forEach((element:any) => {
    
      ////console.log(element[3]);
       if(element[3]!=null)
         c=c+1;

    });

    ////console.log(c);

   
      ////console.log(this.wavg_list);

    var std_ata=JSON.parse(JSON.stringify(benchmark_combined_chart));
    
    benchmark_combined_chart.dataTable=datatabledta_std;
    var std_dta=JSON.parse(JSON.stringify(benchmark_combined_chart));
    benchmark_combined_chart.dataTable=datatabledtd_std;
    var std_dtd=JSON.parse(JSON.stringify(benchmark_combined_chart));
    benchmark_combined_chart.dataTable=datatableatd_std;
    var std_atd=JSON.parse(JSON.stringify(benchmark_combined_chart));

    benchmark_combined_chart.dataTable=datatable_exp;
    var exp_ata=JSON.parse(JSON.stringify(benchmark_combined_chart));

   
    benchmark_combined_chart.dataTable=datatabledta_exp;
    var exp_dta=JSON.parse(JSON.stringify(benchmark_combined_chart));
    benchmark_combined_chart.dataTable=datatabledtd_exp;
    var exp_dtd=JSON.parse(JSON.stringify(benchmark_combined_chart));
    benchmark_combined_chart.dataTable=datatableatd_exp;
    var exp_atd=JSON.parse(JSON.stringify(benchmark_combined_chart));

    benchmark_combined_chart.dataTable=datatable_def;
    var def_ata=JSON.parse(JSON.stringify(benchmark_combined_chart));

   
    benchmark_combined_chart.dataTable=datatabledta_def;
    var def_dta=JSON.parse(JSON.stringify(benchmark_combined_chart));
    benchmark_combined_chart.dataTable=datatabledtd_def;
    var def_dtd=JSON.parse(JSON.stringify(benchmark_combined_chart));
    benchmark_combined_chart.dataTable=datatableatd_def;
    var def_atd=JSON.parse(JSON.stringify(benchmark_combined_chart));

    this.ratebook_trend_graph_wiata= {std_ata:std_ata,std_dta:std_dta,std_dtd:std_dtd,std_atd:std_atd,def_ata:def_ata,def_atd:def_atd,def_dta:def_dta,def_dtd:def_dtd,exp_dta:exp_dta,exp_ata:exp_ata,exp_dtd:exp_dtd,exp_atd:exp_atd}


   
    //console.log(this.ratebook_trend_graph);


  }
  price_model_type_change(p:any){

    this.price_model_type=p;
    this.ptype=p;

  }
  ptype_change(p:any){
    this.ptype=p;
    this.price_model_type=p;
    this.draw_month_over_trend_new();

  }


  //function on load of sourcing file

  distinctweek:any=[]
  distinct_lane:any=[];
  distinct_month:any=[];
  distinct_fiscal:any=[]
  filtered_Data:any=[];

  

  // weekly predection
  prediction_list_all_lane:any=[]
  get_weekly_prediction(){
    this.service.postData({}, 'get_weekly_prediction').then((result) => {
      
      var res:any=result;


      this.prediction_list_all_lane = JSON.parse(res.df_json);
      this.drawgraphs();
     
  
    });
  }

  //ratebook monthly list
  resultlist:any=[]
  getallratebook()
  {
    this.resultlist=[]
    this.service.postData({type:''}, 'getall_ratebok_monthly').then((result) => {
          
      var temp: any = result;
      this.resultlist =temp.data;
            
    });
  }

  
  ocean_filtered:any=[]
  air_data_filtered:any=[]

  convertToArray(data:any) {
    const result = [];
    
    for (let key in data) {
        if (data.hasOwnProperty(key)) {
            result.push(data[key]);
        }
    }
    
    return result;
}
sumOfKey(arr:any, key:any) {
  return arr.reduce((sum:any, obj:any) => {
    // Check if the key exists in the current object
    if (obj[key] !== undefined) {
      sum += obj[key];
    }
    return sum;
  }, 0); // Initialize sum as 0
}

selectall(){
    //console.log(this.selectedItems);
    this.selectedItems=this.distinctlane;
    this.filter_data();
    this.draw_month_over_trend_new();
    this.draw_month_over_trend_new_without();
  }
  select_event(){

    this.filter_data();
    this.draw_month_over_trend_new();
    this.draw_month_over_trend_new_without();

  }

  //filter list data
  projectionval:any=0
  filter_data() {

    //filter_week

    this.fitlered_data=[]
    this.graph_page=0;
    this.graph_page_partner=-1;

    //ratebook filter
    // this.filter_retebook();
    

    //list filter for fiscal weeks as per selections

    if(this.filterselection.fiscal_quarter!='')
    {

      if(this.filterselection.fiscal_month!='')
        {
        this.weekly_avg_cost_model = this.weekly_avg_cost_model_bk.filter((data:any)=>{ return data.FY_year== this.filterselection.fiscal_year && data.cisco_FY_quarter==this.filterselection.fiscal_quarter && data.cisco_FY_month_num==this.filterselection.fiscal_month})

        this.ocean_filtered = this.ocean_data.filter((data:any)=>{ return data.FY_year== this.filterselection.fiscal_year && data.cisco_FY_quarter==this.filterselection.fiscal_quarter && data.cisco_FY_month_num==this.filterselection.fiscal_month})

        
        this.weekly_avg_cost_model_lane = this.weekly_avg_cost_model_lane_bk.filter((data:any)=>{ return data.FY_year== this.filterselection.fiscal_year && data.cisco_FY_quarter==this.filterselection.fiscal_quarter && data.cisco_FY_month_num==this.filterselection.fiscal_month})
      }
      else{
        this.weekly_avg_cost_model = this.weekly_avg_cost_model_bk.filter((data:any)=>{ return data.FY_year== this.filterselection.fiscal_year && data.cisco_FY_quarter==this.filterselection.fiscal_quarter})
       
        this.ocean_filtered = this.ocean_data.filter((data:any)=>{ return data.FY_year== this.filterselection.fiscal_year && data.cisco_FY_quarter==this.filterselection.fiscal_quarter})

        this.weekly_avg_cost_model_lane = this.weekly_avg_cost_model_lane_bk.filter((data:any)=>{ return data.FY_year== this.filterselection.fiscal_year && data.cisco_FY_quarter==this.filterselection.fiscal_quarter })
      }
        
      
    }
    else{

      if(this.filterselection.fiscal_month!='')
        {
          this.weekly_avg_cost_model = this.weekly_avg_cost_model_bk.filter((data:any)=>{
            return data.FY_year== this.filterselection.fiscal_year && data.cisco_FY_month_num==this.filterselection.fiscal_month})
         
            this.ocean_filtered = this.ocean_data.filter((data:any)=>{
              return data.FY_year== this.filterselection.fiscal_year && data.cisco_FY_month_num==this.filterselection.fiscal_month})


            this.weekly_avg_cost_model_lane = this.weekly_avg_cost_model_lane_bk.filter((data:any)=>{
              return data.FY_year== this.filterselection.fiscal_year  && data.cisco_FY_month_num==this.filterselection.fiscal_month })
            
        }else{
          this.weekly_avg_cost_model = this.weekly_avg_cost_model_bk.filter((data:any)=>{
            return data.FY_year== this.filterselection.fiscal_year})
          
          this.ocean_filtered = this.ocean_data.filter((data:any)=>{
              return data.FY_year== this.filterselection.fiscal_year})

          this.weekly_avg_cost_model_lane = this.weekly_avg_cost_model_lane_bk.filter((data:any)=>{ return data.FY_year== this.filterselection.fiscal_year })
        }
        this.get_Distinct_partner();

    }

  
    // for lane level details only selecting first records for further avg
    // this.fitlered_data lane level weight and penalties and cost
    // fitlered_data_details :  details by partner and weeks 
    // filtered_data_all 

    const groupedData:any = this.groupByFirstRecord(this.weekly_avg_cost_model_lane, 'Lane');

        var projection_data_filtered:any=[]


    // filter for selected lanes 
     if(this.selectedItems.length==0){
       this.fitlered_data=groupedData.filter((data:any) =>  this.distinctlane.indexOf(data.Lane)>=0);
       this.fitlered_data_details=this.weekly_avg_cost_model.filter((data:any) =>  this.distinctlane.indexOf(data.Lane)>=0);
       this.ocean_filtered=this.ocean_filtered.filter((data:any) =>  this.distinctlane.indexOf(data['Lane Group'])>=0);
       projection_data_filtered=this.projection_data.filter((data:any) =>  this.distinctlane.indexOf(data['ORIGIN_BRANCH']+'-'+data['DESTIN_BRANCH'])>=0);

       this.filtered_data_all=this.weekly_avg_cost_model_lane.filter((data:any) =>  this.distinctlane.indexOf(data.Lane)>=0);

      }else{

        this.fitlered_data =  groupedData.filter((data:any) =>  this.selectedItems.indexOf(data.Lane)>=0);
        this.fitlered_data_details=this.weekly_avg_cost_model.filter((data:any) =>  this.selectedItems.indexOf(data.Lane)>=0);
        this.ocean_filtered=this.ocean_filtered.filter((data:any) =>  this.selectedItems.indexOf(data['Lane Group'])>=0);
        projection_data_filtered=this.projection_data.filter((data:any) =>  this.selectedItems.indexOf(data['ORIGIN_BRANCH']+'-'+data['DESTIN_BRANCH'])>=0);
        this.filtered_data_all=this.weekly_avg_cost_model_lane.filter((data:any) =>  this.selectedItems.indexOf(data.Lane)>=0);

     }

     this.air_data_filtered=this.convertToArray(this.groupByAndSum_m(this.filtered_data_all,['FYQW'],['COB_WEIGHT_CHARGEABLE']));

     this.ocean_filtered=this.convertToArray(this.groupByAndSum_m(this.ocean_filtered,['FYQW'],['OCEAN_WEIGHT_CHARGEABLE']));
    //  console.log(this.ocean_filtered);
     console.log(projection_data_filtered);


     this.projectionval =this.sumOfKey(projection_data_filtered,'Projected_COB_WEIGHT_CHARGEABLE');


     ////console.log(this.fitlered_data);

     if(this.fitlered_data.length>0)
     {

 
      this.filter_data_service()

      if(this.ratebook_trend.length>0)
       this.draw_month_over_trend_new();
      
      this.lanelist_for_Servicelevel_spend=[]
      this.partner_Details=[]
      this.week_details=[]
      this.draw_trend_line_volue();


     }


  }

  download(){
    console.log(this.fitlered_data_details);

    // let sampleJson: any = [];
    let datad = this.filtered_data_all;
    // 					over_penalty	tier2penalty	tier3penalty	over_penaltyv
    //         				total_spend	total_volume	
    // Step 1: Define the columns you want to include and their new names
    const selectedColumns: { [key: string]: string } = {
      "ORIGIN_BRANCH": "ORIGIN_BRANCH",
      "DESTIN_BRANCH": "DESTIN_BRANCH",
      "PARTNER": "PARTNER",
      "Week_Start": "Fiscal Week",
      "total_volume": "COB_WEIGHT_CHARGEABLE",
      "Overallocation $ Penalty": "Overallocation $ Penalty",
      "Underallocation $ Penalty": "Underallocation $ Penalty",
      "Partner_Blended_Spend": "Partner_Blended_Spend",
      "Wks_Blended_Avg_rate": "Wks_Blended_Avg_rate",
      "total_spend": "Partner_Blended_Spend w Penalty",
      "Wks_Blended_Avg_rate w Penalty": "Wks_Blended_Avg_rate w Penalty",

      // Add more key mappings as needed
    };
    
    // Step 2: Map the data to include only selected columns with renamed keys
    const week_allocation = datad.map((item:any) => {
      const newItem: any = {};
      for (let key in selectedColumns) {
        if (item.hasOwnProperty(key)) {
          newItem[selectedColumns[key]] = item[key];
        }
      }
      return newItem;
    });
    
    // Step 3: Convert to Excel-compatible format
    const keysList = Object.keys(week_allocation[0]);
    const data = week_allocation.map((obj:any) => Object.values(obj));
    data.unshift(keysList); // Add header
    
    // Step 4: Create and write the Excel file
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
    
    workbook.SheetNames.push("Filtered Data");
    workbook.Sheets["Filtered Data"] = worksheet;
    
    XLSX.writeFile(workbook, 'Partner_sourcing_Spend_&_Penalty_details.xlsx');
  }

  // filter for service level and service types and global spend and avg rates cal

  filter_data_service(){

    var filter_data=[];
    
    console.log(this.weekly_avg_cost_model);
   
    if(this.selectedItems.length==0){
      filter_data =   this.weekly_avg_cost_model.filter((data:any) =>  this.distinctlane.indexOf(data.Lane)>=0);

    }else{
      filter_data =  this.weekly_avg_cost_model.filter((data:any) =>  this.selectedItems.indexOf(data.Lane)>=0);
    }

    console.log(filter_data);

    // distinct service

    this.distinct_service=filter_data
    .map((item:any) => item['Service Level'])
    .filter(
        (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
    );

  
   // distinct price model

    this.distinct_pricemodel=filter_data
    .map((item:any) => item['Service Type'])
    .filter(
        (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
    );
   

   
  // by week  by service level total sums

   var weekgroup_servicelevel= this.groupByMultipleAndSum(filter_data,["Week_Start","Service Level"])
   this.weekgroup_servicelevel=weekgroup_servicelevel;
    
   this.weekgroup_servicelevel_partner= this.groupByMultipleAndSum(filter_data,["Week_Start","Service Level","PARTNER"])

   var weely_lane=this.addKeyWithDefaultValue(JSON.parse(JSON.stringify(this.filtered_data_all)),'group','1')



  //  global filter data spends details 

   this.weekl_golbal_spend = Object.values(this.groupByAndSum_m(weely_lane, ['group'],['COB_WEIGHT_CHARGEABLE','Overallocation $ Penalty','Underallocation $ Penalty','Partner_Blended_Spend']));


  //  weekly global spend by partner
   var  weekl_golbal_spend_partner = Object.values(this.groupByAndSum_m(weely_lane, ['PARTNER'],['COB_WEIGHT_CHARGEABLE','Overallocation $ Penalty','Underallocation $ Penalty','Partner_Blended_Spend']));


   this.weekl_golbal_spend[0]['Partner_details']=weekl_golbal_spend_partner;


   var i=0;

  //  generate data by partner by week by lane
   this.weekl_golbal_spend[0]['Partner_details'].forEach((partner:any) => {

      var weely_lane_partner=weely_lane.filter((data:any)=>{ return data.PARTNER==partner.PARTNER});

      var  weekl_golbal_spend_partner_lane:any = Object.values(this.groupByAndSum_m(weely_lane_partner, ['Lane'],['COB_WEIGHT_CHARGEABLE','Overallocation $ Penalty','Underallocation $ Penalty','Partner_Blended_Spend']));
      

      var k=0;
      weekl_golbal_spend_partner_lane.forEach((lane:any) => {

        var weely_lane_partner_week=weely_lane_partner.filter((data:any)=>{ return data.Lane==lane.Lane});
        
          
          weekl_golbal_spend_partner_lane[k]['week_details']=weely_lane_partner_week;
          k=k+1;
      });
      this.weekl_golbal_spend[0]['Partner_details'][i]['lane_details']=weekl_golbal_spend_partner_lane;
      i=i+1
   });



   this.distinct_week=weekgroup_servicelevel.map((item:any) => item['Week_Start'])
   .filter(
       (value, index, current_value) => current_value.indexOf(value) === index
   );

   

  //  filterdata avg for rates / price models by week
   
  var price_model_Avg= this.groupByMultipleAndAverage(filter_data,["Week_Start"],['STD BaseRate (=ATA)', 'STD PeakRate (=ATA+PS)',
    'STD OverallocationRate (=ATA + OAC)', 'STD BaseRate (=ATD)',
    'STD PeakRate (=ATD+PS)', 'STD OverallocationRate (=ATD + OAC)',
    'STD BaseRate (=DTA)', 'STD PeakRate (=DTA+PS)',
    'STD OverallocationRate (=DTA + OAC)', 'STD BaseRate (=DTD)',
    'STD PeakRate (=DTD+PS)', 'STD OverallocationRate (=DTD + OAC)',
    'DEF BaseRate (=ATA)', 'DEF PeakRate (=ATA+PS)',
    'DEF OverallocationRate (=ATA + OAC)', 'DEF BaseRate (=ATD)',
    'DEF PeakRate (=ATD+PS)', 'DEF OverallocationRate (=ATD + OAC)',
    'DEF BaseRate (=DTA)', 'DEF PeakRate (=DTA+PS)',
    'DEF OverallocationRate (=DTA + OAC)', 'DEF BaseRate (=DTD)',
    'DEF PeakRate (=DTD+PS)', 'DEF OverallocationRate (=DTD + OAC)',
    'EXP BaseRate (=ATA)', 'EXP PeakRate (=ATA+PS)',
    'EXP OverallocationRate (=ATA + OAC)', 'EXP BaseRate (=ATD)',
    'EXP PeakRate (=ATD+PS)', 'EXP OverallocationRate (=ATD + OAC)',
    'EXP BaseRate (=DTA)', 'EXP PeakRate (=DTA+PS)',
    'EXP OverallocationRate (=DTA + OAC)', 'EXP BaseRate (=DTD)',
    'EXP PeakRate (=DTD+PS)', 'EXP OverallocationRate (=DTD + OAC)'
    ,'af_Total_STD','fsc_Total_STD','scr_Sur_Total_STD','sct_Sur_Total_STD','ow_Total_STD','ow_programm_Total_STD','ow_Scr_Total_STD','ow_security_Total_STD','pp_Total_STD','destinationmin_Total_STD','dw_programm_Total_STD','dw_Scr_Total_STD','dw_security_Total_STD','dlpw_Total_STD','pss_Total_STD','af_Total_DEF','fsc_Total_DEF','scr_Sur_Total_DEF','sct_Sur_Total_DEF','ow_Total_DEF','ow_programm_Total_DEF','ow_Scr_Total_DEF','ow_security_Total_DEF','pp_Total_DEF','destinationmin_Total_DEF','dw_programm_Total_DEF','dw_Scr_Total_DEF','dw_security_Total_DEF','dlpw_Total_DEF','pss_Total_DEF','af_Total_EXP','fsc_Total_EXP','scr_Sur_Total_EXP','sct_Sur_Total_EXP','ow_Total_EXP','ow_programm_Total_EXP','ow_Scr_Total_EXP','ow_security_Total_EXP','pp_Total_EXP','destinationmin_Total_EXP','dw_programm_Total_EXP','dw_Scr_Total_EXP','dw_security_Total_EXP','dlpw_Total_EXP','pss_Total_EXP',
    'BaseCapacity (=Available Non Peak Capacity/KG)']);



  var filter_data_t=this.addKeyWithDefaultValue(JSON.parse(JSON.stringify(filter_data)),'group','1')

    
    // removming blank rows or null records on the basis of STD BASE ATA
    var filter_data_t_wnull:any=[]
    filter_data_t.forEach((element:any) => {

      if(element['STD BaseRate (=ATA)']!=null && element['STD BaseRate (=ATA)']!=0)
        filter_data_t_wnull.push(element)
      
    });
    

    const groupedData:any = this.groupByFirstRecord_multiple(filter_data_t_wnull, ['ORIGIN_BRANCH','DESTIN_BRANCH','PARTNER','month']);



    //  pricemodel avg by partner
    this.price_model_global_avg = this.groupByMultipleAndAverage(groupedData,["PARTNER"],['STD BaseRate (=ATA)',
       'STD PeakRate (=ATA+PS)', 'STD OverallocationRate (=ATA + OAC)','STD Tier2Rate ATA','STD Tier3Rate ATA','STD PeakTier2Rate ATA','STD PeakTier3Rate ATA',
       'STD BaseRate (=ATD)', 'STD PeakRate (=ATD+PS)',
       'STD OverallocationRate (=ATD + OAC)','STD Tier2Rate ATD','STD Tier3Rate ATD','STD PeakTier2Rate ATD','STD PeakTier3Rate ATD', 'STD BaseRate (=DTA)',
       'STD PeakRate (=DTA+PS)', 'STD OverallocationRate (=DTA + OAC)','STD Tier2Rate DTA','STD Tier3Rate DTA','STD PeakTier2Rate DTA','STD PeakTier3Rate DTA',
       'STD BaseRate (=DTD)', 'STD PeakRate (=DTD+PS)',
       'STD OverallocationRate (=DTD + OAC)','STD Tier2Rate DTD','STD Tier3Rate DTD','STD PeakTier2Rate DTD','STD PeakTier3Rate DTD', 'DEF BaseRate (=ATA)',
       'DEF PeakRate (=ATA+PS)', 'DEF OverallocationRate (=ATA + OAC)','DEF Tier2Rate ATA','DEF Tier3Rate ATA',
       'DEF PeakTier2Rate ATA','DEF PeakTier3Rate ATA','DEF BaseRate (=ATD)', 'DEF PeakRate (=ATD+PS)',
       'DEF OverallocationRate (=ATD + OAC)','DEF Tier2Rate ATD','DEF Tier3Rate ATD','DEF PeakTier2Rate ATD','DEF PeakTier3Rate ATD', 'DEF BaseRate (=DTA)',
       'DEF PeakRate (=DTA+PS)', 'DEF OverallocationRate (=DTA + OAC)','DEF Tier2Rate DTA','DEF Tier3Rate DTA','DEF PeakTier2Rate DTA','DEF PeakTier3Rate DTA',
       'DEF BaseRate (=DTD)', 'DEF PeakRate (=DTD+PS)',
       'DEF OverallocationRate (=DTD + OAC)','DEF Tier2Rate DTD','DEF Tier3Rate DTD','DEF PeakTier2Rate DTD','DEF PeakTier3Rate DTD', 'EXP BaseRate (=ATA)',
       'EXP PeakRate (=ATA+PS)', 'EXP OverallocationRate (=ATA + OAC)','EXP Tier2Rate ATA','EXP Tier3Rate ATA',
       'EXP PeakTier2Rate ATA','EXP PeakTier3Rate ATA','EXP BaseRate (=ATD)', 'EXP PeakRate (=ATD+PS)',
       'EXP OverallocationRate (=ATD + OAC)','EXP Tier2Rate ATD','EXP Tier3Rate ATD','EXP PeakTier2Rate ATD','EXP PeakTier3Rate ATD', 'EXP BaseRate (=DTA)',
       'EXP PeakRate (=DTA+PS)', 'EXP OverallocationRate (=DTA + OAC)','EXP Tier2Rate DTA','EXP Tier3Rate DTA','EXP PeakTier2Rate DTA','EXP PeakTier3Rate DTA',
       'EXP BaseRate (=DTD)', 'EXP PeakRate (=DTD+PS)',
       'EXP OverallocationRate (=DTD + OAC)','EXP Tier2Rate DTD','EXP Tier3Rate DTD','EXP PeakTier2Rate DTD','EXP PeakTier3Rate DTD','af_Total_STD','fsc_Total_STD','scr_Sur_Total_STD','sct_Sur_Total_STD','ow_Total_STD','ow_programm_Total_STD','ow_Scr_Total_STD','ow_security_Total_STD','pp_Total_STD','destinationmin_Total_STD','dw_programm_Total_STD','dw_Scr_Total_STD','dw_security_Total_STD','dlpw_Total_STD','pss_Total_STD','af_Total_DEF','fsc_Total_DEF','scr_Sur_Total_DEF','sct_Sur_Total_DEF','ow_Total_DEF','ow_programm_Total_DEF','ow_Scr_Total_DEF','ow_security_Total_DEF','pp_Total_DEF','destinationmin_Total_DEF','dw_programm_Total_DEF','dw_Scr_Total_DEF','dw_security_Total_DEF','dlpw_Total_DEF','pss_Total_DEF','af_Total_EXP','fsc_Total_EXP','scr_Sur_Total_EXP','sct_Sur_Total_EXP','ow_Total_EXP','ow_programm_Total_EXP','ow_Scr_Total_EXP','ow_security_Total_EXP','pp_Total_EXP','destinationmin_Total_EXP','dw_programm_Total_EXP','dw_Scr_Total_EXP','dw_security_Total_EXP','dlpw_Total_EXP','pss_Total_EXP']);

    console.log(groupedData);


    // by week
    this.price_model_Avg=price_model_Avg;     
    
    
    var filter_data_t_wnull:any=[]

    filter_data.forEach((element:any) => {

      if(element['STD BaseRate (=ATA)']!=null && element['STD BaseRate (=ATA)']!=0)
        filter_data_t_wnull.push(element)
      
    });

    // price model avg by week by partner
    // const groupedDatap:any = this.groupByFirstRecord_multiple(filter_data_t_wnull, ["Week_Start","PARTNER","month"]);
    // console.log(groupedDatap);
    console.log(filter_data_t_wnull);

    this.price_model_Avg_partner= this.groupByMultipleAndAverage(filter_data_t_wnull,["Week_Start","PARTNER"],['STD BaseRate (=ATA)',
       'STD PeakRate (=ATA+PS)', 'STD OverallocationRate (=ATA + OAC)','STD Tier2Rate ATA','STD Tier3Rate ATA','STD PeakTier2Rate ATA','STD PeakTier3Rate ATA',
       'STD BaseRate (=ATD)', 'STD PeakRate (=ATD+PS)',
       'STD OverallocationRate (=ATD + OAC)','STD Tier2Rate ATD','STD Tier3Rate ATD','STD PeakTier2Rate ATD','STD PeakTier3Rate ATD', 'STD BaseRate (=DTA)',
       'STD PeakRate (=DTA+PS)', 'STD OverallocationRate (=DTA + OAC)','STD Tier2Rate DTA','STD Tier3Rate DTA','STD PeakTier2Rate DTA','STD PeakTier3Rate DTA',
       'STD BaseRate (=DTD)', 'STD PeakRate (=DTD+PS)',
       'STD OverallocationRate (=DTD + OAC)','STD Tier2Rate DTD','STD Tier3Rate DTD','STD PeakTier2Rate DTD','STD PeakTier3Rate DTD', 'DEF BaseRate (=ATA)',
       'DEF PeakRate (=ATA+PS)', 'DEF OverallocationRate (=ATA + OAC)','DEF Tier2Rate ATA','DEF Tier3Rate ATA',
       'DEF PeakTier2Rate ATA','DEF PeakTier3Rate ATA','DEF BaseRate (=ATD)', 'DEF PeakRate (=ATD+PS)',
       'DEF OverallocationRate (=ATD + OAC)','DEF Tier2Rate ATD','DEF Tier3Rate ATD','DEF PeakTier2Rate ATD','DEF PeakTier3Rate ATD', 'DEF BaseRate (=DTA)',
       'DEF PeakRate (=DTA+PS)', 'DEF OverallocationRate (=DTA + OAC)','DEF Tier2Rate DTA','DEF Tier3Rate DTA','DEF PeakTier2Rate DTA','DEF PeakTier3Rate DTA',
       'DEF BaseRate (=DTD)', 'DEF PeakRate (=DTD+PS)',
       'DEF OverallocationRate (=DTD + OAC)','DEF Tier2Rate DTD','DEF Tier3Rate DTD','DEF PeakTier2Rate DTD','DEF PeakTier3Rate DTD', 'EXP BaseRate (=ATA)',
       'EXP PeakRate (=ATA+PS)', 'EXP OverallocationRate (=ATA + OAC)','EXP Tier2Rate ATA','EXP Tier3Rate ATA',
       'EXP PeakTier2Rate ATA','EXP PeakTier3Rate ATA','EXP BaseRate (=ATD)', 'EXP PeakRate (=ATD+PS)',
       'EXP OverallocationRate (=ATD + OAC)','EXP Tier2Rate ATD','EXP Tier3Rate ATD','EXP PeakTier2Rate ATD','EXP PeakTier3Rate ATD', 'EXP BaseRate (=DTA)',
       'EXP PeakRate (=DTA+PS)', 'EXP OverallocationRate (=DTA + OAC)','EXP Tier2Rate DTA','EXP Tier3Rate DTA','EXP PeakTier2Rate DTA','EXP PeakTier3Rate DTA',
       'EXP BaseRate (=DTD)', 'EXP PeakRate (=DTD+PS)',
       'EXP OverallocationRate (=DTD + OAC)','EXP Tier2Rate DTD','EXP Tier3Rate DTD','EXP PeakTier2Rate DTD','EXP PeakTier3Rate DTD','af_Total_STD','fsc_Total_STD','scr_Sur_Total_STD','sct_Sur_Total_STD','ow_Total_STD','ow_programm_Total_STD','ow_Scr_Total_STD','ow_security_Total_STD','pp_Total_STD','destinationmin_Total_STD','dw_programm_Total_STD','dw_Scr_Total_STD','dw_security_Total_STD','dlpw_Total_STD','pss_Total_STD','af_Total_DEF','fsc_Total_DEF','scr_Sur_Total_DEF','sct_Sur_Total_DEF','ow_Total_DEF','ow_programm_Total_DEF','ow_Scr_Total_DEF','ow_security_Total_DEF','pp_Total_DEF','destinationmin_Total_DEF','dw_programm_Total_DEF','dw_Scr_Total_DEF','dw_security_Total_DEF','dlpw_Total_DEF','pss_Total_DEF','af_Total_EXP','fsc_Total_EXP','scr_Sur_Total_EXP','sct_Sur_Total_EXP','ow_Total_EXP','ow_programm_Total_EXP','ow_Scr_Total_EXP','ow_security_Total_EXP','pp_Total_EXP','destinationmin_Total_EXP','dw_programm_Total_EXP','dw_Scr_Total_EXP','dw_security_Total_EXP','dlpw_Total_EXP','pss_Total_EXP']);
    
      console.log(this.price_model_Avg_partner);
    //total spend calculations

   
    // total filtered spend and volume
    this.total_filtered_spend=0;
    this.total_filtered_volume=0;

    this.weekgroup_servicelevel.forEach((element:any) => {
      this.total_filtered_spend+=element.Partner_Blended_Spend;
      this.total_filtered_volume+=element.COB_WEIGHT_CHARGEABLE;
      
    });



    // spend by service level
    this.total_spend_servicelevel=this.groupByAndSum_data(this.weekgroup_servicelevel,'Service Level')

    this.total_spend_servicelevel = this.total_spend_servicelevel.sort((b:any, a:any) => a.Partner_Blended_Spend - b.Partner_Blended_Spend);


    // spend by price model

    this.pricemodel_spend=this.groupByAndSum_data(this.fitlered_data_details,'Service Type')
    

    ////////console.log(this.pricemodel_spend);
    this.drilldown(filter_data,this.total_filtered_spend,this.total_spend_servicelevel);
    this.drawgraph_selectedweekanddata();

   }


  //  drill down view 
  drilldown(rawdata:any,spend:any,spendbysl:any){
    
    var data:any =[]
    var details:any=['id', 'childLabel', 'parent', 'size', { role: 'style' }];
    var k=0;
    var p=-1;
    data.push(details);
    // details=[]
    data.push([0,"Spend:($ "+spend.toLocaleString(this.lc,this.opt1)+")",p,1,'black'])
    p=k; 

    k++;

    spendbysl.forEach((element:any) => {

      data.push([k,element.product+":($ "+element.Partner_Blended_Spend.toLocaleString(this.lc,this.opt1)+")",p,1,'black'])
      var sllist=this.get_data_sl(element.product);
      var sortedsllist= sllist.sort((b:any, a:any) => a.Partner_Blended_Spend - b.Partner_Blended_Spend);

      var ps=k;
      k++;
      sortedsllist.slice(0,30).forEach((lane:any) => {


        data.push([k,lane.Lane+":($ "+lane.Partner_Blended_Spend.toLocaleString(this.lc,this.opt1)+")",ps,1,'black'])

        var partner=this.get_data_partner(lane.Lane);
        var pss=k;
        k++;

        partner.forEach((partner:any) => {
          
          data.push([k,partner.PARTNER+":($ "+partner.Partner_Blended_Spend.toLocaleString(this.lc,this.opt1)+")",pss,1,'black'])
                
          var psss=k;
          k++;

          var weeks=this.get_data_week(partner.PARTNER);
          var sortedweeks= weeks.sort((b:any, a:any) => a.Partner_Blended_Spend - b.Partner_Blended_Spend);
         
          weeks.forEach((week:any) => {

            data.push([k,week.Week_Start+":($ "+week.Partner_Blended_Spend.toLocaleString(this.lc,this.opt1)+")",psss,1,'black'])


            k++;
          });

        });

        k++;

      });


       
      

    }); 


    this.chart = {
      chartType: 'WordTree',
      dataTable: 
      data,
    
        
      options: {
        maxFontSize: 12,
        wordtree: {
          format: 'explicit',
          type: 'double'
        },
    
        // bar: { groupWidth: '40%' },
        // chartArea: { width: '80%', height: '100%' },
       
    
    
        legend: { position: 'top', alignment: 'center' },
        hAxis: {
          gridlines: { color: 'transparent' }
        },
        height: 420,
       
      }
    }
    ////////console.log(this.chart.dataTable)
  }

fixNullNumericColumns(dataTable: any[][]): any[][] {
  if (!dataTable || dataTable.length < 2) return dataTable;

  const header = dataTable[0];
  const rows = dataTable.slice(1);

  // Check which indexes are numeric columns
  const numericIndexes: number[] = [];

  for (let col = 1; col < header.length; col++) {
    // Skip role columns (style, annotation)
    if (typeof header[col] === 'object' && header[col].role) continue;

    // If at least one row has a number → it's numeric
    const hasNumber = rows.some(r => typeof r[col] === 'number');

    // If all are null → mark as numeric needing fix
    const allNull = rows.every(r => r[col] === null);

    if (allNull) {
      numericIndexes.push(col);
    }
  }

  // Fix first row for those numeric columns
  numericIndexes.forEach(col => {
    if (rows.length > 0 && rows[0][col] === null) {
      rows[0][col] = 0; // force number type
    }
  });

  // Return fixed table
  return [header, ...rows];
}
  //draw graph for Week over Week Spend categorized by Service Level and Aggregated Blended Rates (hidden view)
  drawgraph_selectedweekanddata(){



    this.testgraph = {
      chartType: 'ComboChart',
      dataTable: [
        ['X-Axis', 'Line Series', 'Bar Series 1', 'Bar Series 2', 'Bar Series 3', 'Bar Series 4'], // Header row
        ['Category 1', 10, 20, 30, 15, 5], // Data row 1
        ['Category 2', 15, 25, 35, 10, 10], // Data row 2
        ['Category 3', 20, 30, 25, 20, 5] // Data row 3
        // Add more rows as needed
      ],
      options: {
        bar: { groupWidth: '40%' },
        textPosition: 'none',
        isStacked: true, // Enable overall stacking for bars
    
        vAxes: {
          0: {
            title: 'ATA Rate ($)', // Title for the line chart axis
            gridlines: { color: 'transparent' }
          }
        },
        series: {
          0: { type: 'line', targetAxisIndex: 0 }, // Line series
          1: { type: 'bars', targetAxisIndex: 0 }, // Stacked bar series 1
          2: { type: 'bars', targetAxisIndex: 0 }, // Stacked bar series 2
          3: { type: 'bars', targetAxisIndex: 0 }, // Stacked bar series 3
          4: { type: 'bars', targetAxisIndex: 0 }  // Stacked bar series 4
        },
    
        legend: { position: 'top', alignment: 'center' },
        hAxis: {
          gridlines: { color: 'transparent' }
        },
        height: 290,
        pointSize: 6,
        colors: [
          '#000',  // Original color
          '#7dd7a3',  // Light green
          '#f1948a',
          '#d7ce7d',  // Light yellow-green
          '#7d7dce', // Light blue
          '#1f77b4'  // Blue
          // Add more colors as needed for additional series
        ]
      }
    };

    var  benchmark_combined_chart_W :any = {
        chartType: 'ComboChart',
        dataTable: [ /* Ensure this contains your combined data */ ],
        options: {
          chartArea: { width: '100%', height: '70%' },
          bar: { groupWidth: '40%' },
          textPosition: 'none',
          annotations: {
            textStyle: {
            color:'black',
            fontSize:12,
            fontWeight:'bold'
            }
          },

          vAxes: {
            0: {
              title: 'ATA Rate ($)', // Title for the line chart axis
              gridlines: { color: 'transparent' },
              minValue: 0, // Set your desired minimum value
              maxValue: 8 // Set your desired maximum value
              
            }
          },
          series: {
            0: { type: 'line', targetAxisIndex: 0 ,lineWidth: 0}, // Line series
            1: { type: 'line', targetAxisIndex: 0 ,lineWidth: 0,color:'red'}, // Line series
            2: { type: 'bars', targetAxisIndex: 0, isStacked: true }, // Stacked bar series
            3: { type: 'bars', targetAxisIndex: 0, isStacked: true }, // Stacked bar series
            4: { type: 'bars', targetAxisIndex: 0, isStacked: true }, // Stacked bar series
            5: { type: 'bars', targetAxisIndex: 0, isStacked: true }, // Stacked bar series
            6: { type: 'bars', targetAxisIndex: 0, isStacked: true }, // Stacked bar series
            7: { type: 'bars', targetAxisIndex: 0, isStacked: true }, // Stacked bar series
            8: { type: 'bars', targetAxisIndex: 0, isStacked: true }, // Stacked bar series
            9: { type: 'bars', targetAxisIndex: 0, isStacked: true }, // Stacked bar series
            10: { type: 'bars', targetAxisIndex: 0, isStacked: true }, // Stacked bar series2: { type: 'bars', targetAxisIndex: 0, isStacked: true }, // Stacked bar series
            11: { type: 'bars', targetAxisIndex: 0, isStacked: true }, // Stacked bar series
            12: { type: 'bars', targetAxisIndex: 0, isStacked: true }, // Stacked bar series
            13: { type: 'bars', targetAxisIndex: 0, isStacked: true }, // Stacked bar series
            14: { type: 'bars', targetAxisIndex: 0, isStacked: true }, // Stacked bar series
            15: { type: 'bars', targetAxisIndex: 0, isStacked: true }, // Stacked bar series 11: { type: 'bars', targetAxisIndex: 0, isStacked: true }, // Stacked bar series
            16: { type: 'bars', targetAxisIndex: 0, isStacked: true }, // Stacked bar series

          },

          isStacked: true,
  
          // legend: { position: 'top', alignment: 'center' },
          hAxis: {
            gridlines: { color: 'transparent' }
          },
          height: 290,
          pointSize: 6,
      
        // ]
        colors:[
          '#000',  // Original color
          '#000', 
          'black' // Light green
    
        ]
      
        }
    };


    var distinc_Week_chart= this.price_model_Avg_partner
    .map((item:any) => item.Week_Start)
    .filter(
        (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
    );
    this.distinc_Week_chart=distinc_Week_chart;

    this.get_monthyear();

   
    console.log(this.distinc_Week_chart)

    this.week_partner_chart=[]

    distinc_Week_chart.forEach((weeks:any) => {
      
      //////console.log(weeks);
      //////console.log(this.price_model_Avg_partner);

      
      var price_model_Avg = this.price_model_Avg_partner.filter((data:any)=>data.Week_Start==weeks);

      var datatable=[]
      var datatableatd=[]
      var datatabledta=[]
      var datatabledtd=[]
      var datatable_def=[]
      var datatableatd_def=[]
      var datatabledta_def=[]
      var datatabledtd_def=[]
      var datatable_exp=[]
      var datatableatd_exp=[]
      var datatabledta_exp=[]
      var datatabledtd_exp=[]




    datatable.push(['Week','Blended Avg Rate ($)','Avg Rate all service level', 'Transportation',{role:'style'}, 'Fuel',{role:'style'},'Security',{role:'style'},'Screening',{role:'style'},{ role: 'annotation', p: { style: 'color: black' } }]);
    datatabledta.push(['Week','Blended Avg Rate ($)','Avg Rate all service level', 'Transportation',{role:'style'}, 'Fuel',{role:'style'},'Security',{role:'style'},'Screening',{role:'style'},'Origin Charges',{role:'style'} ,'Pick Up Charges',{role:'style'},{ role: 'annotation', p: { style: 'color: black' } }]);
    datatabledtd.push(['Week','Blended Avg Rate ($)','Avg Rate all service level', 'Transportation',{role:'style'}, 'Fuel',{role:'style'},'Security',{role:'style'},'Screening',{role:'style'},'Origin',{role:'style'},'Pick Up',{role:'style'},'Destination',{role:'style'},{ role: 'annotation', p: { style: 'color: black' } }]);    
    datatableatd.push(['Week','Blended Avg Rate ($)','Avg Rate all service level', 'Transportation',{role:'style'}, 'Fuel Surcharge',{role:'style'},'Security Surcharge',{role:'style'},'Screening Surcharge',{role:'style'},'Destination Charges',{role:'style'},{ role: 'annotation', p: { style: 'color: black' } }]);


    datatable_def.push(['Week','Blended Avg Rate ($)','Avg Rate all service level', 'Transportation',{role:'style'}, 'Fuel',{role:'style'},'Security',{role:'style'},'Screening',{role:'style'},{ role: 'annotation', p: { style: 'color: black' } }]);
    datatabledta_def.push(['Week','Blended Avg Rate ($)','Avg Rate all service level', 'Transportation',{role:'style'}, 'Fuel',{role:'style'},'Security',{role:'style'},'Screening',{role:'style'},'Origin Charges',{role:'style'} ,'Pick Up Charges',{role:'style'},{ role: 'annotation', p: { style: 'color: black' } }]);
    datatabledtd_def.push(['Week','Blended Avg Rate ($)','Avg Rate all service level', 'Transportation',{role:'style'}, 'Fuel',{role:'style'},'Security',{role:'style'},'Screening',{role:'style'},'Origin',{role:'style'},'Pick Up',{role:'style'},'Destination',{role:'style'},{ role: 'annotation', p: { style: 'color: black' } }]);    
    datatableatd_def.push(['Week','Blended Avg Rate ($)','Avg Rate all service level', 'Transportation',{role:'style'}, 'Fuel Surcharge',{role:'style'},'Security Surcharge',{role:'style'},'Screening Surcharge',{role:'style'},'Destination Charges',{role:'style'},{ role: 'annotation', p: { style: 'color: black' } }]);


     datatable_exp.push(['Week','Blended Avg Rate ($)','Avg Rate all service level', 'Transportation',{role:'style'}, 'Fuel',{role:'style'},'Security',{role:'style'},'Screening',{role:'style'},{ role: 'annotation', p: { style: 'color: black' } }]);
    datatabledta_exp.push(['Week','Blended Avg Rate ($)','Avg Rate all service level', 'Transportation',{role:'style'}, 'Fuel',{role:'style'},'Security',{role:'style'},'Screening',{role:'style'},'Origin Charges',{role:'style'} ,'Pick Up Charges',{role:'style'},{ role: 'annotation', p: { style: 'color: black' } }]);
    datatabledtd_exp.push(['Week','Blended Avg Rate ($)','Avg Rate all service level', 'Transportation',{role:'style'}, 'Fuel',{role:'style'},'Security',{role:'style'},'Screening',{role:'style'},'Origin',{role:'style'},'Pick Up',{role:'style'},'Destination',{role:'style'},{ role: 'annotation', p: { style: 'color: black' } }]);    
    datatableatd_exp.push(['Week','Blended Avg Rate ($)','Avg Rate all service level', 'Transportation',{role:'style'}, 'Fuel Surcharge',{role:'style'},'Security Surcharge',{role:'style'},'Screening Surcharge',{role:'style'},'Destination Charges',{role:'style'},{ role: 'annotation', p: { style: 'color: black' } }]);


    console.log(price_model_Avg);
    var max_rate=0;
    var max_rate_atd=0;
    var max_rate_dta=0;
    var max_rate_dtd=0;

    price_model_Avg.forEach((element:any) => {

    var max=  this.getMaxValueFromKeys(element,['STD PeakRate (=ATA+PS)','DEF PeakRate (=ATA+PS)','EXP PeakRate (=ATA+PS)'])
      
    if(max>max_rate)
       max_rate=max;

    var max=  this.getMaxValueFromKeys(element,['STD PeakRate (=DTA+PS)','DEF PeakRate (=DTA+PS)','EXP PeakRate (=DTA+PS)'])
      
    if(max>max_rate_dta)
      max_rate_dta=max;

    var max=  this.getMaxValueFromKeys(element,['STD PeakRate (=DTD+PS)','DEF PeakRate (=DTD+PS)','EXP PeakRate (=DTD+PS)'])
      
    if(max>max_rate_dtd)
      max_rate_dtd=max;

    var max=  this.getMaxValueFromKeys(element,['STD PeakRate (=ATD+PS)','DEF PeakRate (=ATD+PS)','EXP PeakRate (=ATD+PS)'])
      
    if(max>max_rate_atd)
      max_rate_atd=max;

      var weekdata= this.weekgroup_servicelevel_partner.filter((data:any)=>{return data.Week_Start==weeks && data.PARTNER ==element.PARTNER})
      //////console.log(weekdata)
      var stda= weekdata.filter((data:any)=>{return data['Service Level']=='STD'})
      var expa= weekdata.filter((data:any)=>{return data['Service Level']=='EXP'})
      var defa= weekdata.filter((data:any)=>{return data['Service Level']=='DEF'})

 

      var std=0;
      if(stda.length>0)
        std=stda[0]['Partner_Blended_Spend']
      var exp=0;
      if(expa.length>0)
        exp=expa[0]['Partner_Blended_Spend']
      var def=0;
      if(defa.length>0)
        def=defa[0]['Partner_Blended_Spend']

      var stdv=0;
      if(stda.length>0)
        stdv=stda[0]['COB_WEIGHT_CHARGEABLE']
      var expv=0;
      if(expa.length>0)
        expv=expa[0]['COB_WEIGHT_CHARGEABLE']
      var defv=0;
      if(defa.length>0)
        defv=defa[0]['COB_WEIGHT_CHARGEABLE']

      var avg = (std+def+exp)/(stdv+expv+defv);

    

      datatable.push([element.PARTNER,avg,((element['STD PeakRate (=ATA+PS)']+element['DEF PeakRate (=ATA+PS)']+element['EXP PeakRate (=ATA+PS)'])/3), element['af_Total_STD'],this.colors.Transportation, element['fsc_Total_STD'],this.colors.Fuel,element['scr_Sur_Total_STD'],this.colors.Screening,element['sct_Sur_Total_STD'],this.colors.Security,'$'+element['STD PeakRate (=ATA+PS)'].toLocaleString(this.lc,this.opt1)])


      datatabledta.push([element.PARTNER,avg,((element['DEF PeakRate (=DTA+PS)']+element['STD PeakRate (=DTA+PS)']+element['EXP PeakRate (=DTA+PS)'])/3), element['af_Total_STD'],this.colors.Transportation, element['fsc_Total_STD'],this.colors.Fuel,element['scr_Sur_Total_STD'],this.colors.Screening,element['sct_Sur_Total_STD'],this.colors.Security, element['ow_Total_STD'] + element['ow_programm_Total_STD']+element['ow_Scr_Total_STD']+element['ow_security_Total_STD'],this.colors.Origin,element['pp_Total_STD'],this.colors.PickUp,'$'+element['STD PeakRate (=DTA+PS)'].toLocaleString(this.lc,this.opt1)])


      datatabledtd.push([element.PARTNER,avg,((element['DEF PeakRate (=DTD+PS)']+element['STD PeakRate (=DTD+PS)']+element['EXP PeakRate (=DTD+PS)'])/3), element['af_Total_STD'],this.colors.Transportation, element['fsc_Total_STD'],this.colors.Fuel,element['scr_Sur_Total_STD'],this.colors.Screening,element['sct_Sur_Total_STD'],this.colors.Security, element['ow_Total_STD']+ element['ow_programm_Total_STD']+element['ow_Scr_Total_STD']+element['ow_security_Total_STD'],this.colors.Origin,element['pp_Total_STD'],this.colors.PickUp, element['destinationmin_Total_STD']+ element['dw_programm_Total_STD']+element['dw_Scr_Total_STD']+element['dw_security_Total_STD']+element['dlpw_Total_STD'],this.colors.Destination,'$'+element['STD PeakRate (=DTD+PS)'].toLocaleString(this.lc,this.opt1)])

      datatableatd.push([element.PARTNER,avg,((element['DEF PeakRate (=ATD+PS)']+element['STD PeakRate (=ATD+PS)']+element['EXP PeakRate (=ATD+PS)'])/3), element['af_Total_STD'],this.colors.Transportation, element['fsc_Total_STD'],this.colors.Fuel,element['scr_Sur_Total_STD'],this.colors.Screening,element['sct_Sur_Total_STD'],this.colors.Security, element['destinationmin_Total_STD']+ element['dw_programm_Total_STD']+element['dw_Scr_Total_STD']+element['dw_security_Total_STD']+element['dlpw_Total_STD'],this.colors.Destination,'$'+element['STD PeakRate (=ATD+PS)'].toLocaleString(this.lc,this.opt1)])


      datatable_def.push([element.PARTNER,avg,((element['DEF PeakRate (=ATA+PS)']+element['STD PeakRate (=ATA+PS)']+element['EXP PeakRate (=ATA+PS)'])/3), element['af_Total_DEF'],this.colors.Transportation, element['fsc_Total_DEF'],this.colors.Fuel,element['scr_Sur_Total_DEF'],this.colors.Screening,element['sct_Sur_Total_DEF'],this.colors.Security,'$'+element['DEF PeakRate (=ATA+PS)'].toLocaleString(this.lc,this.opt1)])


      datatabledta_def.push([element.PARTNER,avg,((element['DEF PeakRate (=DTA+PS)']+element['STD PeakRate (=DTA+PS)']+element['EXP PeakRate (=DTA+PS)'])/3), element['af_Total_DEF'],this.colors.Transportation, element['fsc_Total_DEF'],this.colors.Fuel,element['scr_Sur_Total_DEF'],this.colors.Screening,element['sct_Sur_Total_DEF'],this.colors.Security, element['ow_Total_DEF'] + element['ow_programm_Total_DEF']+element['ow_Scr_Total_DEF']+element['ow_security_Total_DEF'],this.colors.Origin,element['pp_Total_DEF'],this.colors.PickUp,'$'+element['DEF PeakRate (=DTA+PS)'].toLocaleString(this.lc,this.opt1)])


      datatabledtd_def.push([element.PARTNER,avg,((element['DEF PeakRate (=DTD+PS)']+element['STD PeakRate (=DTD+PS)']+element['EXP PeakRate (=DTD+PS)'])/3), element['af_Total_DEF'],this.colors.Transportation, element['fsc_Total_DEF'],this.colors.Fuel,element['scr_Sur_Total_DEF'],this.colors.Screening,element['sct_Sur_Total_DEF'],this.colors.Security, element['ow_Total_DEF']+ element['ow_programm_Total_DEF']+element['ow_Scr_Total_DEF']+element['ow_security_Total_DEF'],this.colors.Origin,element['pp_Total_DEF'],this.colors.PickUp, element['destinationmin_Total_DEF']+ element['dw_programm_Total_DEF']+element['dw_Scr_Total_DEF']+element['dw_security_Total_DEF']+element['dlpw_Total_DEF'],this.colors.Destination,'$'+element['DEF PeakRate (=DTD+PS)'].toLocaleString(this.lc,this.opt1)])

      datatableatd_def.push([element.PARTNER,avg,((element['DEF PeakRate (=ATD+PS)']+element['STD PeakRate (=ATD+PS)']+element['EXP PeakRate (=ATD+PS)'])/3), element['af_Total_DEF'],this.colors.Transportation, element['fsc_Total_DEF'],this.colors.Fuel,element['scr_Sur_Total_DEF'],this.colors.Screening,element['sct_Sur_Total_DEF'],this.colors.Security, element['destinationmin_Total_DEF']+ element['dw_programm_Total_DEF']+element['dw_Scr_Total_DEF']+element['dw_security_Total_DEF']+element['dlpw_Total_DEF'],this.colors.Destination,'$'+element['DEF PeakRate (=ATD+PS)'].toLocaleString(this.lc,this.opt1)])


      datatable_exp.push([element.PARTNER,avg,((element['DEF PeakRate (=ATA+PS)']+element['STD PeakRate (=ATA+PS)']+element['EXP PeakRate (=ATA+PS)'])/3), element['af_Total_EXP'],this.colors.Transportation, element['fsc_Total_EXP'],this.colors.Fuel,element['scr_Sur_Total_EXP'],this.colors.Screening,element['sct_Sur_Total_EXP'],this.colors.Security,'$'+element['EXP PeakRate (=ATA+PS)'].toLocaleString(this.lc,this.opt1)])


      datatabledta_exp.push([element.PARTNER,avg,((element['DEF PeakRate (=DTA+PS)']+element['STD PeakRate (=DTA+PS)']+element['EXP PeakRate (=DTA+PS)'])/3), element['af_Total_EXP'],this.colors.Transportation, element['fsc_Total_EXP'],this.colors.Fuel,element['scr_Sur_Total_EXP'],this.colors.Screening,element['sct_Sur_Total_EXP'],this.colors.Security, element['ow_Total_EXP'] + element['ow_programm_Total_EXP']+element['ow_Scr_Total_EXP']+element['ow_security_Total_EXP'],this.colors.Origin,element['pp_Total_EXP'],this.colors.PickUp,'$'+element['EXP PeakRate (=DTA+PS)'].toLocaleString(this.lc,this.opt1)])


      datatabledtd_exp.push([element.PARTNER,avg,((element['DEF PeakRate (=DTD+PS)']+element['STD PeakRate (=DTD+PS)']+element['EXP PeakRate (=DTD+PS)'])/3), element['af_Total_EXP'],this.colors.Transportation, element['fsc_Total_EXP'],this.colors.Fuel,element['scr_Sur_Total_EXP'],this.colors.Screening,element['sct_Sur_Total_EXP'],this.colors.Security, element['ow_Total_EXP']+ element['ow_programm_Total_EXP']+element['ow_Scr_Total_EXP']+element['ow_security_Total_EXP'],this.colors.Origin,element['pp_Total_EXP'],this.colors.PickUp, element['destinationmin_Total_EXP']+ element['dw_programm_Total_EXP']+element['dw_Scr_Total_EXP']+element['dw_security_Total_EXP']+element['dlpw_Total_EXP'],this.colors.Destination,'$'+element['EXP PeakRate (=DTD+PS)'].toLocaleString(this.lc,this.opt1)])

      datatableatd_exp.push([element.PARTNER,avg,((element['DEF PeakRate (=ATD+PS)']+element['STD PeakRate (=ATD+PS)']+element['EXP PeakRate (=ATD+PS)'])/3), element['af_Total_EXP'],this.colors.Transportation, element['fsc_Total_EXP'],this.colors.Fuel,element['scr_Sur_Total_EXP'],this.colors.Screening,element['sct_Sur_Total_EXP'],this.colors.Security, element['destinationmin_Total_EXP']+ element['dw_programm_Total_EXP']+element['dw_Scr_Total_EXP']+element['dw_security_Total_EXP']+element['dlpw_Total_EXP'],this.colors.Destination,'$'+element['EXP PeakRate (=ATD+PS)'].toLocaleString(this.lc,this.opt1)])
     

    });

    benchmark_combined_chart_W.options.vAxes[0].maxValue=max_rate;
    benchmark_combined_chart_W.dataTable= this.fixNullNumericColumns(datatable);

    if(datatable.length<2){
      benchmark_combined_chart_W.options.bar.groupWidth="2%"
    }
    else if(datatable.length>=2&&datatable.length<4){
      benchmark_combined_chart_W.options.bar.groupWidth="20%"
    }

    var price_model_rate_Chart=JSON.parse(JSON.stringify(benchmark_combined_chart_W));

    benchmark_combined_chart_W.dataTable= this.fixNullNumericColumns(datatable_def);
    if(datatable_def.length<2){
      benchmark_combined_chart_W.options.bar.groupWidth="2%"
    }
    else if(datatable_def.length>=2&&datatable_def.length<4){
      benchmark_combined_chart_W.options.bar.groupWidth="20%"
    }
    var price_model_rate_Chart_def=JSON.parse(JSON.stringify(benchmark_combined_chart_W));


    benchmark_combined_chart_W.dataTable=this.fixNullNumericColumns(datatable_exp);
    if(datatable_exp.length<2){
      benchmark_combined_chart_W.options.bar.groupWidth="2%"
    }
    else if(datatable_exp.length>=2&&datatable_exp.length<4){
      benchmark_combined_chart_W.options.bar.groupWidth="20%"
    }
    var price_model_rate_Chart_exp=JSON.parse(JSON.stringify(benchmark_combined_chart_W));


    // dta

    benchmark_combined_chart_W.dataTable=this.fixNullNumericColumns(datatabledta);
    benchmark_combined_chart_W.options.vAxes[0].maxValue=max_rate_dta;

    if(datatabledta.length<2){
      benchmark_combined_chart_W.options.bar.groupWidth="2%"
    }
    else if(datatabledta.length>=2&&datatabledta.length<4){
      benchmark_combined_chart_W.options.bar.groupWidth="20%"
    }
    var price_model_rate_Chartdta=JSON.parse(JSON.stringify(benchmark_combined_chart_W));

    benchmark_combined_chart_W.dataTable=this.fixNullNumericColumns(datatabledta_def);

    if(datatabledta_def.length<2){
      benchmark_combined_chart_W.options.bar.groupWidth="2%"
    }
    else if(datatabledta_def.length>=2&&datatabledta_def.length<4){
      benchmark_combined_chart_W.options.bar.groupWidth="20%"
    }
    var price_model_rate_Chartdta_def=JSON.parse(JSON.stringify(benchmark_combined_chart_W));





    benchmark_combined_chart_W.dataTable=this.fixNullNumericColumns(datatabledta_exp);

    if(datatabledta_exp.length<2){
      benchmark_combined_chart_W.options.bar.groupWidth="2%"
    }
    else if(datatabledta_exp.length>=2&&datatabledta_exp.length<4){
      benchmark_combined_chart_W.options.bar.groupWidth="20%"
    }
    var price_model_rate_Chartdta_exp=JSON.parse(JSON.stringify(benchmark_combined_chart_W));


    //atd

    benchmark_combined_chart_W.dataTable=this.fixNullNumericColumns(datatableatd);
    benchmark_combined_chart_W.options.vAxes[0].maxValue=max_rate_atd;


    if(datatableatd.length<2){
      benchmark_combined_chart_W.options.bar.groupWidth="2%"
    }
    else if(datatableatd.length>=2&&datatabledta.length<4){
      benchmark_combined_chart_W.options.bar.groupWidth="20%"
    }
    var price_model_rate_Chartatd=JSON.parse(JSON.stringify(benchmark_combined_chart_W));


    benchmark_combined_chart_W.dataTable=this.fixNullNumericColumns(datatableatd_def);

    if(datatableatd_def.length<2){
      benchmark_combined_chart_W.options.bar.groupWidth="2%"
    }
    else if(datatableatd_def.length>=2&&datatabledta_def.length<4){
      benchmark_combined_chart_W.options.bar.groupWidth="20%"
    }
    var price_model_rate_Chartatd_def=JSON.parse(JSON.stringify(benchmark_combined_chart_W));


    benchmark_combined_chart_W.dataTable=this.fixNullNumericColumns(datatableatd_exp);

    if(datatableatd_exp.length<2){
      benchmark_combined_chart_W.options.bar.groupWidth="2%"
    }
    else if(datatableatd_exp.length>=2&&datatabledta_exp.length<4){
      benchmark_combined_chart_W.options.bar.groupWidth="20%"
    }
    var price_model_rate_Chartatd_exp=JSON.parse(JSON.stringify(benchmark_combined_chart_W));


    //dtd

    benchmark_combined_chart_W.dataTable=this.fixNullNumericColumns(datatabledtd);
    benchmark_combined_chart_W.options.vAxes[0].maxValue=max_rate_dtd;

    if(datatabledtd.length<2){
      benchmark_combined_chart_W.options.bar.groupWidth="2%"
    }
    else if(datatabledtd.length>=2&&datatabledta.length<4){
      benchmark_combined_chart_W.options.bar.groupWidth="20%"
    }
    var price_model_rate_Chartdtd=JSON.parse(JSON.stringify(benchmark_combined_chart_W));




   

   


    benchmark_combined_chart_W.dataTable=this.fixNullNumericColumns(datatabledtd_def);
    if(datatabledtd_def.length<2){
      benchmark_combined_chart_W.options.bar.groupWidth="2%"
    }
    else if(datatabledtd_def.length>=2&&datatabledta_def.length<4){
      benchmark_combined_chart_W.options.bar.groupWidth="20%"
    }

    var price_model_rate_Chartdtd_def=JSON.parse(JSON.stringify(benchmark_combined_chart_W));





    benchmark_combined_chart_W.dataTable=this.fixNullNumericColumns(datatabledtd_exp);
    if(datatabledtd_exp.length<2){
      benchmark_combined_chart_W.options.bar.groupWidth="2%"
    }
    else if(datatabledtd_exp.length>=2&&datatabledta_exp.length<4){
      benchmark_combined_chart_W.options.bar.groupWidth="20%"
    }
    var price_model_rate_Chartdtd_exp=JSON.parse(JSON.stringify(benchmark_combined_chart_W));


    this.week_partner_chart.push({week:weeks,ATA_STD:price_model_rate_Chart,ATD_STD:price_model_rate_Chartatd,DTD_STD:price_model_rate_Chartdtd,DTA_STD:price_model_rate_Chartdta,ATA_DEF:price_model_rate_Chart_def,ATD_DEF:price_model_rate_Chartatd_def,DTD_DEF:price_model_rate_Chartdtd_def,DTA_DEF:price_model_rate_Chartdta_def,ATA_exp:price_model_rate_Chart_exp,ATD_exp:price_model_rate_Chartatd_exp,DTD_exp:price_model_rate_Chartdtd_exp,DTA_exp:price_model_rate_Chartdta_exp});

  });
  console.log(this.week_partner_chart);

  
  var datatable=[]
    



    var benchmark_combined_chart_spend :any = {
      chartType: 'ComboChart',
      dataTable: [ /* Ensure this contains your combined data */ ],
      options: {
        bar: { groupWidth: '40%' },
        // chartArea: { width: '80%', height: '100%' },
        vAxes: {
          0: {
            gridlines: { color: 'transparent' },
            textPosition: 'none'
            
          },
          1: {
            gridlines: { color: 'transparent' },
            textPosition: 'none'
            
          }
        },
        series: {
          0: { type: 'line', targetAxisIndex: 1 }, // Line series
          1: { type: 'bars', targetAxisIndex: 0, isStacked: true }, // Stacked bar series
          2: { type: 'bars', targetAxisIndex: 0, isStacked: true }, // Stacked bar series
          3: { type: 'bars', targetAxisIndex: 0, isStacked: true }, // Stacked bar series
        },

        isStacked: true,
 
        legend: { position: 'top', alignment: 'center' },
        hAxis: {
          gridlines: { color: 'transparent' }
        },
        height: 270,
        pointSize: 6,
        colors:[
          '#000',  // Original color
'#7db8ce',  // Light teal
'#7dd7a3',  // Light green
'#f1948a',
'#ce7d7d',  // Light rose
'#d78f7a',  // Light coral
'#d7ce7d',  // Light yellow-green
'#7d7dce'  // Light blue
       
      ]
      
      }
    };


  datatable=[]
   var datatablev=[]

   

    datatable.push(['Week','Blended Avg Rate ($)','Total Spend for DEF ($)','Total Spend for STD ($)',  'Total Spend for EXP ($)']);
    datatablev.push(['Week','Blended Avg Rate ($)','Total Volume for DEF (kg)','Total Volume for STD (kg)',  'Total Volume for EXP (kg)']);

  
    this.distinct_week.forEach((element:any) => {
      
     var weekdata= this.weekgroup_servicelevel.filter((data:any)=>{return data.Week_Start==element})

      var stda= weekdata.filter((data:any)=>{return data['Service Level']=='STD'})
      var expa= weekdata.filter((data:any)=>{return data['Service Level']=='EXP'})
      var defa= weekdata.filter((data:any)=>{return data['Service Level']=='DEF'})

 

      var std=0;
      if(stda.length>0)
        std=stda[0]['Partner_Blended_Spend']
      var exp=0;
      if(expa.length>0)
        exp=expa[0]['Partner_Blended_Spend']
      var def=0;
      if(defa.length>0)
        def=defa[0]['Partner_Blended_Spend']

      var stdv=0;
      if(stda.length>0)
        stdv=stda[0]['COB_WEIGHT_CHARGEABLE']
      var expv=0;
      if(expa.length>0)
        expv=expa[0]['COB_WEIGHT_CHARGEABLE']
      var defv=0;
      if(defa.length>0)
        defv=defa[0]['COB_WEIGHT_CHARGEABLE']
      
      
      

      datatable.push([element,(std/stdv),def,std,exp]);
      datatablev.push([element,(std/stdv),defv,stdv,expv]);

    });

    benchmark_combined_chart_spend.dataTable=datatable;
    this.benchmark_combined_chart_spend=JSON.parse(JSON.stringify(benchmark_combined_chart_spend));

    ////////console.log(benchmark_combined_chart_spend);

    benchmark_combined_chart_spend.dataTable=datatablev;
    this.benchmark_combined_chart_volume=JSON.parse(JSON.stringify(benchmark_combined_chart_spend));



   };

// getting monthyear an
 get_monthyear(){
  var monthyear=this.weekly_avg_cost_model.filter((data:any) =>{ return  this.distinc_Week_chart.indexOf(data.FYQW)>-1});
  
  
 }


// events 

// event on click for month over month graph
selectweek(event:any,price:any,serv:any)
{

  var prev:any;
  if(event.row==0){
    prev=this.momlist[event.row];
  }else
  {
    prev=this.momlist[event.row-1];

  }
  // model to show price modeling rate details
  this.presentModal(this.momlist[event.row],prev,serv,price);

}



download_ratebook()
  {
    

    //console.log(this.ratebook_trendl);

    // let sampleJson: any = [];
    let datad = this.ratebook_trend_filtered;





 

    // 					over_penalty	tier2penalty	tier3penalty	over_penaltyv
    // smonthyear	lane	Service Provider	STD BaseRate (=ATA)	STD PeakRate (=ATA+PS)	STD OverallocationRate (=ATA + OAC)	STD BaseRate (=ATD)	STD PeakRate (=ATD+PS)	STD OverallocationRate (=ATD + OAC)	STD BaseRate (=DTA)	STD PeakRate (=DTA+PS)	STD OverallocationRate (=DTA + OAC)	STD BaseRate (=DTD)	STD PeakRate (=DTD+PS)	STD OverallocationRate (=DTD + OAC)	DEF BaseRate (=ATA)	DEF PeakRate (=ATA+PS)	DEF OverallocationRate (=ATA + OAC)	DEF BaseRate (=ATD)	DEF PeakRate (=ATD+PS)	DEF OverallocationRate (=ATD + OAC)	DEF BaseRate (=DTA)	DEF PeakRate (=DTA+PS)	DEF OverallocationRate (=DTA + OAC)	DEF BaseRate (=DTD)	DEF PeakRate (=DTD+PS)	DEF OverallocationRate (=DTD + OAC)	EXP BaseRate (=ATA)	EXP PeakRate (=ATA+PS)	EXP OverallocationRate (=ATA + OAC)	EXP BaseRate (=ATD)	EXP PeakRate (=ATD+PS)	EXP OverallocationRate (=ATD + OAC)	EXP BaseRate (=DTA)	EXP PeakRate (=DTA+PS)	EXP OverallocationRate (=DTA + OAC)	EXP BaseRate (=DTD)	EXP PeakRate (=DTD+PS)	EXP OverallocationRate (=DTD + OAC)	BaseCapacity (=Available Non Peak Capacity/KG)	PeakRateCapacity (=Available Peak/HDRA Capacity/KG)	af_Total_STD	fsc_Total_STD	scr_Sur_Total_STD	sct_Sur_Total_STD	ow_Total_STD	ow_programm_Total_STD	ow_Scr_Total_STD	ow_security_Total_STD	pp_Total_STD	destinationmin_Total_STD	dw_programm_Total_STD	dw_Scr_Total_STD	dw_security_Total_STD	dlpw_Total_STD	pss_Total_STD	af_Total_DEF	fsc_Total_DEF	scr_Sur_Total_DEF	sct_Sur_Total_DEF	ow_Total_DEF	ow_programm_Total_DEF	ow_Scr_Total_DEF	ow_security_Total_DEF	pp_Total_DEF	destinationmin_Total_DEF	dw_programm_Total_DEF	dw_Scr_Total_DEF	dw_security_Total_DEF	dlpw_Total_DEF	pss_Total_DEF	af_Total_EXP	fsc_Total_EXP	scr_Sur_Total_EXP	sct_Sur_Total_EXP	ow_Total_EXP	ow_programm_Total_EXP	ow_Scr_Total_EXP	ow_security_Total_EXP	pp_Total_EXP	destinationmin_Total_EXP	dw_programm_Total_EXP	dw_Scr_Total_EXP	dw_security_Total_EXP	dlpw_Total_EXP	pss_Total_EXP	
    //         				total_spend	total_volume	
    // Step 1: Define the columns you want to include and their new names
    const selectedColumns: { [key: string]: string } = {
      "smonthyear": "Month",
      "lane": "Lane",
      "Service Provider":"Partner",
      "STD PeakRate (=ATA+PS)": "STD PeakRate (=ATA)",
      "WAVG ATA":"IATA WAVG ATA STD",
      "DEF PeakRate (=ATA+PS)": "DEF PeakRate (=ATA)",
      "WAVG ATA DEF":"IATA WAVG ATA DEF",
      "EXP PeakRate (=ATA+PS)": "EXP PeakRate (=ATA)",
      "WAVG ATA EXP":"IATA WAVG ATA EXP"
      // Add more key mappings as needed
    };
    
   // Step 2: Map the data to include only selected columns with renamed keys
    const week_allocation = datad.map((item:any )=> {
      const newItem: any = {};
      for (let key in selectedColumns) {
        if (item.hasOwnProperty(key)) {
          newItem[selectedColumns[key]] = item[key];
        }
      }
      return newItem;
    });
    
    // Step 3: Convert to Excel-compatible format
    const keysList = Object.keys(week_allocation[0]);
    const data = week_allocation.map((obj :any)=> Object.values(obj));
    data.unshift(keysList); // Add header
    
    // Step 4: Create and write the Excel file
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
    
    workbook.SheetNames.push("Filtered Data");
    workbook.Sheets["Filtered Data"] = worksheet;
    
    XLSX.writeFile(workbook, 'Month Over Month Ratebook Data.xlsx');
  }
// event for tab3 graphs
select(event:any) {
  //console.log(event)
  if(event.selectedRowValues.length>0)
  {
    // var alldatalane= this.prediction_list_all_lane.filter(function(item:any){return item['Lane']===this.LaneLis})

     //console.log(event.row,event.column);
     this.gotopartner(this.graphlist[this.capgraphindex].graph.dataTable[event.row+1][0],this.graphlist[this.capgraphindex].data.split("-")[0],this.graphlist[this.capgraphindex].data.split("-")[1])
  }
}

async gotopartner(week:any,origin:any,destination:any) {
  const modal = await this.modalController.create({
    component: PartnerdetailsComponent,
    componentProps: {
       weekdata: week,
       origin:origin,
       destination:destination
    }
  });
  return await modal.present();
}


// model to show rate details
async presentModal(element:any,preelement:any,serv:any,price:any) {
    const modal = await this.modalController.create({
      component: RatebookmompopupComponent,
      cssClass: 'custom-modal',
      componentProps: {
      //  bardata: this.bars
      element:element,
      preelement:preelement,
      serv:serv,
      price:price,
      }
    });
    return await modal.present();
}

ratebook_trend:any=[]


// custoized tooltip for MOM rate grapg
tooltipHtml(element:any,prevelement:any,serv:any,price:any) {
    ////console.log(element)
    var key=serv+' PeakRate (='+price+'+PS)';
    ////console.log(key)
    var icon=""
    if(element[key]-prevelement[key]>0)
    {
      icon= `<ion-icon  style="color:red;font-size:28px;margin: -1px; align-items: center;" name="arrow-dropup"></ion-icon>`
               
    }else{
      icon= `<ion-icon  style="color:green;font-size:28px;margin: -1px; align-items: center;" name="arrow-dropdown"></ion-icon>`

    }
    return `
      <div id="customers" style="padding: 10px; border: 1px solid #ccc;width:250px">
      <h6 style="margin:0px;font-size:12px">${serv} ${price}</h6>
      <table style="border-collapse: collapse; width: 100%; border: 1px solid #e5e7e9;text-align:left">
         <tr><th style="border: 1px solid #e5e7e9; padding: 4px;">${element['smonthyear']} </th><td colspan="2" style="border: 1px solid #e5e7e9; padding: 4px;"> $ ${element[key].toLocaleString(this.lc,this.opt1)}</td></tr>
          <tr><th style="border: 1px solid #e5e7e9; padding: 4px;">${prevelement['smonthyear']} </th><td colspan="2" style="border: 1px solid #e5e7e9; padding: 4px;"> $ ${prevelement[key].toLocaleString(this.lc,this.opt1)}</td></tr>
          <tr><th style="border: 1px solid #e5e7e9; padding: 4px;">MOM Change </th><td style="border: 1px solid #e5e7e9; padding: 4px;"> $ ${(element[key]-prevelement[key]).toLocaleString(this.lc,this.opt1)} (${(((element[key]-prevelement[key])/prevelement[key])*100).toLocaleString(this.lc,this.opt1)}%)
           </td><td>`+icon+`</td></tr>

      </table>
     
    `;

     //   <strong>${element['STD PeakRate (=ATA+PS)'].toLocaleString(this.lc,this.opt1)}</strong><br/>
      //    ${prevelement['STD PeakRate (=ATA+PS)'].toLocaleString(this.lc,this.opt1)}<br/>
      //   Diff: ${(prevelement['STD PeakRate (=ATA+PS)']-element['STD PeakRate (=ATA+PS)']).toLocaleString(this.lc,this.opt1)}
      // </div>
}

momlist:any;
iatatogle=false;

cleanArrayObjects(array:any, key:any) {
    return array.filter((item:any) => {
      // Check if the value of the specified key is not null, zero, or empty
      return item[key] !== null && item[key] !== 0 && item[key] !== '';
    });
}

removeDuplicatesByKeys(array:any, keys:any) {
      const seen = new Set(); // To track unique key combinations
      return array.filter((item:any) => {
        // Generate a unique key based on the values of the selected keys
        const keyGroup = keys.map((key:any) => item[key]).join('|'); // Use `|` to join key values
        if (seen.has(keyGroup)) {
          return false; // If this combination of key values has been seen, skip it
        } else {
          seen.add(keyGroup); // Otherwise, add the combination to the set
          return true; // Keep the current object
        }
      });
}

fop=0;
set_toplane(){
  this.fop=1;
}
filter_toplane(){

  if(this.toplaneoption==6){
    this.fop=0;
    this.clear_lane();

  }
  else if(this.toplaneoption==0){
    this.selectedItems=[]

    this.toplane_spend.forEach((element:any) => {
      this.selectedItems.push(element.Lane)

      
    });
    this.fop=0;

    this.filter_data();


  }else if(this.toplaneoption==1){
    this.selectedItems=[]

    this.toplane_volume.forEach((element:any) => {
      this.selectedItems.push(element.Lane)

      
    });
    this.fop=0;

    //console.log(this.selectedItems);
    this.filter_data();

  }
  else if(this.toplaneoption==2){
    this.selectedItems=[]

    this.toplane_spend.slice(0,20).forEach((element:any) => {
      this.selectedItems.push(element.Lane)

      
    });
    this.fop=0;

    this.filter_data();


  }else if(this.toplaneoption==3){
    this.selectedItems=[]

    this.toplane_volume.slice(0,20).forEach((element:any) => {
      this.selectedItems.push(element.Lane)

      
    });
    this.fop=0;

    //console.log(this.selectedItems);
    this.filter_data();

  }
  else if(this.toplaneoption==4){
    this.selectedItems=[]

    this.toplane_spend.slice(0,10).forEach((element:any) => {
      this.selectedItems.push(element.Lane)

      
    });
    this.fop=0;

    this.filter_data();


  }else if(this.toplaneoption==5){
    this.selectedItems=[]

    this.toplane_volume.slice(0,10).forEach((element:any) => {
      this.selectedItems.push(element.Lane)

      
    });
    this.fop=0;

    //console.log(this.selectedItems);
    this.filter_data();

  }


  this.draw_month_over_trend_new();
  this.draw_month_over_trend_new_without();
}

draw_trend_line_volue(){
  var LineChartdata:any = {
    chartType: 'LineChart', // Use LineChart for line-based charts
    dataTable: [], // Ensure temp is the correct data for your chart
    options: {
      title: "",
      
      hAxis: {
        gridlines: {
          color: 'transparent'
        },
        slantedText: true,  // Rotate x-axis labels
        slantedTextAngle: 45,  // Rotate the text at a 45-degree angle for better fit
        textStyle: { fontSize: 10 }
      },
      vAxis: {
        gridlines: {
          color: 'transparent'
        } ,
        slantedText: true,  // Rotate x-axis labels
        slantedTextAngle: 45,  // Rotate the text at a 45-degree angle for better fit
        textStyle: { fontSize: 10 }
      },
      
      pointSize: 3,
      legend: {
        position: 'top',
        alignment: 'center',
        textStyle: { fontSize: 14 }
      },

  
      // Configure other chart appearance
      colors: ['#FAD7A0','#AED6F1',  '#7FB3D5', '#2C3E50'], // Bar colors, these can be removed since we're using lines
      chartArea: { 'width': '80%', 'height': '70%' },
      
      height: 360,
    }
  };
  var datatable:any=[]
  
  datatable.push(['Week','Air Volume','Ocean Volume'])
  var k=0;

  // var distinctwek=this.getDistinctKeyDistrict(this.air_data_filtered,this.ocean_filtered,'FYQW');

  // console.log(this.distinc_Week_chart);
  this.distinc_Week_chart.reverse();

  this.distinc_Week_chart.forEach((el:any) => {
    var element =el

   var airlist= this.air_data_filtered.filter((res:any)=>{ return res.FYQW==element});
   var oceanlist= this.ocean_filtered.filter((res:any)=>{return res.FYQW==element});

   console.log(airlist,oceanlist,element)
    var air=null,ocean=null;

    if(airlist.length>0)
    {
      if(airlist[0]['COB_WEIGHT_CHARGEABLE']>0){
        air=airlist[0]['COB_WEIGHT_CHARGEABLE'];
      }

    }
    if(oceanlist.length>0)
    {
      if(oceanlist[0]['OCEAN_WEIGHT_CHARGEABLE']>0){
        ocean=oceanlist[0]['OCEAN_WEIGHT_CHARGEABLE'];
      }
    }
    datatable.push([element,air,ocean]);
    k++;
    
  });

  if(datatable.length>1){
    if(datatable[1][2]==null)
      datatable[1][2]=0
    if(datatable[1][1]==null)
      datatable[1][1]=0
  }


  // console.log(datatable);


  LineChartdata.dataTable=datatable;
  this.airtrend_graph = JSON.parse(JSON.stringify(LineChartdata));
  

}

 
 airtrend_graph:any;
 wavg_list:any=[]
  




  


  fitlered_data:any=[]
  fitlered_data_details:any=[]
  filtered_data_all:any=[]
 

  

  
   
   distinct_service:any=[]
   distinct_pricemodel:any=[]
   price_model_Avg:any=[];

   distinct_week:any=[]
   weekgroup_servicelevel:any=[]
   price_model_global_avg:any=[]
   weekl_golbal_spend:any=[]
   price_model_Avg_partner:any=[]
   weekgroup_servicelevel_partner:any=[]

   monthslist:any=[]

  
   
 



   pricemodel_spend:any=[]

  removeUnderscoreX(data:any) {
    return data.map((obj:any) => {
      const newObj:any= {};
      for (const key in obj) {
        // Check if the key ends with "" and remove it
        const newKey = key.endsWith('') ? key.slice(0, -2) : key;
        newObj[newKey] = obj[key]; // Assign the value to the new key
      }
      return newObj;
    });
  }

  groupByAndSum_m(data:any, groupKeys:any, sumKeys:any) {
    return data.reduce((acc:any, obj:any) => {
      // Create a unique key based on the grouping keys
      const groupKey = groupKeys.map((key:any) => obj[key]).join('|');
      
      // If the group doesn't exist, create it
      if (!acc[groupKey]) {
        acc[groupKey] = {
          ...groupKeys.reduce((acc:any, key:any) => {
            acc[key] = obj[key];
            return acc;
          }, {}),
          ...sumKeys.reduce((acc:any, key:any) => {
            acc[key] = 0;
            return acc;
          }, {}),
        };
      }
  
      // Sum the values for the specified keys
      sumKeys.forEach((key:any) => {
        acc[groupKey][key] += obj[key];
      });
  
      return acc;
    }, {});
  }


   lanelist_for_Servicelevel_volume:any=[]
   selectedsv="";
   selectedtype=""
   setgraph_report(t:any){
    this.graph_report_index=t;
    if(t==1||t==2||t==3||t==4||t==5)
    {
     
      this.lanelist_for_Servicelevel_spend=[]

      this.selected_lane="";
      this.partner_Details =[]
      this.selected_partner=""
      this.week_details =[]
      // this.filterselection.fiscal_quarter=""
      // this.filterselection.fiscal_month=""
      // this.filterselection.fiscal_year=""

      this.week_obj=null;
      this.price_model_Details=[]
      this.selectedsv=""
      this.selectedtype=""

      this.selected_lane="";
    }
   }
   get_lane_data(){

    // var lanelist_for_Servicelevel_spend = this.fitlered_data_details.filter(data=>{
    //   return data['Service Level']==sl});

      ////console.log(this.filtered_data_all);
      const groupedData:any = this.groupByFirstRecord_multiple(this.filtered_data_all, ['Lane','Week_Start']);


      this.lanelist_for_Servicelevel_spend = this.groupByMultipleAndSuml(groupedData,["Lane"])
      ////console.log(this.lanelist_for_Servicelevel_spend);

    //  ////////console.log(this.lanelist_for_Servicelevel_spend )
    
      // this.lanelist_for_Servicelevel_volume = this.groupByMultipleAndSum(lanelist_for_Servicelevel_spend,["Lane"])
      // ////////console.log(this.lanelist_for_Servicelevel_spend )

      this.lanelist_for_Servicelevel_spend = JSON.parse(JSON.stringify(this.lanelist_for_Servicelevel_spend)).sort((b:any, a:any) => a.total_spend - b.total_spend);

      this.lanelist_for_Servicelevel_volume =JSON.parse(JSON.stringify(this.lanelist_for_Servicelevel_spend)).sort((b:any, a:any) => a.COB_WEIGHT_CHARGEABLE - b.COB_WEIGHT_CHARGEABLE);

     // ////////console.log(this.lanelist_for_Servicelevel_spend )
      this.partner_Details =[]
      this.selected_partner=""
      this.week_details =[]
      this.week_obj=null;

      this.selected_lane="";

      this.lanelist_for_Servicelevel_spend= this.lanelist_for_Servicelevel_spend.sort((b:any, a:any) => a.Partner_Blended_Spend - b.Partner_Blended_Spend);
      return this.lanelist_for_Servicelevel_spend;
   }
   get_data_sl(sl:any)
   {
   // ////////console.log(sl)

    this.selectedsv=sl;

    var lanelist_for_Servicelevel_spend = this.fitlered_data_details.filter((data:any)=>{
      return data['Service Level']==sl});

      // ////////console.log(this.lanelist_for_Servicelevel_spend);

      this.lanelist_for_Servicelevel_spend = this.groupByMultipleAndSum(lanelist_for_Servicelevel_spend,["Lane"])
    //  ////////console.log(this.lanelist_for_Servicelevel_spend )
    
      // this.lanelist_for_Servicelevel_volume = this.groupByMultipleAndSum(lanelist_for_Servicelevel_spend,["Lane"])
      // ////////console.log(this.lanelist_for_Servicelevel_spend )

      this.lanelist_for_Servicelevel_spend = JSON.parse(JSON.stringify(this.lanelist_for_Servicelevel_spend)).sort((b:any, a:any) => a.Partner_Blended_Spend - b.Partner_Blended_Spend);

      this.lanelist_for_Servicelevel_volume =JSON.parse(JSON.stringify(this.lanelist_for_Servicelevel_spend)).sort((b:any, a:any) => a.COB_WEIGHT_CHARGEABLE - b.COB_WEIGHT_CHARGEABLE);

     // ////////console.log(this.lanelist_for_Servicelevel_spend )
      this.partner_Details =[]
      this.selected_partner=""
      this.week_details =[]

      this.selected_lane="";

      this.price_model_Details=[]
      this.lanelist_for_Servicelevel_spend= this.lanelist_for_Servicelevel_spend.sort((b:any, a:any) => a.Partner_Blended_Spend - b.Partner_Blended_Spend);
      return this.lanelist_for_Servicelevel_spend;
   }
   get_data_sl_model(sl:any)
   {
   // ////////console.log(sl)

    this.selectedsv=sl;

    var lanelist_for_Servicelevel_spend = this.fitlered_data_details.filter((data:any)=>{
      return data['Service Level']==sl});

      // ////////console.log(this.lanelist_for_Servicelevel_spend);

      this.price_model_Details = this.groupByMultipleAndSum(lanelist_for_Servicelevel_spend,["Service Type"])
    //  ////////console.log(this.lanelist_for_Servicelevel_spend )
    
      // this.lanelist_for_Servicelevel_volume = this.groupByMultipleAndSum(lanelist_for_Servicelevel_spend,["Lane"])
      // ////////console.log(this.lanelist_for_Servicelevel_spend )

      this.price_model_Details = JSON.parse(JSON.stringify(this.price_model_Details)).sort((b:any, a:any) => a.Partner_Blended_Spend - b.Partner_Blended_Spend);

      // this.price_model_Details_volume =JSON.parse(JSON.stringify(this.lanelist_for_Servicelevel_spend)).sort((b, a) => a.COB_WEIGHT_CHARGEABLE - b.COB_WEIGHT_CHARGEABLE);

     // ////////console.log(this.lanelist_for_Servicelevel_spend )
      this.partner_Details =[]
      this.selected_partner=""
      this.week_details =[]

      this.lanelist_for_Servicelevel_spend=[]
      this.selected_lane="";

      // this.price_model_Details=[]
      this.price_model_Details= this.price_model_Details.sort((b:any, a:any) => a.Partner_Blended_Spend - b.Partner_Blended_Spend);
      return this.price_model_Details;
   }
   selected_price=''
   get_data_sl_model_lane(sl:any)
   {
   // ////////console.log(sl)

    this.selected_price=sl;

    var lanelist_for_Servicelevel_spend = this.fitlered_data_details.filter((data:any)=>{
      return data['Service Level']==this.selectedsv && data['Service Type']==sl});

      // ////////console.log(this.lanelist_for_Servicelevel_spend);

      this.lanelist_for_Servicelevel_spend = this.groupByMultipleAndSum(lanelist_for_Servicelevel_spend,["Lane"])
    //  ////////console.log(this.lanelist_for_Servicelevel_spend )
    
      // this.lanelist_for_Servicelevel_volume = this.groupByMultipleAndSum(lanelist_for_Servicelevel_spend,["Lane"])
      // ////////console.log(this.lanelist_for_Servicelevel_spend )

      this.lanelist_for_Servicelevel_spend = JSON.parse(JSON.stringify(this.lanelist_for_Servicelevel_spend)).sort((b:any, a:any) => a.Partner_Blended_Spend - b.Partner_Blended_Spend);

      // this.price_model_Details_volume =JSON.parse(JSON.stringify(this.lanelist_for_Servicelevel_spend)).sort((b, a) => a.COB_WEIGHT_CHARGEABLE - b.COB_WEIGHT_CHARGEABLE);

     //////console.log(this.lanelist_for_Servicelevel_spend )
      this.partner_Details =[]
      this.selected_partner=""
      this.week_details =[]

      this.selected_lane="";

      this.lanelist_for_Servicelevel_spend= this.lanelist_for_Servicelevel_spend.sort((b:any, a:any) => a.Partner_Blended_Spend - b.Partner_Blended_Spend);
      return this.lanelist_for_Servicelevel_spend;
   }
   

   get_data_model(sl:any){
    // ////////console.log(sl)
 
     this.selectedtype=sl;
 
     var lanelist_for_Servicelevel_spend = this.fitlered_data_details.filter((data:any)=>{
       return data['Service Type']==sl});
 
       // ////////console.log(this.lanelist_for_Servicelevel_spend);
 
       this.lanelist_for_Servicelevel_spend = this.groupByMultipleAndSum(lanelist_for_Servicelevel_spend,["Lane"])
     //  ////////console.log(this.lanelist_for_Servicelevel_spend )
     
       // this.lanelist_for_Servicelevel_volume = this.groupByMultipleAndSum(lanelist_for_Servicelevel_spend,["Lane"])
       // ////////console.log(this.lanelist_for_Servicelevel_spend )
 
       this.lanelist_for_Servicelevel_spend = JSON.parse(JSON.stringify(this.lanelist_for_Servicelevel_spend)).sort((b:any, a:any) => a.Partner_Blended_Spend - b.Partner_Blended_Spend);
 
       this.lanelist_for_Servicelevel_volume =JSON.parse(JSON.stringify(this.lanelist_for_Servicelevel_spend)).sort((b:any, a:any) => a.COB_WEIGHT_CHARGEABLE - b.COB_WEIGHT_CHARGEABLE);
 
      // ////////console.log(this.lanelist_for_Servicelevel_spend )
       this.partner_Details =[]
       this.selected_partner=""
       this.week_details =[]
 
       this.selected_lane="";

       this.lanelist_for_Servicelevel_spend= this.lanelist_for_Servicelevel_spend.sort((b:any, a:any) => a.Partner_Blended_Spend - b.Partner_Blended_Spend);

 
       return this.lanelist_for_Servicelevel_spend;
    }
    
   selectspendtype=1;
   partner_Details:any=[]
   selected_lane=""
   setselectedspendtype(t:any){
      this.selectspendtype=t;
      this.partner_Details =[]
      this.selected_partner=""
      this.week_details =[]
      this.filterselection.fiscal_quarter=""
      this.filterselection.fiscal_month=""
      this.filterselection.fiscal_year=""

      this.week_obj=null;
      this.price_model_Details=[]
      this.selectedsv=""
      this.selectedtype=""

      this.selected_lane="";

   }
   get_data_partner(lane:any){

    this.selected_lane=lane;
     var partner_Details = this.fitlered_data_details.filter((data:any)=>{
      return data['Service Level']==this.selectedsv && data.Lane == lane });
   
      this.partner_Details = this.groupByMultipleAndSum(partner_Details,["PARTNER"])
      //////console.log(this.partner_Details )
      this.week_details=[]
      this.selected_partner=""
      // this.price_model_Details=[]

      this.partner_Details =this.partner_Details.sort((b:any, a:any) => a.Partner_Blended_Spend - b.Partner_Blended_Spend);
      

      //////console.log(this.partner_Details )

      return this.partner_Details;
   }

    get_data_partner_model_lane(lane:any){
      this.selected_lane=lane;
      var partner_Details = this.fitlered_data_details.filter((data:any)=>{
       return data['Service Level']==this.selectedsv && data['Service Type']==this.selected_price  && data.Lane == lane });
    
       this.partner_Details = this.groupByMultipleAndSum(partner_Details,["PARTNER"])
       //////console.log(this.partner_Details )
       this.week_details=[]
       this.selected_partner=""
       // this.price_model_Details=[]
 
       this.partner_Details =this.partner_Details.sort((b:any, a:any) => a.Partner_Blended_Spend - b.Partner_Blended_Spend);
       
 
       //////console.log(this.partner_Details )
 
       return this.partner_Details;

    }
    get_data_partner_new(lane:any){
      this.selected_lane=lane;

      
      var partner_Details = this.filtered_data_all.filter((data:any)=>{
       return  data.Lane == lane });
    
       this.partner_Details = this.groupByMultipleAndSump(partner_Details,["PARTNER"])
       ////////console.log(this.partner_Details )
       this.week_details=[]
       this.selected_partner=""
 
       this.partner_Details =this.partner_Details.sort((b:any, a:any) => a['Partner_Blended_Spend w Penalty'] - b['Partner_Blended_Spend w Penalty']);
       this.week_obj=null;

       
       return this.partner_Details;
    }
    get_data_partner_model(lane:any){

      this.selected_lane=lane;
       var partner_Details = this.fitlered_data_details.filter((data:any)=>{
        return data['Service Type']==this.selectedtype && data.Lane == lane });
     
        this.partner_Details = this.groupByMultipleAndSum(partner_Details,["PARTNER"])
        ////////console.log(this.partner_Details )
        this.week_details=[]
        this.selected_partner=""
        
        this.partner_Details =this.partner_Details.sort((b:any, a:any) => a.Partner_Blended_Spend - b.Partner_Blended_Spend);

        return this.partner_Details;
      }

    week_details:any=[]
    selected_partner=""
    get_data_week(lane:any){

      var partner=lane;
      this.selected_partner=lane;
      var slane=this.selected_lane
      ////////console.log(lane);
       var week_details = this.fitlered_data_details.filter((data:any)=>{
        return data['Service Level']==this.selectedsv && data.Lane == slane && data.PARTNER == lane });
     
        this.week_details = this.groupByMultipleAndSum(week_details,["Week_Start"])
        // this.week_details =this.week_details.sort((b, a) => a.Partner_Blended_Spend - b.Partner_Blended_Spend);

        ////////console.log(this.week_details )
        // this.price_model_Details=[]
     
        return this.week_details;
    }
    
    get_data_week_model_lane(lane:any){

        var partner=lane;
        this.selected_partner=lane;
        var slane=this.selected_lane
        ////////console.log(lane);
         var week_details = this.fitlered_data_details.filter((data:any)=>{
          return data['Service Level']==this.selectedsv && data['Service Type']==this.selected_price && data.Lane == slane && data.PARTNER == lane });
       
          this.week_details = this.groupByMultipleAndSum(week_details,["Week_Start"])
          // this.week_details =this.week_details.sort((b, a) => a.Partner_Blended_Spend - b.Partner_Blended_Spend);
  
          ////////console.log(this.week_details )
          // this.price_model_Details=[]
       
          return this.week_details;
    }
    
    get_data_week_new(lane:any){

        var partner=lane;
      this.selected_partner=lane;
      var slane=this.selected_lane
      ////console.log(this.filtered_data_all);
         var filtered_data_all =this.filtered_data_all.sort((b:any, a:any) => a.Week_Start_dt - b.Week_Start_dt);

       var week_details = filtered_data_all.filter((data:any)=>{
        return  data.Lane == slane && data.PARTNER == lane });
     
        this.week_details = this.groupByMultipleAndSump(week_details,["Week_Start"])
        // this.week_details =this.week_details.sort((b, a) => a.Week_Start - b.Week_Start);

        this.week_obj=null;
        ////console.log(this.week_details )
     
        return this.week_details;

    }
    
    formatDate(timestamp:any) {
        const date = new Date(timestamp);
        const month = (date.getMonth() + 1).toString().padStart(2, '0');  // getMonth() returns 0-11, so add 1
        const day = date.getDate().toString().padStart(2, '0');           // getDate() returns 1-31
        const year = date.getFullYear();                                  // getFullYear() returns the 4-digit year
        
        return `${month}/${day}/${year}`;
    }
    
    selected_week=""
    week_obj:any;
    get_spend_details_by_week(week:any){

       var week=week;
      this.selected_week=week;
      var slane=this.selected_lane
      //console.log(this.filtered_data_all);
      //console.log(this.fitlered_data_details);

       var week_details = this.filtered_data_all.filter((data:any)=>{
        return  data.Lane == slane && data.PARTNER == this.selected_partner && data.FYQW == week });

        var weekd =this.formatDate(week_details[0].Week_Start_dt)

        //console.log(weekd);

        var week_details_allo = this.fitlered_data_details.filter((data:any)=>{
          return  data.Lane == slane && data.PARTNER == this.selected_partner && data.FYQW == week });
          //console.log(week_details_allo);
          if(week_details_allo.length>0){
            week_details[0]['Baseallocation']=week_details_allo[0]['Baseallocation']
            week_details[0]['Flex']=week_details_allo[0]['Flex']
            week_details[0]['MinAllocaion']=week_details_allo[0]['MinAllocaion']  
          }
          	
        // this.week_details = this.groupByMultipleAndSump(week_details,["Week_Start"])
        // this.week_details =this.week_details.sort((b, a) => a.Partner_Blended_Spend - b.Partner_Blended_Spend);

        //////console.log(week_details )
        if(week_details.length>0)
         this.week_obj = week_details[0]
        else
         this.week_obj=null;
     
         console.log(this.week_obj)
        return this.week_obj;
    }

      price_model_Details:any=[]
      get_spend_details_by_week_pricemodel(week:any){

        var week=week;
       this.selected_week=week;
       var slane=this.selected_lane
       ////////console.log(lane);
        var week_details = this.fitlered_data_details.filter((data:any)=>{
         return data['Service Level']==this.selectedsv &&  data.Lane == slane && data.FYQW == week  && data.PARTNER == this.selected_partner });
      
         
         this.price_model_Details = this.groupByMultipleAndSum(week_details,["Service Type"])
         // this.week_details =this.week_details.sort((b, a) => a.Partner_Blended_Spend - b.Partner_Blended_Spend);
 
        //  //////console.log(week_details )
        //  if(week_details.length>0)
        //   this.week_obj=week_details[0]
        //  else
        //   this.week_obj=null;
        //////console.log(this.price_model_Details )
      
         return this.price_model_Details;
       }
      get_data_week_model(lane:any){

        var partner=lane;
        this.selected_partner=lane;
        var slane=this.selected_lane
        ////////console.log(lane);
         var week_details = this.fitlered_data_details.filter((data:any)=>{
          return data['Service Type']==this.selectedtype && data.Lane == slane && data.PARTNER == lane });
       
          this.week_details = this.groupByMultipleAndSum(week_details,["Week_Start"])
          ////////console.log(this.week_details )
          this.week_details =this.week_details.sort((b:any, a:any) => a.Partner_Blended_Spend - b.Partner_Blended_Spend);

          return this.week_details;
        }

      partner_details_row:any;
      get_data_week_details(week:any){

        var week=week;
        var slane=this.selected_lane
        ////////console.log(this.weekly_avg_cost_model_lane)
         this.partner_details_row= this.weekly_avg_cost_model_lane.filter((data:any)=>{
          return data['Service Level']==this.selectedsv && data.Lane == slane && data.PARTNER == this.selected_partner && data.Week_Start == week });
       

          ////////console.log(this.partner_details_row )
       
        }
        get_data_week_details_model(week:any){

          var week=week;
          var slane=this.selected_lane
          ////////console.log(this.weekly_avg_cost_model_lane)
           this.partner_details_row= this.weekly_avg_cost_model_lane.filter((data:any)=>{
            return data['Service Type']==this.selectedtype && data.Lane == slane && data.PARTNER == this.selected_partner && data.Week_Start == week });
         
  
            ////////console.log(this.partner_details_row )
         
          }
   total_spend_servicelevel:any=[]
   total_filtered_volume=0;

  

  clear_lane(){
    this.toplaneoption=-1;
    this.fop=0;
    this.filers.fiscal_airportcode_destination=[];
    this.filers.fiscal_airportcode_origin=[];
    this.filterselection.airport_destination="";
    this.filterselection.airport_origin="";
    this.filterselection.theater_origin=""
    this.filterselection.theater_destination=""

    this.filterselection.region_origin=""
    this.filterselection.region_destination=""
    // this.summary_page=0;

    // this.get_data_lane_for_week(this.selectedweekno,this.filterselection.selectedlane)


     this.getdisctinctlane();
  }

  distinctlane:any=[]
  selectedlane="HKG-AMS"
 




  selectedweekdata:any=[];

  partenrweekdata:any;
  selectedlanedata:any=[];
  lc:any;
  opt={minimumFractionDigits:0, maximumFractionDigits: 0}
  opt1={minimumFractionDigits:2, maximumFractionDigits: 2}

  changeweek(w:any){
    var ctx=this;
    this.selectedweek=w;
    ////////console.log(ctx.selectedlane)
    ////////console.log(this.weekdata[w]);
    this.selectedlanedata = this.weekdata[w].filter(function(item:any){
      return item.Lane==  ctx.selectedlane  
      //////////console.log("1")     
  });
    

  ////////console.log(this.selectedlanedata);

    this.selectedweekdata= this.getDistinctByKey(this.selectedlanedata,'PARTNER')

    ////////console.log(this.selectedweekdata);
    //this.drawcharts();
  }

  getDistinctByKey = (array:any, key:any) => {
    const seen = new Set();
    return array.filter((item:any) => {
      const keyValue = item[key];
      if (!seen.has(keyValue)) {
        seen.add(keyValue);
        return true;
      }
      return false;
    });
  };
  utilization_chart_current_week:any;


  partner_allocation_graph:any
  partner_spend_graph:any

  partner_allocation_data:any;

  combochart_spend_and_avg_rate:any;
  combochart_benchmarkIATA:any;

  weekoverweekspend:any=[]
   getRandomNumber() {
    const randomNumber = (Math.random() * 4 - 2).toFixed(2); // Generate a random number between 0 and 2, then round to 2 decimal places
    return parseFloat(randomNumber); // Convert back to a number
  }
ptype='ATA';
week_partner_chart:any=[]
  drawcharts(){

    var moved_summary_new = {
      chartType: 'PieChart',
      dataTable: [
        ['Task', 'Hours per Day'],
        ['Demand', 30],
        ['Unused', 60],
        ['Unused', 10],
         // This is the remaining part of the donut
    ],
       options: {
        title: '',
        pieHole: 0.7,
        pieStartAngle: 180,
          tooltip: { trigger: 'none' },
        is3D: false,
        legend: 'none',
        colors: ['#11c237', '#47c2f4', '#dfe7ea'], // Custom colors
        pieSliceBorderColor: 'none',
        height: 80,
        'chartArea': {'width': '60%', 'height': '90%'},
        sliceVisibilityThreshold: 0 
    }

        

    }

    this.utilization_chart_current_week=moved_summary_new;

    var partner_allocation :any= {
      chartType: 'PieChart',
      dataTable: [],
       options: {
        options: {
  
          title: 'Allocation Summary',
          
        },
      pieSliceTextStyle: {
            color: 'black'
        },        pieHole:0.4,

        pieStartAngle: 0,
        legend:'none',

        colors: ['#c39bd3','#ebdef0','#85c1e9','#d6eaf8','#7dcea0','#d4efdf','#bfc9ca','#f2f3f4'],
        'chartArea': {'width': '80%', 'height': '80%'},

      height:90,
      }

    }
    var temp=[]
    var partner=[];
     
    temp.push(['Partner','Allocation']);


    this.selectedweekdata.forEach((element:any) => {

        var base=0,flex=0;
        if(element.Baseallocation!=null)
          base=element.Baseallocation;
        if(element.Flex!=null)
          flex=element.Flex;

        temp.push([element.PARTNER + "Base",base])
        temp.push([element.PARTNER + "Flex",flex])
    });
    ////////console.log(this.selectedweekdata);
    partner_allocation.dataTable=temp;
    this.partner_allocation_data=partner_allocation;


    ////////console.log(this.partner_allocation_data);

    var partner_spend :any= {
      chartType: 'PieChart',
      dataTable: [],
       options: {
        options: {
  
          title: 'Spend Distribution',
          
        },
      pieSliceTextStyle: {
            color: 'black'
        },        pieHole:0.4,

        pieStartAngle: 0,
        legend:'none',

        colors: ['#c39bd3','#85c1e9','#7dcea0','#bfc9ca'],
        'chartArea': {'width': '80%', 'height': '80%'},

      height:90,
      }

    }
    var temp=[]
    var partner=[];
     
    temp.push(['Partner','Spend with Penalty']);


    this.selectedweekdata.forEach((element:any) => {

        // var base=0,flex=0;
        // if(element.Baseallocation!=null)
        //   base=element.Baseallocation;
        // if(element.Flex!=null)
        //   flex=element.Flex;

        temp.push([element.PARTNER,element['Partner_Blended_Spend w Penalty']])
    });

    ////////console.log(this.selectedweekdata);
    partner_spend.dataTable=temp;
    this.partner_spend_graph=partner_spend;


    //combo chart

    var i=0;
    
    this.weekoverweekspend=[]
    this.weekdata.forEach((element:any) => {
      var ctx=this;

      var lanedata :any=element.filter(function(item:any){
        return item.Lane==  ctx.selectedlane  
      });
      const groupedData = this.groupByAndSum(lanedata);
      const result:any = Object.values(groupedData); // Convert the object back to an array

      
        //////////console.log("1")     
   
      
        var number=this.getRandomNumber();

      if(lanedata.length>0)
       this.weekoverweekspend.push({'week':this.weeklist[i],'lane':result[0].Lane,spend:result[0].Partner_Blended_Spend,avg:lanedata[0]['Wks_Blended_Avg_rate'],rate:lanedata[0]['Wks_Blended_Avg_rate']-number})
      else
        this.weekoverweekspend.push({'week':this.weeklist[i],'lane':result[0].Lane,spend:null,avg:null,rate:0})

      i=i++;

    });

    ////////console.log(this.weekoverweekspend);
    // const groupedData = this.groupByAndSum(this.selectedlanedata);
    // const result = Object.values(groupedData); // Convert the object back to an array

    // ////////console.log(result);

    
    var allocation_combined_chart:any = {
      chartType: 'ComboChart',
      dataTable: [      ], // Ensure this contains your combined data
      options: {
        chartArea: { width: '60%', height: '80%' },
        vAxes: {
          0: {
            title: 'Blended Spend ($)', // Title for the line chart axis
            gridlines: { color: 'transparent' }
          },
          1: {
            title: 'Blended Avg Rate ($)', // Title for the column chart axis
            gridlines: { color: 'transparent' }
          }
        },
        series: {
          0: { type: 'bars', targetAxisIndex: 1 }, // Column series
          1: { type: 'area', targetAxisIndex: 0 } , // Line series
          2: { type: 'line', targetAxisIndex: 1 }  // Line series

        },
        legend: { position: 'top', alignment: 'center' },
        hAxis: {
          gridlines: { color: 'transparent' }
        },
        height: 380,
        pointSize: 3,
        colors: ['#aed6f1', '#5dade2', '#a04000','#a04000']
      }
    };

    var data=[]
    data.push(['Week','Blended Avg Rate',{role:'style'},'Blended Spend','Rate from Ratebook'])
    this.weekoverweekspend.forEach((element:any) => {
      
      var color='#82e0aa'
      if(element.rate<element.avg)
       color='#f5cba7'

      data.push([element.week,element.avg,color,element.spend,element.rate])
    });
    allocation_combined_chart.dataTable=data;
    this.combochart_spend_and_avg_rate=allocation_combined_chart;


    var benchmark_combined_chart :any= {
      chartType: 'ComboChart',
      dataTable: [      ], // Ensure this contains your combined data
      options: {
        chartArea: { width: '75%', height: '75%' },
        vAxes: {
          0: {
            title: 'ATA Rate ($)', // Title for the line chart axis
            gridlines: { color: 'transparent' }
          },
          
        },
        series: {
          1: { type: 'bars', targetAxisIndex: 0 }, // Column series
          0: { type: 'line', targetAxisIndex: 0 } , // Line series

        },
        legend: { position: 'top', alignment: 'center' },
        hAxis: {
          gridlines: { color: 'transparent' }
        },
        height: 280,
        pointSize: 6,
        colors: ['#000','#aed6f1','#000']
      }
    };

    var data=[]
    data.push(['Week','IATA  Rate','Rate from Ratebook',{role:'style'}])
    this.weekoverweekspend.forEach((element:any) => {
      
      var color='#82e0aa'
      if(element.rate<element.avg)
       color='#f5cba7'

      data.push([element.week,element.rate,element.avg,color])
    });
    benchmark_combined_chart.dataTable=data;
    this.combochart_benchmarkIATA=benchmark_combined_chart;

  }

   price_model_rate_Chart:any;
   price_model_rate_Chart_dta:any;
   price_model_rate_Chart_atd:any;
   price_model_rate_Chart_dtd:any;
   benchmark_combined_chart_spend:any;
   benchmark_combined_chart_volume:any;

   testgraph:any;
   currentPage=1;
   pageSize=10;
   monthlist=['Jan','Feb','Mar',"Apr",'May','Jun','Jul','Aug','Sept','Oct','Nov','Dec']

   

colors = {
  "Transportation": "#81D0E8",  // Darker Cool Blue
  "Fuel": "#F5A623",            // Darker Peach
  "Screening": "#40E0D0",       // Darker Orange
  "Security": "#D69A6C",        // Darker Gold
  "Origin": "#A8B2B2",          // Darker Green
  "PickUp": "#f4d03f",          // Darker Yellow
  "Destination": "#5F9EA0"      // Darker Teal
};

colorslist = [
  {
      "Key": "Transportation",
      "Color": "#81D0E8"
  },
  {
      "Key": "Fuel",
      "Color": "#F5A623"
  },
  {
      "Key": "Screening",
      "Color": "#40E0D0"
  },
  {
      "Key": "Security",
      "Color": "#D69A6C"
  },
  {
      "Key": "Origin",
      "Color": "#A8B2B2"
  },
  {
      "Key": "Pick Up",
      "Color": "#f4d03f"
  },
  {
      "Key": "Destination",
      "Color": "#5F9EA0"
  }
];

getMaxValueFromKeys = (obj:any, keys:any) => {
  return Math.max(...keys.map((key:any) => obj[key] || -Infinity));
};

   selected_parter="Partner_1"
  distinc_Week_chart:any=[]
  distinc_partner_chart:any=[]
  week_partner_chart_weeks:any=[]
  selected_Sv="STD"

  

chart:any;

  


  groupByAndSum(arr: Array<any>) {
    return arr.reduce((acc, current) => {
      const { Lane, Partner_Blended_Spend } = current;
  
      // Check if the category already exists in the accumulator
      if (!acc[Lane]) {
        acc[Lane] = { Lane, Partner_Blended_Spend: 0 };
      }
  
      // Sum the values
      acc[Lane].Partner_Blended_Spend += Partner_Blended_Spend;
  
      return acc;
    }, {} as { [key: string]: { Lane: string; Partner_Blended_Spend: number } });
  }
  reportab=0;

  selected_year="";
  selected_month=0;

  ratebookfilters:any={
    partner:[],
    quote_type:[],
    service_level:[],
    programme:[]
  }
  ratebookselector:any={
    partner:"",
    quote_type:"",
    service_level:"",
    programme:""
  }
  // 
  ratecol =['DTD','DTA','ATD','ATA','DTD Tier 2','DTA Tier 2','ATD Tier 2','ATA Tier 2','DTD Tier 3','DTA Tier 3','ATD Tier 3','ATA Tier 3']
  ratecol1 =['Peak Season ($/Kg)','Peak Season Start Date','Peak Season End Date','Available Peak/HDRA Capacity/KG','Available Non Peak Capacity/KG','Over-capacity allocation Rate - if applicable',	'Over-capacity allocation Start Date','Over-capacity allocation End Date']

  ratecolt =['n','n','n','n','n','n','n','n','n','n','n','n','n','s','s','n','n','n','s','s']
  rabook_master:any=[]
  ratebook_page=0;
  

  graph_page=0;
  nextgraph(e:any,i:any){
    e.preventDefault();
    // if(this.graph_page<this.graph_report_list.length)
     this.graph_page = i;

  }

  graph_page_partner=-1;
  selected_partners:any=[];
  p_selecttype='a'

  check_partner(i:any){

    return this.selected_partners.indexOf(this.partner_list[i]);

  }

  changeptype(){

     if(this.p_selecttype=='a')
      {
        this.selected_partners = JSON.parse(JSON.stringify(this.partner_list));
        this.draw_month_over_trend_new();
        this.draw_month_over_trend_new_without();
      }
      else {
        this.selected_partners=[]
      }
      


  }

  nextgraphp(e:any,i:any){

   
   

      if(this.p_selecttype=='m'){

        var k=this.selected_partners.indexOf(this.partner_list[i])
        if(k<0)
        {
          this.selected_partners.push(this.partner_list[i]);
        }
        else{
         this.selected_partners.splice(k,1);
        }
      }
      else if(this.p_selecttype=='s'){

           this.selected_partners=[]
           this.selected_partners.push(this.partner_list[i]);
           this.draw_month_over_trend_new();
           this.draw_month_over_trend_new_without();
        

      }




     

  }
  prevgraph(){

    if(this.graph_page>0)
     this.graph_page = this.graph_page -1;

  }

  next(){
    const filterPipe = new MultiKeyValueFilterPipe();
    const fiteredArr = filterPipe.transform(this.filtered_ratbook,{ 'Service Provider':this.ratebookselector.partner , 'Service Level':this.ratebookselector.service_level,'Program Name':this.ratebookselector.programme  },this.currentPage+1,this.pageSize);
    // ////console.log(fiteredArr);
    // //////console.log(this.ratebook_page,(fiteredArr.length/this.ratebook_page))

    // if(this.ratebook_page<(fiteredArr.length/this.ratebook_page))
     this.ratebook_page=this.ratebook_page+1;

    if(fiteredArr.length>0)
     this.currentPage=this.currentPage+1;

  }
  prev()
  {
    if(this.ratebook_page>0)
    this.ratebook_page=this.ratebook_page-1;

    if(this.currentPage>1)
    this.currentPage=this.currentPage-1;

  }
  ratebook_flag=false;
  getratebook(month:any,year:any){
    

    this.ratebook_flag=true;
    this.rabook_master=[]
    this.filtered_ratbook=[]
    this.service.postData({month:month,year:year},"get_partner_sourcing_data_new_ratebook").then((result) => {

      var res:any=result;
      this.rabook_master=JSON.parse(res.dfRB);

      //////console.log(this.rabook_master);

      this.filter_retebook();
      this.get_distnct_partner();
      this.get_distnct_servicelevel();
      this.get_distnct_programme();
      this.ratebook_flag=false;

      
    });

  }

  convertToZeroIfBlankOrNull(value:any) {
  return (value === "" || value === null) ? 0 : value;
}
  filter_blank(row:any){

    var flag=false;
    this.week_partner_chart.forEach((element:any) => {

     if(this.convertToZeroIfBlankOrNull(row[element.week+"_COB_WEIGHT_CHARGEABLE"])>0)
      {
          flag=true
      }

    });

    return flag;
  }
  check_bsa_lane(partner:any,origin:any,destination:any,lanes:any){

    //console.log(lanes);
    //console.log(partner+"_"+origin + "-" +destination)

   var k=lanes.filter((res:any)=>{return res.partner+'_'+res.borrow == partner+"_"+origin + "-" +destination});

   if(k.length>0)
    return k[0].bsa;

   else
     return ""



  //  var lane= bsalanes.filter((res:any)=>{return res.Origin==origin && res.Destination ==destination && res.Partner ==partner});
  //  if(lane.length>0){
  //   return lane[0].Borrrow;
  //  }
  //  else 
  //   return ""




  }
   groupAndSumforbsa(data:any, groupKeys:any) {
  const grouped :any= {};

  data.forEach((item:any) => {
    const key :any = groupKeys.map((k:any) => item[k]).join('|');

    if (!grouped[key]) {
      // Clone group keys and initialize numeric fields with zero fallback
      grouped[key] = {};
      for (let prop in item) {
        if (groupKeys.includes(prop)) {
          grouped[key][prop] = item[prop];
        } else if (typeof item[prop] === 'number' || item[prop] == null) {
          grouped[key][prop] = item[prop] || 0;
        } else {
          grouped[key][prop] = item[prop];
        }
      }
    } else {
      // Sum numeric fields (null/undefined treated as 0)
      for (let prop in item) {
        if (!groupKeys.includes(prop) && (typeof item[prop] === 'number' || item[prop] == null)) {
          const currentVal = grouped[key][prop] || 0;
          const newVal = item[prop] || 0;
          grouped[key][prop] = currentVal + newVal;
        }
      }
    }
  });

  // Post-process to set zero sums to blank
  for (let key in grouped) {
    for (let prop in grouped[key]) {
      if (!groupKeys.includes(prop) && typeof grouped[key][prop] === 'number' && grouped[key][prop] === 0) {
        grouped[key][prop] = '';
      }
    }
  }

  return Object.values(grouped);
  }
 download_fw(){

    //console.log(this.graphlist[0].graph.dataTable[this.graphlist[0].graph.dataTable.length-1][0]);
   
    var i=0;
    // this.service.postData({week:'2025/05/11'},"get_bsa_lanes_by_week").then((result) => {

    //   var res:any=result;
    //   //console.log(JSON.parse(res.fdf));

    //   var baslanes =JSON.parse(res.fdf);
    //   var bsalaneslist:any=[]
    //   var nonbsalaneslist:any=[]

    //   var lanes:any=[]

    //   this.fw_q.forEach((element:any) => {

    //     var bsa= this.check_bsa_lane(element.PARTNER,element.ORIGIN_BRANCH,element.DESTIN_BRANCH,baslanes,lanes)

    //     //console.log(bsa)

    //       if(bsa!='')
    //       {
    //         var obj = JSON.parse(JSON.stringify(this.fw_q[i]))

    //         if(bsa.split("/").length>1)
    //         {
    //           obj['lane']=bsa;
    //           bsalaneslist.push(obj) 

    //         }
    //         else{
    //           obj['lane']=obj.PARTNER+"_"+obj.ORIGIN_BRANCH+"_"+obj.DESTIN_BRANCH+"/"+bsa;
    //           bsalaneslist.push(obj) 
    //           lanes.push({bsa:element.PARTNER+"_"+bsa,id:obj.PARTNER+"_"+obj.ORIGIN_BRANCH+"_"+obj.DESTIN_BRANCH+"/"+bsa});
    //           //console.log(lanes);
 
    //         } 


    //       }
    //       else{
             
    //         nonbsalaneslist.push(element);
    //         //this.fw_q[i]['lane']=element.PARTNER+"_"+element.ORIGIN_BRANCH+"_"+element.DESTIN_BRANCH;

    //       }
        
    //       i++;
    //   });


    //   // var this.groupAndSumforbsa(bsalaneslist,[])
    console.log(this.fw_q_bsa);

       var bsalaneslist:any=[]
       var i=0;
       var lanes:any=[]
      this.fw_q_bsa.forEach((element:any) => {

        var b=this.check_bsa_lane(element.PARTNER,element.ORIGIN_BRANCH,element.DESTIN_BRANCH,lanes)
        var bsa="";
        //console.log(b);
        if(b!='')
         {
             
           bsa=this.fw_q_bsa[i]['lane']= b;
           bsalaneslist.push(JSON.parse(JSON.stringify(this.fw_q_bsa[i])));
          //  lanes.push({bsa:bsa,borrow:bsa['Borrrow']});

            
         }else{

           bsa=this.fw_q_bsa[i]['lane']= this.fw_q_bsa[i]['PARTNER']+'_'+this.fw_q_bsa[i]['ORIGIN_BRANCH']+'-'+this.fw_q_bsa[i]['DESTIN_BRANCH']+'/'+this.fw_q_bsa[i]['Borrrow']

           bsalaneslist.push(JSON.parse(JSON.stringify(this.fw_q_bsa[i])));
           lanes.push({bsa:bsa,borrow:this.fw_q_bsa[i]['Borrrow'],partner: this.fw_q_bsa[i]['PARTNER']});
         }
         i++;

      });
      //console.log(bsalaneslist);

      

      var grouped:any = this.groupAndSumforbsa(bsalaneslist, ["lane"]);
      //console.log(grouped);
      

      



    

    
    //console.log("as");

    
    // let sampleJson: any = [];
    let datad =  this.fw_q;

    if(this.selectedItems.length==0)
     datad= this.fw_q.filter((data:any) =>  this.distinctlane.indexOf(data.ORIGIN_BRANCH+"-"+data.DESTIN_BRANCH)>=0 && this.filter_blank(data)==true);
    else
     datad= this.fw_q.filter((data:any) =>  this.selectedItems.indexOf(data.ORIGIN_BRANCH+"-"+data.DESTIN_BRANCH)>=0 && this.filter_blank(data)==true);
    
    //console.log(datad);
    

    var keysToKeep = ['ORIGIN_BRANCH','DESTIN_BRANCH','PARTNER'];  // Your list of desired keys

    
    this.week_partner_chart.forEach((element:any) => {
      keysToKeep.push(element.week+"_COB_WEIGHT_CHARGEABLE");
      keysToKeep.push(element.week+"_Partner Allocation");
      keysToKeep.push(element.week+"_Partner_Blended_Spend");
      keysToKeep.push(element.week+"_Partner Overallocation $ Penalty");
      keysToKeep.push(element.week+"_Partner Blended Spend w  Penalty");
      keysToKeep.push(element.week+"_Partner Blended Spend w Overalloaction Penalty");
      // keysToKeep.push(element.week+"_Wks_Blended_Avg_rate");
      // keysToKeep.push(element.week+"_Wks_Blended_Avg_rate w Overallocation Penalty");

    });

    //console.log(keysToKeep);

    const filtered = datad.map((obj:any) =>
      keysToKeep.reduce((acc:any, key:any) => {
        if (key in obj) {
          acc[key] = obj[key];
        }
        return acc;
      }, {})
    );




    const keysList = Object.keys(filtered[0]);

    const data = filtered.map((obj:any) => Object.values(obj));
    data.unshift(keysList); // Add header
    

    //second data


    let datad1 = grouped;

    if(this.selectedItems.length==0)
      datad1=grouped.filter((data:any) =>  this.distinctlane.indexOf(data.ORIGIN_BRANCH+"-"+data.DESTIN_BRANCH)>=0);
    else
     datad1=grouped.filter((data:any) =>  this.selectedItems.indexOf(data.ORIGIN_BRANCH+"-"+data.DESTIN_BRANCH)>=0);
    
    //console.log(datad1);
    

    var keysToKeep = ['lane'];  // Your list of desired keys

 this.week_partner_chart.forEach((element:any) => {
  keysToKeep.push(`${element.week}_COB_WEIGHT_CHARGEABLE`);
  keysToKeep.push(`${element.week}_Partner Allocation`);
  keysToKeep.push(`${element.week}_Partner_Blended_Spend`);
  keysToKeep.push(`${element.week}_Partner Overallocation $ Penalty`);
  keysToKeep.push(`${element.week}_Partner Blended Spend w  Penalty`);
  keysToKeep.push(`${element.week}_Partner Blended Spend w Overalloaction Penalty`);
  // keysToKeep.push(`${element.week}_Wks_Blended_Avg_rate`);
  // keysToKeep.push(`${element.week}_Wks_Blended_Avg_rate w Overallocation Penalty`);
});

//console.log(keysToKeep);

const filtered1 = datad1.map((obj:any) => {
  const acc:any = {};

  // Always keep the 'lane' column
  if ('lane' in obj) {
    acc['lane'] = obj['lane'];
  }

  // Loop through weeks to process keys and conditions
  this.week_partner_chart.forEach((element:any) => {
    const week = element.week;

    const keyList = [
      "_COB_WEIGHT_CHARGEABLE",
      "_Partner Allocation",
      "_Partner_Blended_Spend",
      "_Partner Overallocation $ Penalty",
      "_Partner Blended Spend w  Penalty",
      "_Partner Blended Spend w Overalloaction Penalty",
      // "_Wks_Blended_Avg_rate",
      // "_Wks_Blended_Avg_rate w Overallocation Penalty"
    ];

    keyList.forEach(suffix => {
      const key = week + suffix;

      if (key in obj) {
        if (
          suffix === "_Partner Overallocation $ Penalty" &&
          obj[week + "_COB_WEIGHT_CHARGEABLE"] <= obj[week + "_Partner Allocation"]
        ) {
          acc[key] = ""; // Set to blank if condition met
        } else {
          acc[key] = obj[key];
        }
      }
    });
  });

  return acc;
});


    

    const keysList1 = Object.keys(filtered1[0]);

    const data1 = filtered1.map((obj:any) => Object.values(obj));
    data1.unshift(keysList1); // Add header


    // Step 4: Create and write the Excel file
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();

    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
        const worksheet1: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data1);

    workbook.SheetNames.push("Non BSA Lanes");
    workbook.SheetNames.push("BSA Lanes");

    workbook.Sheets["Non BSA Lanes"] = worksheet;
    workbook.Sheets["BSA Lanes"] = worksheet1;

    
    XLSX.writeFile(workbook, 'Estimated Spend by Fiscal Week (w Overallocation Penalty).xlsx');

 // });
  }
  download_fwo(){

    //console.log(this.graphlist[0].graph.dataTable[this.graphlist[0].graph.dataTable.length-1][0]);
   
    var i=0;
   

       var bsalaneslist:any=[]
       var i=0;
       var lanes:any=[]
      this.fw_q_bsa.forEach((element:any) => {

        var b=this.check_bsa_lane(element.PARTNER,element.ORIGIN_BRANCH,element.DESTIN_BRANCH,lanes)
        var bsa="";
        //console.log(b);
        if(b!='')
         {
             
           bsa=this.fw_q_bsa[i]['lane']= b;
           bsalaneslist.push(JSON.parse(JSON.stringify(this.fw_q_bsa[i])));
          //  lanes.push({bsa:bsa,borrow:bsa['Borrrow']});

            
         }else{

           bsa=this.fw_q_bsa[i]['lane']= this.fw_q_bsa[i]['PARTNER']+'_'+this.fw_q_bsa[i]['ORIGIN_BRANCH']+'-'+this.fw_q_bsa[i]['DESTIN_BRANCH']+'/'+this.fw_q_bsa[i]['Borrrow']

           bsalaneslist.push(JSON.parse(JSON.stringify(this.fw_q_bsa[i])));
           lanes.push({bsa:bsa,borrow:this.fw_q_bsa[i]['Borrrow'],partner: this.fw_q_bsa[i]['PARTNER']});
         }
         i++;

      });
      //console.log(bsalaneslist);

      

      var grouped:any = this.groupAndSumforbsa(bsalaneslist, ["lane"]);
      //console.log(grouped);
      

      



    

    
    //console.log("as");

    
    // let sampleJson: any = [];
    let datad =  this.fw_o;

    if(this.selectedItems.length==0)
     datad= this.fw_o.filter((data:any) =>  this.distinctlane.indexOf(data.ORIGIN_BRANCH+"-"+data.DESTIN_BRANCH)>=0);
    else
     datad= this.fw_o.filter((data:any) =>  this.selectedItems.indexOf(data.ORIGIN_BRANCH+"-"+data.DESTIN_BRANCH)>=0);
    
    //console.log(datad);
    

    var keysToKeep = ['ORIGIN_BRANCH','DESTIN_BRANCH','PARTNER'];  // Your list of desired keys

    this.week_partner_chart.forEach((element:any) => {
      keysToKeep.push(element.week+"_COB_WEIGHT_CHARGEABLE");
      keysToKeep.push(element.week+"_Partner Allocation");

      keysToKeep.push(element.week+"_Partner_Blended_Spend");
      keysToKeep.push(element.week+"_Partner Overallocation $ Penalty");
      keysToKeep.push(element.week+"_Partner Blended Spend w  Penalty");
      keysToKeep.push(element.week+"_Partner Blended Spend w Overalloaction Penalty");
      keysToKeep.push(element.week+"_Wks_Blended_Avg_rate");
      keysToKeep.push(element.week+"_Wks_Blended_Avg_rate w Overallocation Penalty");

    });

    //console.log(keysToKeep);

    const filtered = datad.map((obj:any) =>
      keysToKeep.reduce((acc:any, key:any) => {
        if (key in obj) {
          acc[key] = obj[key];
        }
        return acc;
      }, {})
    );




    const keysList = Object.keys(filtered[0]);

    const data = filtered.map((obj:any )=> Object.values(obj));
    data.unshift(keysList); // Add header
    

    //second data


    let datad1 = grouped;

    if(this.selectedItems.length==0)
      datad1=grouped.filter((data:any) =>  this.distinctlane.indexOf(data.ORIGIN_BRANCH+"-"+data.DESTIN_BRANCH)>=0);
    else
     datad1=grouped.filter((data:any) =>  this.selectedItems.indexOf(data.ORIGIN_BRANCH+"-"+data.DESTIN_BRANCH)>=0);
    
    //console.log(datad1);
    

    var keysToKeep = ['lane'];  // Your list of desired keys

 this.week_partner_chart.forEach((element:any) => {
  keysToKeep.push(`${element.week}_COB_WEIGHT_CHARGEABLE`);
  keysToKeep.push(`${element.week}_Partner Allocation`);
  keysToKeep.push(`${element.week}_Partner_Blended_Spend`);
  keysToKeep.push(`${element.week}_Partner Overallocation $ Penalty`);
  keysToKeep.push(`${element.week}_Partner Blended Spend w  Penalty`);
  keysToKeep.push(`${element.week}_Partner Blended Spend w Overalloaction Penalty`);
  keysToKeep.push(`${element.week}_Wks_Blended_Avg_rate`);
  keysToKeep.push(`${element.week}_Wks_Blended_Avg_rate w Overallocation Penalty`);
});

//console.log(keysToKeep);

const filtered1 = datad1.map((obj:any) => {
  const acc:any = {};

  // Always keep the 'lane' column
  if ('lane' in obj) {
    acc['lane'] = obj['lane'];
  }

  // Loop through weeks to process keys and conditions
  this.week_partner_chart.forEach((element:any) => {
    const week = element.week;

    const keyList = [
      "_COB_WEIGHT_CHARGEABLE",
      "_Partner Allocation",
      "_Partner_Blended_Spend",
      "_Partner Overallocation $ Penalty",
      "_Partner Blended Spend w  Penalty",
      "_Partner Blended Spend w Overalloaction Penalty",
      "_Wks_Blended_Avg_rate",
      "_Wks_Blended_Avg_rate w Overallocation Penalty"
    ];

    keyList.forEach(suffix => {
      const key = week + suffix;

      if (key in obj) {
        if (
          suffix === "_Partner Overallocation $ Penalty" &&
          obj[week + "_COB_WEIGHT_CHARGEABLE"] <= obj[week + "_Partner Allocation"]
        ) {
          acc[key] = ""; // Set to blank if condition met
        } else {
          acc[key] = obj[key];
        }
      }
    });
  });

  return acc;
});


    

    const keysList1 = Object.keys(filtered1[0]);

    const data1 = filtered1.map((obj:any )=> Object.values(obj));
    data1.unshift(keysList1); // Add header


    // Step 4: Create and write the Excel file
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();

    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
        const worksheet1: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data1);

    workbook.SheetNames.push("Non BSA Lanes");
    workbook.SheetNames.push("BSA Lanes");

    workbook.Sheets["Non BSA Lanes"] = worksheet;
    workbook.Sheets["BSA Lanes"] = worksheet1;

    
    XLSX.writeFile(workbook, 'Finance WoW Overallocation Penalty View(Only For overallocated lane).xlsx');

 // });
  }

Download_ratebook()
{
  let sampleJson: any = [];
  const filterPipe = new MultiKeyValueFilterPipe();
// const fiteredArr = filterPipe.transform(this.filtered_ratbook,{ 'Service Provider':this.ratebookselector.partner , 'Service Level':this.ratebookselector.service_level,'Program Name':this.ratebookselector.programme  });
  var datad=this.filtered_ratbook
  const keyToRemove = 'PARTNER';

var week_allocation = datad.map((item:any) => {
  // Create a shallow copy of the object
  const { [keyToRemove]: _, ...rest } = item;
  return rest;
});
  ////////console.log(week_allocation);
  const keysList = Object.keys(week_allocation[0]);
  const data = week_allocation.map((obj:any) => Object.values(obj));

  data.unshift(keysList);
  var workbook: XLSX.WorkBook = XLSX.utils.book_new();
  var worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);

  workbook.SheetNames.push("Filtered Data");
  workbook.Sheets["Filtered Data"] = worksheet;

  XLSX.writeFile(workbook,this.selected_month+'_'+this.selected_year+'_ratebook'+".xlsx");

}

  filtered_ratbook:any=[]

  filter_retebook(){
    if(this.selectedItems.length==0){
      this.filtered_ratbook=this.rabook_master.filter((data:any) =>  this.distinctlane.indexOf(data['Lane Group'])>=0);
     

     }else{
    
       this.filtered_ratbook =  this.rabook_master.filter((data:any) =>  this.selectedItems.indexOf(data['Lane Group'])>=0);
    

    }

    //////console.log(this.filtered_ratbook);


  }

  get_distnct_partner(){

    this.ratebookfilters.partner = this.filtered_ratbook
    .map((item:any) => item['Service Provider'])
    .filter(
        (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
    );
  }
  get_distnct_quote(){

    this.ratebookfilters.quote_type = this.filtered_ratbook
    .map((item:any) => item['Quote Type'])
    .filter(
        (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
    );
  }
  get_distnct_servicelevel(){

    this.ratebookfilters.service_level = this.filtered_ratbook
    .map((item:any) => item['Service Level'])
    .filter(
        (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
    );
    this.ratebookfilters.service_level=this.ratebookfilters.service_level.filter((data:any)=>{return data!='' && data !=null });

  }

  get_distnct_programme(){

    this.ratebookfilters.programme = this.filtered_ratbook
    .map((item:any) => item['Program Name'])
    .filter(
        (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
    );

    this.ratebookfilters.programme=this.ratebookfilters.programme.filter((data:any)=>{return data!='' && data !=null });
    ////console.log( this.ratebookfilters.programme)

  }

  GOtoNExtPage_1() {
    
    this.router.navigateByUrl('/dashboard');
  }
  GOtoNExtPage_P()
  {
    this.router.navigateByUrl('/operationasl-concern1');
  }
  GOtomessage() {
      
    this.router.navigateByUrl('/messages');
  }
  go_config()
  {
    this.router.navigateByUrl('/mle-training');
  
  }

  // capacity prediction

  weeklydata:any=[]
  LineChartdata_13week:any;

  graphlist:any=[]
  lane_list:any=[]

  getfilteredlane()
  { 
    this.lane_list = this.prediction_list_all_lane
    .map((item:any) => item.Lane)
    .filter(
        (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
    );
    //console.log(this.lane_list);
  }
  capgraphindex=0

  setcapgraph(k:any){
   this.capgraphindex=k;
  }
  drawgraphs (){


    this.getfilteredlane();
    
    this.lane_list.forEach((ele:any) => {
      
   
   var alldatalane= this.prediction_list_all_lane.filter(function(item:any){return item['Lane']===ele})

    //13 week graph

    var LineChartdata :any= {
      chartType: 'ComboChart',
      dataTable: temp,
       options: {
        options: {
  
          title: "Last 13 week's actual demand and Weekly Trends",
          
        },
        hAxis: {  gridlines: {
          color: 'transparent'
         }},
         vAxis :{
          gridlines: {
            color: 'transparent'
           }
         },
         
        pointSize:3,
        legend: { position: 'top', alignment: 'center',textStyle: {fontSize: 10} },
        seriesType: 'bars',
        series: {3: {type: 'line',targetAxisIndex:0,lineDashStyle: [10, 2],color:"#5DADE2"},4: {type: 'line',targetAxisIndex:0,lineDashStyle: [10, 2],color:"#95A5A6"},5: {type: 'line',targetAxisIndex:0,color:'black',pointSize:3},6: {type: 'line',targetAxisIndex:0,color:'blue',pointSize:3}},        
        
        colors: ['#AED6F1','#FAD7A0','#7FB3D5','#2C3E50'],
        'chartArea': {'width': '100%', 'height': '70%'},

        
      height:440,
      }
  
    }

    var temp :any=[];
    temp.push(['Week','Moving average past 2 week','Moving average past 4 week','Moving average past Quarter','Prediction lower','Prediction lower','Actual tonnage','Ocean tonnage'])

    alldatalane.forEach((element:any) => {

      // var week= (new Date(element.Week).getMonth()+1)+'/'+(new Date(element.Week).getDate()+1)+'/'+new Date(element.Week).getFullYear();
      // var utcdate=new Date(element.Week).toLocaleString('en-US', { timeZone: 'UTC' });
     var week=element['Prediction for Week bk']

      var mavg2=0
      var mavg4=0;
      var mavg3=0;
       var ocean_weekly=null
      if(element['Moving Avg 2wks']!=null)
        mavg2=element['Moving Avg 2wks']
      if(element['Moving Avg 4wks']!=null)
        mavg4=element['Moving Avg 4wks']
      if(element['Moving Avg 3mnths']!=null)
        mavg3=element['Moving Avg 3mnths']

      var lower=null;
      if(element['Predictions Lower']!=0)
         lower=element['Predictions Lower']
      var upper=null;
      
      if(element['Predictions Upper']!=0)
         upper=element['Predictions Upper']
         
      var actual=null;

      if(element['Actual COB Weight']!=0)
         actual=element['Actual COB Weight']

     var ocean=NaN;

         if(element['OCEAN_WEIGHT_CHARGEABLE']!=0)
         ocean=element['OCEAN_WEIGHT_CHARGEABLE']

      
        //  //console.log(ocean)
        // // if(ocean==null)
        // //    ocean=NaN;

      temp.push([week,mavg2,mavg4,mavg3,lower,upper,actual,ocean])
       
    });

    //console.log(temp);
    var c=0;
    temp.slice(1,temp.length-1).forEach((element:any) => {
    
       if(element[7]!=null && !Number.isNaN(element[7]))
         c=c+1;

    });

    //console.log(c);

    if(c==0)
      {
        temp[1][7]=0;

        LineChartdata.options.series[6].pointSize=0;
      }else{
        LineChartdata.options.series[6].pointSize=3;

      }

      c=0;
    temp.slice(1,temp.length-1).forEach((element:any) => {
    
       if(element[6]!=null && !Number.isNaN(element[6]))
         c=c+1;

    });

    //console.log(c);

    if(c==0)
      {
        temp[1][6]=0;
        LineChartdata.options.series[5].pointSize=0;

      }else{
        LineChartdata.options.series[5].pointSize=3;

      }

    LineChartdata.dataTable=temp;
   


    this.LineChartdata_13week=JSON.parse(JSON.stringify(LineChartdata));

    this.graphlist.push({"graph":this.LineChartdata_13week,"data":ele});

    });

    //console.log(this.graphlist);
  
  }

  



  //generalised group functions

  addKeyWithDefaultValue(data:any, newKey:any, defaultValue:any)  {
    return data.map((obj:any )=> ({
      ...obj,               // Spread the existing properties
      [newKey]: defaultValue // Add the new key with the default value
    }));
  }

  groupByMultipleAndAveragebk = (data:any, groupKeys:any, avgKeys:any) => {

    return Object.values(
      data.reduce((acc:any, obj:any) => {
        // Create a composite key for grouping
        const key = groupKeys.map((k:any) => obj[k]).join('|'); // e.g., "North|A"
  
        if (!acc[key]) {
          // Initialize the accumulator entry if it doesn't exist
          acc[key] = {
            ...groupKeys.reduce((acc:any, k:any) => ({ ...acc, [k]: obj[k] }), {}), // Keep the group keys
            ...avgKeys.reduce((acc:any, k:any) => ({ ...acc, [k]: 0 }), {}), // Initialize averages to 0
            count: 0 // Initialize count for averaging
          };
        }
  
        // Sum values and increment count for each average key
        avgKeys.forEach((k:any) => {
          acc[key][k] += obj[k]; // Sum the values
          // //console.log(obj[k]);

        });
        acc[key].count += 1; // Increment count
  
        return acc;
      }, {})
    ).map((item:any) => {
      // Calculate average for each average key
      avgKeys.forEach((k:any )=> {
        item[k] = item[k] / item['count']; // Calculate average
      });
      delete item['count']; // Remove count from final output
      return item;
    });
  };

  groupByMultipleAndAverage(data:any, groupByKeys:any, avgColumns:any) {
    // Helper function to check if a value is valid for averaging
    function isValidValue(value:any) {
      return value !== null && value !== undefined && value !== 0;
    }
  
    // Grouping the data based on the provided groupByKeys
    const groupedData = data.reduce((acc:any, row:any) => {
      // Create a key for the group (using the values of the groupByKeys)
      const groupKey = groupByKeys.map((key:any) => row[key]).join('`'); // Unique key based on the groupByKeys
  
      if (!acc[groupKey]) {
        acc[groupKey] = [];
      }
      acc[groupKey].push(row);
      return acc;
    }, {});
  
    // Now, calculate the averages for each group
    const resultList = [];
  
    for (const groupKey in groupedData) {
      const group = groupedData[groupKey];
      const groupAvg :any= {};
  
      // Split the groupKey into its corresponding groupByKey values
      const groupKeyValues:any = groupKey.split('`');
      groupByKeys.forEach((key:any, index:any) => {
        groupAvg[key] = groupKeyValues[index]; // Set the actual group key field
      });
  
      // Calculate the averages for each column in avgColumns
      avgColumns.forEach((col:any) => {
        // Filter out invalid values (null, undefined, 0) for each column
        const validValues = group
          .map((row:any) => row[col])
          .filter(isValidValue);
  
        // If there are valid values, calculate the average
        if (validValues.length > 0) {
          const sum = validValues.reduce((sum:any, val:any) => sum + val, 0);
          groupAvg[col] = sum / validValues.length;
        } else {
          groupAvg[col] = null; // If no valid values, set average to null
        }
      });
  
      // Push the result into the resultList
      resultList.push(groupAvg);
    }
  
    return resultList;
  }

  groupByAndSum_data = (data:any, groupKey:any) => {
    return Object.values(
      data.reduce((acc:any, obj:any) => {
        const key = obj[groupKey];
  
        if (!acc[key]) {
          acc[key] = { 
            product: key,
            Partner_Blended_Spend: 0,
            COB_WEIGHT_CHARGEABLE: 0 
            
          };
        }
  
        acc[key].Partner_Blended_Spend += obj.Partner_Blended_Spend;
        acc[key].COB_WEIGHT_CHARGEABLE += obj.COB_WEIGHT_CHARGEABLE; // Sum total price (quantity * price)
  
        return acc;
      }, {})
    );
  };

  groupByMultipleAndSum = (data:any, groupKeys:any) => {
    return Object.values(
      data.reduce((acc:any, obj:any) => {
        // Create a composite key for grouping
        const key = groupKeys.map((k :any)=> obj[k]).join('|'); // e.g., "North|A"
  
        if (!acc[key]) {
          // Initialize the accumulator entry if it doesn't exist
          acc[key] = {
            ...groupKeys.reduce((acc:any, k:any) => ({ ...acc, [k]: obj[k] }), {}), // Keep the group keys
            Partner_Blended_Spend: 0,
            COB_WEIGHT_CHARGEABLE: 0 
          };
        }
  
        // Sum the quantity and total price
        acc[key].Partner_Blended_Spend += obj.Partner_Blended_Spend;
        acc[key].COB_WEIGHT_CHARGEABLE += obj.COB_WEIGHT_CHARGEABLE;
  
        return acc;
      }, {})
    );
  };

  groupByMultipleAndSump = (data:any, groupKeys:any) => {
    return Object.values(
      data.reduce((acc:any, obj:any) => {
        // Create a composite key for grouping
        const key = groupKeys.map((k:any) => obj[k]).join('|'); // e.g., "North|A"
  
        if (!acc[key]) {
          // Initialize the accumulator entry if it doesn't exist
          acc[key] = {
            ...groupKeys.reduce((acc:any, k:any) => ({ ...acc, [k]: obj[k] }), {}), // Keep the group keys
            'Partner_Blended_Spend w Penalty': 0,
            COB_WEIGHT_CHARGEABLE: 0 
          };
        }
  
        // Sum the quantity and total price
        acc[key]['Partner_Blended_Spend w Penalty'] += obj['Partner_Blended_Spend w Penalty'];
        acc[key].COB_WEIGHT_CHARGEABLE += obj.COB_WEIGHT_CHARGEABLE;
  
        return acc;
      }, {})
    );
  };

  groupByMultipleAndSuml = (data:any, groupKeys:any) => {
    return Object.values(
      data.reduce((acc:any, obj:any) => {
        // Create a composite key for grouping
        const key = groupKeys.map((k:any) => obj[k]).join('|'); // e.g., "North|A"
  
        if (!acc[key]) {
          // Initialize the accumulator entry if it doesn't exist
          acc[key] = {
            ...groupKeys.reduce((acc:any, k:any) => ({ ...acc, [k]: obj[k] }), {}), // Keep the group keys
            total_spend: 0,
            COB_WEIGHT_CHARGEABLE: 0 
          };
        }
  
        // Sum the quantity and total price
        acc[key].total_spend+= obj.total_spend;
        acc[key].COB_WEIGHT_CHARGEABLE += obj.total_volume;
  
        return acc;
      }, {})
    );
  };

  groupByFirstRecord = (arr:any, key:any) => {
    return Object.values(
      arr.reduce((acc:any, obj:any) => {
        const groupKey = obj[key];
        if (!acc[groupKey]) {
          acc[groupKey] = obj; // Select the first record of the group
        }
        return acc;
      }, {})
    );
  };

  groupByFirstRecord_multiple = (arr:any, keys:any) => {
    return Object.values(
      arr.reduce((acc:any, obj:any) => {
        // Create a unique group key by joining the values of the specified keys
        const groupKey = keys.map((key:any) => obj[key]).join('|');
        if (!acc[groupKey]) {
          acc[groupKey] = obj; // Select the first record of the group
        }
        return acc;
      }, {})
    );
  };


// filter lanes and other related functions

check_origin_exitst(origin:any){

  return  this.filers.fiscal_airportcode_origin.indexOf(origin);

}

check_destination_exitst(destination:any){

 return  this.filers.fiscal_airportcode_destination.indexOf(destination);

}
getdisctinctlane(){

  var ctx=this;
  this.distinctlane=[]
  ////////console.log(this.distinct_lane)
  if(this.filers.fiscal_airportcode_origin.length>0&&this.filers.fiscal_airportcode_destination.length==0)
    {
      this.distinctlane=this.distinct_lane.filter(function(item:any){
        return ctx.check_origin_exitst(item.split("-")[0])>-1});     
        //////////console.log("1")     
    }
    else if(this.filers.fiscal_airportcode_origin.length==0&&this.filers.fiscal_airportcode_destination.length>0)
    {
      this.distinctlane=this.distinct_lane.filter(function(item:any){
        return ctx.check_destination_exitst(item.split("-")[1])>-1});          
        //////////console.log("2")     

    }
    else if(this.filers.fiscal_airportcode_destination.length>0&&this.filers.fiscal_airportcode_origin.length>0)
    {

    this.distinctlane=this.distinct_lane.filter(function(item:any){
      return ctx.check_origin_exitst(item.split("-")[0])>-1 && ctx.check_destination_exitst(item.split("-")[1])>-1});
      //////////console.log("3")     

    }
    else{

      this.distinctlane=this.distinct_lane;
      //////////console.log("4")     

    }

    //console.log(this.distinctlane)
    // this.selectedItems=[]
    this.distinctlane = this.distinctlane.sort((a:any, b:any) => a.localeCompare(b));

    this.selectedItems=this.distinctlane;


    this.filter_data();

}
//region mapping

fiscal_list:any=[]
lane_region:any=[]
today:any;
today_check:any;
startofweek:any;
endofweek:any;



 get_distincttheator(){
  this.filers.fiscal_theater_origin = this.lane_region
      .map((item:any) => item.THEATER_NAME)
      .filter(
          (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
      );
      //////console.(this.filers.fiscal_theater_origin);

}

getrigionbhytheater(theater:any,theaterd:any)
{
  //////////console.log(theater,theaterd)
  if(theater!='')
  {
    var list = this.lane_region.filter(function(item:any){return item.THEATER_NAME===theater } ) 
 
    this.filers.fiscal_region_origin = list
        .map((item:any) => item.REGION_NAME)
        .filter(
            (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
        );

  }
  else{
    this.filers.fiscal_region_origin = this.lane_region
        .map((item:any) => item.REGION_NAME)
        .filter(
            (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
        );
  }
  if(theaterd!='')
  {

      var list = this.lane_region.filter(function(item:any){return item.THEATER_NAME===theaterd } ) 
 
      this.filers.fiscal_region_destination= list
          .map((item:any) => item.REGION_NAME)
          .filter(
              (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
          );

        }
        else{

          var list = this.lane_region.filter(function(item:any){return item.THEATER_NAME===theaterd } ) 
 
          this.filers.fiscal_region_destination= this.lane_region
              .map((item:any) => item.REGION_NAME)
              .filter(
                  (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
              );
        }
       
      // this.getdistinctweek(fiscal_year,fiscal_quarter,this.filers.fiscalmonth[0]);
      this.getairpotbhytheater(this.filterselection.theater_origin,this.filterselection.theater_destination,this.filterselection.region_origin,this.filterselection.region_destination)
}

getairpotbhytheater(theater:any,theaterd:any,region:any,regiond:any){
  // //////////console.log(theater,theaterd,region,regiond)

  

    if(theater!=''&&region!='')
    {
    //  //////////console.log("1")
      var list = this.lane_region.filter(function(item:any){
        //////console.(item.THEATER_NAME,item.REGION_NAME)
        return item.THEATER_NAME===theater && item.REGION_NAME===region } ) 
        // //////////console.log(list)
      
      this.filers.fiscal_airportcode_origin = list
          .map((item:any) => item['Airport Code'])
          .filter(
              (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
          );      


    }
    else if(theater!=''&&region==''){
      // //////////console.log("2")
      var list = this.lane_region.filter(function(item:any){
        //////console.(item.THEATER_NAME,item.REGION_NAME)
        return item.THEATER_NAME===theater } ) 
      //////console.(list)
      // //////////console.log(list)


      this.filers.fiscal_airportcode_origin = list
          .map((item:any) => item['Airport Code'])
          .filter(
              (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
          );    
          // //////////console.log()

    }

    else if(theater==''&&region!=''){
      // //////////console.log("3")
      var list = this.lane_region.filter(function(item:any){
        //////console.(item.THEATER_NAME,item.REGION_NAME)
        return item.REGION_NAME===region} ) 
      //////console.(list)

      this.filers.fiscal_airportcode_origin = list
          .map((item:any) => item['Airport Code'])
          .filter(
              (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
          );    
    }
    else{
      // //////////console.log("4")
      this.filers.fiscal_airportcode_origin = this.lane_region
      .map((item:any) => item['Airport Code'])
      .filter(
          (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
      ); 
    }




    if(theaterd!=''&&regiond!='')
    {
      var list = this.lane_region.filter(function(item:any){return item.THEATER_NAME===theaterd && item.REGION_NAME===regiond } ) 
  
      this.filers.fiscal_airportcode_destination= list
          .map((item:any) => item['Airport Code'])
          .filter(
              (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
          );

    }
    else if(theaterd!=''&&regiond==''){
      var list = this.lane_region.filter(function(item:any){return item.THEATER_NAME===theaterd  } ) 
  
      this.filers.fiscal_airportcode_destination= list
          .map((item:any) => item['Airport Code'])
          .filter(
              (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
          );
    }
    else if(theaterd==''&&regiond!=''){
      var list = this.lane_region.filter(function(item:any){return  item.REGION_NAME===regiond } ) 
  
      this.filers.fiscal_airportcode_destination= list
          .map((item:any) => item['Airport Code'])
          .filter(
              (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
          );
    }
    else{
      this.filers.fiscal_airportcode_destination = this.lane_region
      .map((item:any) => item['Airport Code'])
      .filter(
          (value:any, index:any, current_value:any) => current_value.indexOf(value) === index
      ); 
    }
      

  
  this.getdisctinctlane();

  this.filter_retebook();
  
   
}
  
  // Service Provider,Quote Type , Program Name ,Service Level, 
  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'Lane',
      textField: 'Lane',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      itemsShowLimit:2
    };
  }


  groupByMultipleAndAverage_new = (data:any, groupKeys:any, avgKeys:any) => {
  return Object.values(
    data.reduce((acc:any, obj:any) => {
      // Create a composite key for grouping
      const key = groupKeys.map((k:any) => obj[k]).join('|');

      if (!acc[key]) {
        // Initialize accumulator entry
        acc[key] = {
          ...groupKeys.reduce((acc:any, k:any) => ({ ...acc, [k]: obj[k] }), {}),
          ...avgKeys.reduce((acc:any, k:any) => ({ ...acc, [k]: 0, [`${k}_count`]: 0 }), {})
        };
      }

      // Sum values and count only non-null entries
      avgKeys.forEach((k:any) => {
        const val = obj[k];
        if (val != null) {
          acc[key][k] += val;
          acc[key][`${k}_count`] += 1;
        }
      });

      return acc;
    }, {})
  ).map((item :any)=> {
    // Calculate average
    avgKeys.forEach((k:any )=> {
      const count = item[`${k}_count`];
      item[k] = count > 0 ? item[k] / count : null;
      delete item[`${k}_count`];
    });
    return item;
  });
};

  groupByMultipleAndWeightedAverage = (data:any, groupKeys:any, avgKeys:any) => {
    return Object.values(
      data.reduce((acc:any, obj:any) => {
        // Composite key for grouping
        const key = groupKeys.map((k:any) => obj[k]).join('|');
  
        const weight = obj.count ?? 1; // Default to 1 if count is missing
  
        if (!acc[key]) {
          acc[key] = {
            ...groupKeys.reduce((acc:any, k:any) => ({ ...acc, [k]: obj[k] }), {}),
            ...avgKeys.reduce((acc:any, k:any) => ({ ...acc, [k]: 0 }), {}),
            totalWeight: 0
          };
        }
  
        // Accumulate weighted sums
        avgKeys.forEach((k:any) => {
          acc[key][k] += obj[k] * weight;
        });
        acc[key].totalWeight += weight;
  
        return acc;
      }, {})
    ).map(it => {
      var item:any=it;
      // Compute final weighted averages
      avgKeys.forEach((k:any) => {
        item[k] = item.totalWeight === 0 ? null : item[k] / item.totalWeight;
      });
      delete item.totalWeight;
      return item;
    });
  };

  groupByMultipleAndWeightedAverage_new = (data:any, groupKeys:any, avgKeys:any) => {
  return Object.values(
    data.reduce((acc:any, obj:any) => {
      // Create a composite key for grouping
      const key = groupKeys.map((k:any )=> obj[k]).join('|');

      if (!acc[key]) {
        acc[key] = {
          ...groupKeys.reduce((a:any, k:any) => ({ ...a, [k]: obj[k] }), {}),
          ...avgKeys.reduce((a:any, k:any) => ({ ...a, [k]: 0, [`${k}_totalWeight`]: 0 }), {}),
        };
      }

      // Accumulate weighted sum per key using key-specific counts
      avgKeys.forEach((k:any) => {
        const countKey = `${k}_count`;
        const weight = obj[countKey] ?? 0;

        acc[key][k] += (obj[k] ?? 0) * weight;
        acc[key][`${k}_totalWeight`] += weight;
      });

      return acc;
    }, {})
  ).map((item:any) => {
    // Compute final weighted averages
    avgKeys.forEach((k:any) => {
      const totalWeight :any= item[`${k}_totalWeight`] ?? 0;
      item[k] = totalWeight === 0 ? null : item[k] / totalWeight;
      delete item[`${k}_totalWeight`]; // Clean up intermediate weight
    });
    return item;
  });
};

}
